import React, { Component } from "react";
import { Row, Col, Form, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container } from 'reactstrap';
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderSelectField, renderText, focusOnError } from "../layout/FormInputs";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { required, checkForNull, nextEvenNo } from "../../helper/validation";
import { Loader } from "../common/Loader";
import { HorizontalStiffiners, VerticalStiffiners } from './MasterData';
import { createShutterDesign, getShutterDesignData, updateShutterDesign } from "../../actions/DesignMaster";
import moment from 'moment';
import { onKeyPress } from "../../config/config";

const selector = formValueSelector('CIShutterDesign');

const stemDiaOption = [
    // { Text: '---Select---', Value: 0 },
    { Text: 24, Value: 24 },
    { Text: 30, Value: 30 },
    { Text: 35, Value: 35 },
    { Text: 40, Value: 40 },
    { Text: 45, Value: 45 },
    { Text: 50, Value: 50 },
    { Text: 55, Value: 55 },
    { Text: 60, Value: 60 },
    { Text: 65, Value: 65 },
    { Text: 70, Value: 70 },
    { Text: 75, Value: 75 },
    { Text: 80, Value: 80 },
    { Text: 90, Value: 90 },
    { Text: 100, Value: 100 },
    { Text: 110, Value: 110 },
    { Text: 120, Value: 120 },
    { Text: 130, Value: 130 },
    { Text: 140, Value: 140 },
    { Text: 150, Value: 150 },
    { Text: 160, Value: 160 },
]

const referenceDocsOption = [
    { Text: 'Reference Documents : AWWA C561 code of practice for Slide.', Value: 0 },
    { Text: 'Reference Documents : BS 7775 code of practice for Slide/Shutter/Plank.', Value: 1 },
    { Text: 'Reference Documents : IS 5620 code of practice for Slide/Shutter/Plank.', Value: 2 },
    { Text: 'Reference Documents : AWWA C562 code of practice for Slide.', Value: 3 },
]


const manufacturingMaterialOption = [
    { Text: 'CI FG-260', Value: 0 },
    { Text: 'CI CLASS B / CI FG-220', Value: 1 },
    { Text: 'CI FG-200', Value: 2 },
    { Text: 'CI WITH 2% NI', Value: 3 },
    { Text: 'DI ASTM A536 60-42-10', Value: 4 },
    { Text: 'DI ASTM A536 70-50-05', Value: 5 },
    { Text: 'NI RISIST-TYPE 1 -14-18', Value: 6 },
    { Text: 'NI RISIST-TYPE 2 -18-22', Value: 7 }
]

const horizontalStiffenerOption = [
    { Text: 'A', Value: 'A' },
    { Text: 'B', Value: 'B' },
    // { Text: 'C', Value: 'C' },
    // { Text: 'D', Value: 'D' },
    // { Text: 'E', Value: 'E' },
]
const horizontalRibOptions = [
    { Text: 'WITH STEM HOLE', Value: 'WITH STEM HOLE' },
    { Text: 'WITHOUT STEM HOLE', Value: 'WITHOUT STEM HOLE' }
]

const sharftSpindleOption = [
    { Text: 'SINGLE SPINDLE', Value: 'SINGLE_SPINDLE' },
    { Text: 'TANDEM SPINDLE', Value: 'TANDEM_SPINDLE' },
]

const ClosureOption = [
    { Text: 'FLUSH BOTTOM CLOSURE', Value: 'FLUSH BOTTOM CLOSURE' },
    { Text: 'CONVENTIONAL BOTTOM CLOSURE', Value: 'CONVENTIONAL BOTTOM CLOSURE' }
]

const factorOfSafety = [
    { Text: "STANDARD", Value: "STANDARD" },
    { Text: "CUSTOM", Value: "CUSTOM" }
];

let thicknessObjectSHV = {};

const horizontalRSDataCompare = [305, 458, 610, 762, 915, 1067, 1220, 1372, 1524, 1677, 1829, 2134, 2439, 2744, 3048, 3353, 3658, 3963]
const horizontalRSDataValue = [1, 1, 2, 2, 3, 3, 3, 4, 4, 4, 4, 5, 5, 6, 7, 8, 8, 8, 0]

const horizontalWidthDataCompareB = [200, 540, 600, 900, 1300, 1600, 1900, 2200, 2300, 2700]
const horizontalHeightDataCompareC = [450, 600, 900, 1300, 1600, 1900, 2200, 2300, 2700, 3000]
const horizontalHeightDataValueVert = [2, 3, 3, 4, 4, 5, 6, 7, 7, 8, 0]
const horizontalHeightDataValueHoriz = [2, 2, 3, 3, 3, 4, 5, 5, 6, 6, 0]

// Q431
const Q431Back = [24, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150, 155, 160]

const Q431BackValue = [45.00, 45.00, 45.00, 45.00, 55.00, 55.00, 70.00, 70.00, 70.00, 80.00, 80.00, 95.00, 95.00, 95.00, 108.00, 108.00, 123.00, 123.00, 123.00, 133.00, 133.00, 140.00, 145.00, 150.00, 155.00, 160.00, 165.00, 170.00]

//table 2 for section 3 
const table2Section3G328 = [305, 612, 1020, 1220, 1525]
const table2Section3G328Value = [1, 2, 3, 4, 5, 0]
//table 3 for section 3
const table3Section3G336 = [915, 1525, 2001, 5001]
const table3Section3G336Value = [75, 100, 125, 150, 0]

// table 4
const table4Section3G351 = [305.00, 612.00, 1221.00, 1830.00, 2450.00, 2651.00, 2751.00, 3251.00, 3501.00, 4101.00, 4401.00, 5001.00]
const table4Section3G351Value = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
//table 4 right side
const table4BW = [45.00, 45.00, 45.00, 50.00, 50.00, 60.00, 60.00, 60.00, 75.00, 75.00, 75.00, 75.00]
const table4WT = [15.00, 15.00, 25.00, 30.00, 30.00, 30.00, 30.00, 30.00, 40.00, 40.00, 40.00, 40.00]
const table4MC = [5.00, 6.00, 6.00, 10.00, 10.00, 10.00, 10.00, 10.00, 12.00, 12.00, 12.00, 12.00]

const table5BW = [90.50, 88.00, 90.50, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00, 105.00]
const table5WT = [12.70, 9.50, 9.50, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00, 19.00]
const table5MC = [5.00, 6.00, 6.00, 10.00, 10.00, 10.00, 10.00, 10.00, 12.00, 12.00, 12.00, 12.00]

const table6BW = [80.00, 80.00, 80.00, 80.00, 85.00, 85.00, 90.00, 90.00, 90.00, 90.00, 100.00, 110.00]
const table6WT = [50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 50.00, 60.00, 60.00]
const table6MC = [5.00, 6.00, 6.00, 10.00, 10.00, 10.00, 10.00, 10.00, 12.00, 12.00, 12.00, 12.00]

const weightOfSideWedgesCalc = [0.99, 1.99, 2.99, 3.99, 4.99, 5.99, 6.99, 7.99, 8.99, 9.99]
const weightOfSideWedgesCalcValue = [30, 50, 70, 90, 110, 130, 150, 170, 190, 210, 0]

let shearstressObj

class CIShutterDesign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoader: false,
            isSubmitted: false,
            stageOneOpen: true,
            stageTwoOpen: false,
            stageThreeOpen: false,
            startDate: '',
            shutterDesignId: '',
            referenceDocumentsObj: {
                BendingStress: 0.5,
                AxialStress: 0.5,
                ShearStress: 0.25,
            },
            manufacturingMaterialObj: {
                UTS: 410,
                YS: 250,
                FSS: 300,
            },
            selectedHorizontalStiff: 'A',
            horizontalStiffenersSectionObj: HorizontalStiffiners ? HorizontalStiffiners.A : {},
            selectedVerticalStiff: 'A',
            verticalStiffenersSectionObj: VerticalStiffiners ? VerticalStiffiners.A : {},
            selectedSpindle: 'SINGLE_SPINDLE',
            selectedApplicableStandard: '',
            currentSelectedReferenceDoc: '0',
            stressObject2: {
                BendingStress: 0,
                AxialStress: 0,
                ShearStress: 0
            },
            currentSelectedMaterial: 0,
            selectedStemMaterial: '205_SS 401',
            skinPlateThickness: 0,
            clPlValue: 0,
            selectedSeriesOffered: 'A-113',
            copyCosting: '',
            isPostOrder: false,
            activeActuation: '',
            modal: false,
            identifier: {},
            isPostOrderCreated: false,
            thrustOnOptions: [],
            frameExtensionOption: [],
            frameExtension: '',
            factorOfSafetyDD: '',
            frameLengthOption: [
                { Text: 'SHORT LENGTH', Value: 'SHORT LENGTH' },
                { Text: 'FULL LENGTH', Value: 'FULL LENGTH' }],
            selectHorizontalRib: 'WITH STEM HOLE',
            horizontalSniffersSelect: '',
            thicknessSHVObject: {},
            diagonalWH: 0,
            FOSValueStandard: 5,
            CastIronSafeCheck: false
        };
    }


    componentDidMount() {

        // this.props.change("HRb1", 0)
        // this.props.change("HRt1", 0)
        // this.props.change("HRt3", 0)
        // this.props.change("HRd", 0)
        // this.props.change('HRd1', 0)
        // this.props.change('HRD', 0)
        // this.props.change("VRb1", 0)
        // this.props.change("VRt1", 0)
        // this.props.change("VRt3", 0)
        // this.props.change("VRd", 0)
        // this.props.change("VRd1", 0)
        // this.props.change('VRD', 0)
        // this.props.change("shaftSpindle", 'SINGLE_SPINDLE')
        // this.props.change("SpindleDirection", 'RISING')
    }

    componentDidUpdate(prevProps) {
        const { CastIronSafeCheck } = this.state
        if (this.props.fieldObj !== prevProps.fieldObj) {

            const tempForShutterThickness = this.calculationForCI()

            const { seatingHeadTensileStress, seatingHeadCompressiveStress, unseatingHeadTensileStress,
                unseatingHeadCompressiveStress, beamDeflectionMaxHead, actualDefLesser, seatingHeadTensileStressTable2,
                seatingHeadCompressiveStressTable2,
                unseatingHeadCompressiveStressTable2, unseatingHeadTensileStressTable2, beamDeflectionMaxHeadTable2, actualDefLesserTabl2,
                seatingHeadTensileStress_5,
                seatingHeadCompressiveStress_5, unseatingHeadCompressiveStress_5, unseatingHeadTensileStress_5, beamDeflectionMaxHead_5,
                actualDefLesser_5 } = tempForShutterThickness

            if (
                (seatingHeadTensileStress > this.tensileStressCalc()) ||

                (seatingHeadCompressiveStress > this.compressiveStressCalc()) ||

                (unseatingHeadCompressiveStress > this.tensileStressCalc()) ||

                (unseatingHeadTensileStress > this.compressiveStressCalc()) ||

                (beamDeflectionMaxHead > actualDefLesser) ||

                (seatingHeadTensileStressTable2 > this.tensileStressCalc()) ||

                (seatingHeadCompressiveStressTable2 > this.compressiveStressCalc()) ||

                (unseatingHeadCompressiveStressTable2 > this.tensileStressCalc()) ||

                (unseatingHeadTensileStressTable2 > this.compressiveStressCalc()) ||

                (beamDeflectionMaxHeadTable2 > actualDefLesserTabl2) ||

                (checkForNull(seatingHeadTensileStress_5) > this.tensileStressCalc()) ||

                (checkForNull(seatingHeadCompressiveStress_5) > this.compressiveStressCalc()) ||

                (checkForNull(unseatingHeadCompressiveStress_5) > this.tensileStressCalc()) ||

                (checkForNull(unseatingHeadTensileStress_5) > this.compressiveStressCalc()) ||

                (checkForNull(beamDeflectionMaxHead_5) > checkForNull(actualDefLesser_5))

            ) {
                this.setState({ CastIronSafeCheck: false })
            } else {
                this.setState({ CastIronSafeCheck: true })
            }

            this.props.fieldObj.TypicalVerticalRIBShutterThicknessForA = tempForShutterThickness.shutterThicknessSection5
            this.props.fieldObj.CastIronSafeCheck = CastIronSafeCheck
            this.props.cisData(this.props.fieldObj)
        }
    }

    /**
    * @method handleReferenceDocsChild
    * @description Handle reference documents
    */
    handleReferenceDocsChild = (data) => {

        //const value = e.target.value;
        let tempObj = {};
        const value = Number(data)
        if (value === 0) {

            tempObj = {
                BendingStress: 0.25,
                AxialStress: 0.25,
                ShearStress: 0.25,
            }
        } else if (value === 1) {

            tempObj = {
                BendingStress: 0.75,
                AxialStress: 0.75,
                ShearStress: 0.3,
            }
        } else if (value === 2) {

            tempObj = {
                BendingStress: 0.4,
                AxialStress: 0.4,
                ShearStress: 0.3,
            }
        } else if (value === 3) {

            tempObj = {
                BendingStress: 0.2,
                AxialStress: 0.2,
                ShearStress: 0.2,
            }
        } else if (!value) {

            tempObj = {
                BendingStress: 0,
                AxialStress: 0,
                ShearStress: 0,
            }
        }

        this.setState({ referenceDocumentsObj: tempObj, currentSelectedReferenceDoc: value !== null ? (value).toString() : null })
    }

    /**
   * @method handleManufacturingMaterial
   * @description Handle reference documents
   */
    handleManufacturingMaterialChild = (data) => {
        const { referenceDocumentsObj, currentSelectedReferenceDoc } = this.state;
        let tempObj = {};

        const value = Number(data)
        const X27 = () => {
            switch (currentSelectedReferenceDoc) {
                case '0':
                    return 0.25
                case '1':
                    return 0.75
                case '2':
                    return 0.40
                case '3':
                    return 0.20
                default:
                    return 0
            }
        }
        const X28 = () => {
            switch (currentSelectedReferenceDoc) {
                case '0':
                    return 0.5
                case '1':
                    return 0.75
                case '2':
                    return 0.40
                case '3':
                    return 0.40
                default:
                    return 0
            }
        };

        const Y29 = (Y27, Y28) => Math.min(Y27, Y28);
        const X29 = (y27, y28) => (Y29(y27, y28) === y27) ? X27() : X28();
        const Y30 = (y27, y28, val1, val2) => (Y29(y27, y28) === y27) ? val1 : val2;

        if (value === 0) {
            tempObj = {
                UTS: 260,
                E: 99974,
                CS: 910,
            }
        } else if (value === 1) {
            tempObj = {
                UTS: 220,
                E: 99974,
                CS: 770,
            }
        }
        else if (value === 2) {
            tempObj = {
                UTS: 200,
                E: 99974,
                CS: 700,
            }

        } else if (value === 3) {
            tempObj = {
                UTS: 220,
                E: 99974,
                CS: 770,
            }

        } else if (value === 4) {
            tempObj = {
                UTS: 415,
                E: 172000,
                CS: 1453,
            }

        }
        else if (value === 5) {
            tempObj = {
                UTS: 485,
                E: 172000,
                CS: 1698,
            }
        } else if (value === 6) {
            tempObj = {
                UTS: 172,
                E: 85000,
                CS: 700,
            }
        } else if (value === 7) {
            tempObj = {
                UTS: 172,
                E: 85000,
                CS: 700,
            }
        } else if (!value) {
            tempObj = {
                UTS: 410,
                E: 250,
                CS: 300,
            }
        }

        const stressObj = {
            BendingStress: X29(tempObj.UTS * X27(), tempObj.YS * X28()),
            AxialStress: X29(tempObj.UTS * X27(), tempObj.YS * X28()),
            ShearStress: referenceDocumentsObj.ShearStress
        }


        const stressObject2 = {
            AllowableStress: this.state.factorOfSafetyDD === 'CUSTOM' ? Number(tempObj.TS) / Number(this.props.fieldObj.FOSValue) : Number(tempObj.TS) / 5,
            AxialStress: Y30(tempObj.UTS * X27(), tempObj.YS * X28(), tempObj.UTS, tempObj.YS) * X29(tempObj.UTS * X27(), tempObj.YS * X28()),
            ShearStress: referenceDocumentsObj.ShearStress * tempObj.FSS
        }


        this.setState({
            manufacturingMaterialObj: tempObj,
            referenceDocumentsObj: stressObj,
            stressObject2,
            currentSelectedMaterial: value
        })
    }

    setThrustOnOptionsArray = (frameLength) => {
        if (frameLength === 'SHORT LENGTH') {
            this.setState({
                thrustOnOptions: [{ Text: 'OP. PLATFORM', Value: 'OP. PLATFORM' }]
            })
        } else {
            this.setState({
                thrustOnOptions: [
                    { Text: 'OP. PLATFORM', Value: 'OP. PLATFORM' },
                    { Text: 'FRAME', Value: 'FRAME' },
                    { Text: 'FRAME VIA THRUST TUBE', Value: 'FRAME VIA THRUST TUBE' },
                ]
            })
        }
    }

    setFrameExtensionArray = (frameExtension) => {

        if (frameExtension === 'A-211 / 212 / 213' || frameExtension === 'A-221 / 222 / 223'
            || frameExtension === 'A-201-202-203 CAST IRON OPEN CHANNEL'
        ) {
            this.setState({
                frameExtensionOption: [
                    { Text: 'SELF CONTAINED', Value: 'SELF CONTAINED' },
                    { Text: 'SELF CONTAINED FRAME WITH EXT LENGTH', Value: 'SELF CONTAINED FRAME WITH EXT LENGTH' },
                    { Text: 'CLOSED TOP FRAME WITH EXT STEM LENGTH', Value: 'CLOSED TOP FRAME WITH EXT STEM LENGTH' }
                ]
            })
        } else {
            this.setState({
                frameExtensionOption: [
                    { Text: 'NOT REQUIRED', Value: 'NOT REQUIRED' },
                    { Text: 'REQUIRED', Value: 'REQUIRED' }
                ]
            })
        }
    }

    setFramelength = (value) => {

        if (value === 'A-211 / 212 / 213' || value === 'A-221 / 222 / 223' ||
            value === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            this.setState({
                frameLengthOption: [
                    { Text: 'FULL LENGTH', Value: 'FULL LENGTH' }
                ]
            })
        }
        else {
            this.setState({
                frameLengthOption: [
                    { Text: 'SHORT LENGTH', Value: 'SHORT LENGTH' },
                    { Text: 'FULL LENGTH', Value: 'FULL LENGTH' }
                ]
            })
        }
    }

    componentDidMount = () => {
        const { isEditFlag, ShutterId, isViewFlag } = this.props;
        this.props.change('horizontalStiffenersSection5', 'A')
        this.props.change('FOSValueStan', 5)

        this.setState({ isLoader: true })
        if (!isEditFlag) {
            this.props.change('horizontalStiffenersSection', 'A')
            this.setState({ horizontalSniffersSelect: 'A' })
            this.props.change('factorOfSafetyDD', 'STANDARD')
            this.props.change('selectHorizontalRib', 'WITH STEM HOLE')
        }
        if (isEditFlag || isViewFlag || ShutterId) {
            // this.props.getShutterDesignData(ShutterId, (res) => {
            // if (res && res.data && res.data.Data) {
            // let Data = res.data.Data;
            let Data = this.props.shutterDataCI
            let shaftSpindle = '';
            if (String(sharftSpindleOption && sharftSpindleOption[0].Text) === String(Data.SelectedSpindleType)) {
                shaftSpindle = sharftSpindleOption[0].Value;
            } else if (String(sharftSpindleOption && sharftSpindleOption[1].Text) === String(Data.SelectedSpindleType)) {
                shaftSpindle = sharftSpindleOption[1].Value;
            }
            let ClosureType = '';
            if (String(ClosureOption && ClosureOption[0].Text) === String(Data.SelectedClosureType)) {
                ClosureType = ClosureOption[0].Value;
            } else if (String(ClosureOption && ClosureOption[1].Text) === String(Data.SelectedClosureType)) {
                ClosureType = ClosureOption[1].Value;
            }
            let referenceDocuments = '';
            if (String(referenceDocsOption && referenceDocsOption[0].Text) === String(Data.SelectedReferenceDocument)) {
                referenceDocuments = referenceDocsOption[0].Value;
            } else if (String(referenceDocsOption && referenceDocsOption[1].Text) === String(Data.SelectedReferenceDocument)) {
                referenceDocuments = referenceDocsOption[1].Value;
            } else if (String(referenceDocsOption && referenceDocsOption[2].Text) === String(Data.SelectedReferenceDocument)) {
                referenceDocuments = referenceDocsOption[2].Value;
            } else if (String(referenceDocsOption && referenceDocsOption[3].Text) === String(Data.SelectedReferenceDocument)) {
                referenceDocuments = referenceDocsOption[3].Value;
            }
            let manufacturingMaterial = '';
            if (String(manufacturingMaterialOption && manufacturingMaterialOption[0].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[0].Value;
            } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[1].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[1].Value;
            } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[2].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[2].Value;
            } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[3].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[3].Value;
            } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[4].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[4].Value;
            } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[5].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[5].Value;
            } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[6].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[6].Value;
            } else if (String(manufacturingMaterialOption && manufacturingMaterialOption[7].Text) === String(Data.SelectedMaterialType)) {
                manufacturingMaterial = manufacturingMaterialOption[7].Value;
            }

            this.handleReferenceDocsChild(referenceDocuments);
            this.handleManufacturingMaterialChild(manufacturingMaterial);
            this.setState({
                selectedHorizontalStiff: Data.SelectedHorizontalStiffnerSection,
                selectedVerticalStiff: Data.SelectedVerticalStiffnerSection,
                selectedSeriesOffered: Data.SelectedSeriesOffered,
                activeActuation: Data.SelectedActuation,
                stageTwoOpen: true,
                stageThreeOpen: true,
                isLoader: false,
                identifier: {
                    item_number: Data.ItemNumber,
                    pid_number: Data.PIDNumber,
                    quote_number: Data.QuoteNumber
                },
                isPostOrderCreated: Data.IsPostCreated,
                currentSelectedReferenceDoc: referenceDocuments,
                currentSelectedMaterial: manufacturingMaterial,
                selectedStemMaterial: Data.SelectedStemMaterial,
                selectedSpindle: shaftSpindle,
                frameExtension: Data.SelectedFrameExtension, //API change
                factorOfSafetyDD: Data.SelectedFactorOfSafety, // API change
            });

            this.setFrameExtensionArray(this.state.selectedSeriesOffered)

            this.setThrustOnOptionsArray(Data.SelectedFrameLengthType)
            this.props.change('date', moment(Data.Dated))
            this.props.change('selectedThrustOn', Data.SelectedThrustOn)
            this.props.change('referenceDocuments', referenceDocuments)
            this.props.change('ItemNumber', Data.ItemNumber)
            this.props.change('pid_number', Data.PIDNumber)
            this.props.change('quote_number', Data.QuoteNumber)
            this.props.change('client', Data.Client)
            this.props.change('project', Data.Project)
            this.props.change('location', Data.Location)
            this.props.change('tag_number', Data.TagNumber)
            this.props.change('rev_number', Data.RevisionNumber)
            if (Data.RevisionDate) {
                this.props.change('rev_date', moment(Data.RevisionDate))
            }
            this.props.change('applicableStandard', Data.SelectedApplicableStandard)
            this.props.change('stemMaterial', Data.SelectedStemMaterial)
            this.props.change('height', Data.SizeHeight)
            this.props.change('width', Data.SizeWidth)
            this.props.change('seatingHead', Data.SeatingHead)
            this.props.change('unseatingHead', Data.UnseatingHead)
            this.props.change('cl_pl', Data.ClPl)
            this.props.change('stemDiaField', Data.SelectedStemDiameter)
            this.props.change('shaftSpindle', shaftSpindle)
            this.props.change('SpindleDirection', Data.SelectedSpindleDirection)
            this.props.change('SelectedSeriesOffered', Data.SelectedSeriesOffered)
            this.props.change('Actuation', Data.SelectedActuation)
            this.props.change('ClosureType', ClosureType)
            this.props.change('SelectedFrameLengthType', Data.SelectedFrameLengthType)
            this.props.change('manufacturingMaterial', manufacturingMaterial)
            this.props.change('frameMounting', Data.SelectedFrameMounting)
            this.props.change('verticalStiffeners', Data.NoOfVerticalStiffeners)
            this.props.change('horizontalStiffeners', Data.NoOfHorizontalStiffeners)
            this.props.change('skinPlateThickness', Data.SkinPlateThickness)
            // this.props.change('horizontalStiffenersSection', Data.SelectedHorizontalStiffnerSection)
            this.props.change('HRb1', Data.HorizontalStiffenerb1)
            this.props.change('HRt1', Data.HorizontalStiffenert1)
            this.props.change('HRt3', Data.HorizontalStiffenert3)
            this.props.change('HRd', Data.HorizontalStiffenerInnerd)
            //this.props.change('HRd1', Data.HRd1)
            //this.props.change('HRD', Data.HRD)
            this.props.change('horizontalDeflection', Data.HorizontalL)
            this.props.change('verticalStiffenersSection', Data.SelectedVerticalStiffnerSection)
            this.props.change('VRb1', Data.VerticalStiffenerb1)
            this.props.change('VRt1', Data.VerticalStiffenert1)
            this.props.change('VRt3', Data.VerticalStiffenert3)
            this.props.change('VRd', Data.VerticalStiffenerInnerd)
            //this.props.change("VRd1", Data.VRd1)
            //this.props.change("VRD", Data.VRD)
            this.props.change('verticalDeflection', Data.VerticalL)
            this.props.change('FL', Data.FrameLength)
            this.props.change('FOS1', Data.FOSOne)
            this.props.change('FOS2', Data.FOSTwo)
            this.props.change('FOS3', Data.FOSThree)
            this.props.change('SelectedFrameExtension', Data.SelectedFrameExtension)
            this.props.change('factorOfSafetyDD', Data.SelectedFactorOfSafety)

            this.props.change('FOSValue', Data.CustomFactorOfSafetyValue)
            this.props.change('selectHorizontalRib', Data.SelectTypicalHorizontalRIB)
            this.props.change('horizontalStiffenersSection', Data.SelectedHorizontalStiffnerSection)
            this.props.change('hs1', Data.TypicalHorizontalRIBThicknessOneForA)
            this.props.change('hs2', Data.TypicalHorizontalRIBThicknessTwoForA)
            this.props.change('hs3', Data.TypicalHorizontalRIBHeightForA)
            this.props.change('hs4', Data.TypicalHorizontalRIBShutterThicknessForA)
            this.props.change('hs5', Data.TypicalHorizontalRIBNoOfHorzRIBSSpacingForA)
            this.props.change('hs6', Data.TypicalHorizontalRIBWidthOfFlangeForB)
            this.props.change('hs7', Data.TypicalHorizontalRIBThicknessForFlangeForB)
            this.props.change('hs8', Data.TypicalHorizontalRIBThicknessForWebForB)
            this.props.change('hs9', Data.TypicalHorizontalRIBShutterThicknessForB)
            this.props.change('hs10', Data.TypicalHorizontalRIBHeightWebForB)
            this.props.change('hs11', Data.TypicalHorizontalRIBNoOfHorzRIBSSpacingForB)
            this.props.change('hs12', Data.TypicalVerticalRIBThicknessOneForA)
            this.props.change('hs13', Data.TypicalVerticalRIBThicknessTwoForA)
            this.props.change('hs14', Data.TypicalVerticalRIBHeightForA)
            this.props.change('hs15', Data.TypicalVerticalRIBNoOfHorzRIBSSpacingForA)
            // this.props.change('horizontalStiffenersSection', Data.SelectedVerticalStiffnerSection)

            this.setState({
                horizontalSniffersSelect: Data.SelectedHorizontalStiffnerSection,
                selectHorizontalRib: Data.SelectTypicalHorizontalRIB,
            })
            this.props.ActuationToggler(Data.SelectedActuation)
            setTimeout(() => {
                this.handleReferenceDocsChild(referenceDocuments)
                this.handleManufacturingMaterialChild(manufacturingMaterial)
                this.calculationHandler();
            }, 100)
            this.setFramelength(Data.SelectedSeriesOffered);
            // }
            // })
        } else {
            let referenceDocuments = referenceDocsOption[0].Value;
            let manufacturingMaterial = manufacturingMaterialOption[0].Value;
            this.handleReferenceDocsChild(referenceDocuments);
            this.handleManufacturingMaterialChild(manufacturingMaterial);
            // this.props.change('date', data.date)
            // this.props.change('selectedThrustOn', data.selectedThrustOn)
            // this.props.change('applicableStandard', data.applicableStandard)
            // this.props.change('stemMaterial', data.stemMaterial)
            // this.props.change('ItemNumber', data.ItemNumber)
            // this.props.change('pid_number', data.pid_number)
            // this.props.change('quote_number', data.quote_number)
            // this.props.change('client', data.client)
            // this.props.change('project', data.project)
            // this.props.change('location', data.location)
            // this.props.change('tag_number', data.tag_number)
            // this.props.change('rev_number', data.rev_number)
            // this.props.change('rev_date', data.rev_date)
            // this.props.change('height', data.height)
            // this.props.change('width', data.width)
            // this.props.change('seatingHead', data.seatingHead)
            // this.props.change('unseatingHead', data.unseatingHead)
            // this.props.change('stemDia', data.stemDia)
            // this.props.change('cl_pl', data.cl_pl)
            // this.props.change('shaftSpindle', data.shaftSpindle)
            // this.props.change('SpindleDirection', data.SpindleDirection)
            // this.props.change('frameMounting', data.frameMounting)
            // this.props.change('ClosureType', data.ClosureType)
            // this.props.change('Actuation', data.Actuation)
            // this.props.change('SelectedSeriesOffered', data.SelectedSeriesOffered)
            // this.props.change('SelectedFrameLengthType', data.SelectedFrameLengthType)
            // this.props.change('HRb1', data.HRb1)
            // this.props.change('HRd', data.HRd)
            // this.props.change('HRt1', data.HRt1)
            // this.props.change('HRt3', data.HRt3)
            // this.props.change('HRb1', data.HRb1)
            // this.props.change('HRd1', data.HRd1)
            // this.props.change('HRD', data.HRD)
            // this.props.change('VRb1', data.VRb1)
            // this.props.change('VRt1', data.VRt1)
            // this.props.change("VRd1", data.VRd1)
            // this.props.change("VRD", data.VRD)
            // this.props.change('VRt3', data.VRt3)
            // this.props.change('VRd', data.VRd)
            // // this.props.change('referenceDocuments', '')
            // // this.props.change('manufacturingMaterial', data.manufacturingMaterial)
            // this.props.change('horizontalStiffenersSection', data.horizontalStiffenersSection)
            // this.props.change('verticalStiffenersSection', data.verticalStiffenersSection)
            // this.props.change('horizontalStiffeners', data.horizontalStiffeners)
            // this.props.change('verticalStiffeners', data.verticalStiffeners)
            // this.props.change('skinPlateThickness', data.skinPlateThickness)
            // this.props.change('horizontalDeflection', data.horizontalDeflection)
            // this.props.change('verticalDeflection', data.verticalDeflection)
            // this.props.change('FL', data.FrameLength)
            // this.props.change('FOS1', data.FOSOne)
            // this.props.change('FOS2', data.FOSTwo)
            // this.props.change('FOS3', data.FOSThree)
            // this.props.change('factorOfSafetyDD', data.SelectedFactorOfSafety)
            // this.setState({
            //     selectedSeriesOffered: data.SelectedSeriesOffered,
            //     isLoader: false,
            //     currentSelectedReferenceDoc: '',
            //     currentSelectedMaterial: '',
            //     selectedSpindle: data.SpindleDirection
            // })

            setTimeout(() => {
                this.handleReferenceDocsChild(null)
                this.handleManufacturingMaterialChild(null)
                this.calculationHandler();
                this.setState({ isLoader: false })
            }, 100)
        }
    }

    componentWillUnmount = () => {
        // this.props.setData(fieldObj);
        // this.props.setShutterDesignData({
        //     ...this.props.shutterDesignData,
        //     UTS: this.state.manufacturingMaterialObj.UTS,
        //     shutterDesignId: this.state.shutterDesignId,
        //     selectedSpindle: this.state.selectedSpindle,
        //     setApplicableStandard: this.state.selectedApplicableStandard,
        //     stemMaterial: this.state.selectedStemMaterial,
        // });

    }

    calculationHandler = () => {
        setTimeout(() => {
            this.calculate()
        }, 100)
    }

    calculate = () => {

        const { selectedHorizontalStiff, selectedVerticalStiff } = this.state;
        let t1 = checkForNull(this.returnFieldInteger('HRt1'));
        let t2 = checkForNull(this.returnFieldInteger('skinPlateThickness'));
        let d = checkForNull(this.returnFieldInteger('HRd'));
        let d1 = checkForNull(this.returnFieldInteger('HRd1'));

        if (selectedHorizontalStiff === 'A') {
            this.props.change('HRd1', d - t1)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'B') {
            this.props.change('HRd1', d)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'C') {
            this.props.change('HRd1', d - 2 * t1)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'D') {
            this.props.change('HRd1', d - 2 * t1)
            this.props.change('HRD', t2 + d)
        } else if (selectedHorizontalStiff === 'E') {

            this.props.change('HRd1', d - t1)
            this.props.change('HRD', d1 + t1 + t2)
        }

        let Vt1 = this.returnFieldInteger('VRt1');
        let Vd = this.returnFieldInteger('VRd');
        let Vd1 = this.returnFieldInteger('VRd1');

        if (selectedVerticalStiff === 'A') {
            this.props.change('VRd1', Vd - Vt1)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'B') {
            this.props.change('VRd1', Vd)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'C') {
            this.props.change('VRd1', Vd - 2 * Vt1)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'D') {
            this.props.change('VRd1', Vd - 2 * Vt1)
            this.props.change('VRD', t2 + Vd)
        } else if (selectedVerticalStiff === 'E') {
            this.props.change('VRd1', Vd - Vt1)
            this.props.change('VRD', Vd1 + Vt1 + t2)
        }
    }

    returnFieldInteger = (fieldName) => {
        const { fieldObjShutter } = this.props;

        switch (fieldName) {
            case 'HRb1':
                return fieldObjShutter && fieldObjShutter.HRb1 ? Number(fieldObjShutter.HRb1) : 0;
            case 'HRd':
                return fieldObjShutter && fieldObjShutter.HRd ? Number(fieldObjShutter.HRd) : 0;
            case 'HRd1':
                return fieldObjShutter && fieldObjShutter.HRd1 ? Number(fieldObjShutter.HRd1) : 0;
            case 'HRD':
                return fieldObjShutter && fieldObjShutter.HRD ? Number(fieldObjShutter.HRD) : 0;
            case 'HRt1':
                return fieldObjShutter && fieldObjShutter.HRt1 ? Number(fieldObjShutter.HRt1) : 0;
            case 'HRt3':
                return fieldObjShutter && fieldObjShutter.HRt3 ? Number(fieldObjShutter.HRt3) : 0;
            case 'VRb1':
                return fieldObjShutter && fieldObjShutter.VRb1 ? Number(fieldObjShutter.VRb1) : 0;
            case 'VRd':
                return fieldObjShutter && fieldObjShutter.VRd ? Number(fieldObjShutter.VRd) : 0;
            case 'VRd1':
                return fieldObjShutter && fieldObjShutter.VRd1 ? Number(fieldObjShutter.VRd1) : 0;
            case 'VRD':
                return fieldObjShutter && fieldObjShutter.VRD ? Number(fieldObjShutter.VRD) : 0;
            case 'VRt1':
                return fieldObjShutter && fieldObjShutter.VRt1 ? Number(fieldObjShutter.VRt1) : 0;
            case 'VRt3':
                return fieldObjShutter && fieldObjShutter.VRt3 ? Number(fieldObjShutter.VRt3) : 0;
            case 'height':
                return fieldObjShutter && fieldObjShutter.height ? Number(fieldObjShutter.height) : 0;
            case 'horizontalDeflection':
                return fieldObjShutter && fieldObjShutter.horizontalDeflection ? Number(fieldObjShutter.horizontalDeflection) : 0;
            case 'horizontalStiffeners':
                return fieldObjShutter && fieldObjShutter.horizontalStiffeners ? Number(fieldObjShutter.horizontalStiffeners) : 0;
            case 'horizontalStiffenersSection':
                return fieldObjShutter && fieldObjShutter.horizontalStiffenersSection ? Number(fieldObjShutter.horizontalStiffenersSection) : 0;
            case 'seatingHead':
                return fieldObjShutter && fieldObjShutter.seatingHead ? Number(fieldObjShutter.seatingHead) : 0;
            case 'skinPlateThickness':
                return fieldObjShutter && fieldObjShutter.skinPlateThickness ? Number(fieldObjShutter.skinPlateThickness) : 0;
            case 'unseatingHead':
                return fieldObjShutter && fieldObjShutter.unseatingHead ? Number(fieldObjShutter.unseatingHead) : 0;
            case 'verticalDeflection':
                return fieldObjShutter && fieldObjShutter.verticalDeflection ? Number(fieldObjShutter.verticalDeflection) : 0;
            case 'verticalStiffeners':
                return fieldObjShutter && fieldObjShutter.verticalStiffeners ? Number(fieldObjShutter.verticalStiffeners) : 0;
            case 'width':
                return fieldObjShutter && fieldObjShutter.width ? Number(fieldObjShutter.width) : 0;
            default:
                break;
        }
    }

    /**
    * @method stageOneController
    * @description Hide and Show stage one 
    */
    stageOneController = () => {
        this.setState({
            stageOneOpen: !this.state.stageOneOpen
        })
    }

    /**
    * @method stageTwoController
    * @description Hide and Show stage two 
    */
    stageTwoController = () => {
        this.setState({
            stageTwoOpen: !this.state.stageTwoOpen
        })
    }

    /**
    * @method stageThreeController
    * @description Hide and Show stage three 
    */
    stageThreeController = () => {
        this.setState({
            stageThreeOpen: !this.state.stageThreeOpen
        })
    }

    /**
    * @method handleStemDia
    * @description Hide and Show stage three 
    */
    handleStemDia = (e) => {
    }

    /**
    * @method handleFrameLength
    * @description 
    */
    handleFrameLength = (e) => {
        const value = e.target.value;
        this.setThrustOnOptionsArray(value)
    }

    /**
    * @method handleFrameExtension
    * @description 
    */
    handleFrameExtension = (e) => {
        const value = e.target.value;
        this.setState({ frameExtension: value })
    }

    /**
    * @method nextStepTwo
    * @description Move to step 2 
    */
    nextStepTwo = () => {
        this.setState({
            stageTwoOpen: !this.state.stageTwoOpen
        })
    }

    /**
    * @method handleDate
    * @description Handle date
    */
    handleDate = (date) => {
        this.setState({
            startDate: date,
        });
    };

    /**
    * @method seatingWaterCalculation
    * @description Calculate seating water head 
    */
    seatingWaterCalculation = () => {
        return (this.returnFieldInteger('seatingHead') * 1000) + (this.returnFieldInteger('height') / 2)
    };

    /**
    * @method unseatingWaterCalculation
    * @description Calculate unseating water head
    */
    unseatingWaterCalculation = () => {
        return (this.returnFieldInteger('unseatingHead') * 1000) + (this.returnFieldInteger('height') / 2)
    };

    seatingHeadCalculation = () => {
        const { fieldObjShutter } = this.props;
        return (fieldObjShutter.seatingHead * 1000)
    };

    unseatingHeadCalculation = () => {
        return (this.seatingHeadCalculation() + this.returnFieldInteger('height') / 2)
    };

    /**
    * @method returnMaxNumber
    * @description Return max number
    */
    returnMaxNumber = () => {
        const seatingHead = this.returnFieldInteger('seatingHead') * 1000 + (this.returnFieldInteger('height') / 2)
        const unseatingHead = (this.returnFieldInteger('unseatingHead') * 1000) + (this.returnFieldInteger('height') / 2)

        if (seatingHead > unseatingHead) {
            return seatingHead;
        } else if (unseatingHead > seatingHead) {
            return unseatingHead;
        } if (Number(unseatingHead) === Number(seatingHead)) {
            return seatingHead;
        }

    };

    handleReferenceDocs = (e) => {
        const value = e.target.value;
        this.handleReferenceDocsChild(value)
    }

    handleManufacturingMaterial = (e) => {
        const value = e.target.value;
        this.handleManufacturingMaterialChild(value)
    }


    /**
    * @method bayWidthVerticalStif
    * @description Calculate bay width of vertical stiffeners
    */
    bayWidthVerticalStif = () => {
        const { fieldObj } = this.props;
        return (fieldObj && fieldObj.verticalStiffeners) ? checkForNull((this.returnFieldInteger('width') / (this.returnFieldInteger('verticalStiffeners') - 1))) : 0
    };

    /**
    * @method bayWidthHorizontalStif
    * @description Calculate bay width of horizontal stiffeners
    */
    bayWidthHorizontalStif = () => {
        const { fieldObj } = this.props;
        return (fieldObj && fieldObj.horizontalStiffeners) ? checkForNull((this.returnFieldInteger('height') / (this.returnFieldInteger('horizontalStiffeners') - 1))) : 0
    };

    /**
    * @method maxPressureCenterSkinPlate
    * @description Calculate max Pressure Center Skin Plate
    */
    maxPressureCenterSkinPlate = () => {
        const { fieldObj } = this.props;
        return (((1010 * 9.81) * (fieldObj && fieldObj.seatingHead ? `${this.returnMaxNumber() / 1000}` : 0)) / 1000000)
    };

    /**
    * @method returnMaxStiffeners
    * @description Calculate return Max Stiffeners
    */
    returnMaxStiffeners = () => {
        const { fieldObj } = this.props;
        const verticalStiff = (fieldObj && fieldObj.verticalStiffeners) ? checkForNull((this.returnFieldInteger('width') / (this.returnFieldInteger('verticalStiffeners') - 1))) : 0;
        const horizontalStiff = (fieldObj && fieldObj.horizontalStiffeners) ? checkForNull((this.returnFieldInteger('height') / (this.returnFieldInteger('horizontalStiffeners') - 1))) : 0;

        if (verticalStiff < horizontalStiff) {
            return checkForNull((horizontalStiff / verticalStiff));
        } else {
            return checkForNull((verticalStiff / horizontalStiff));
        }

    };

    /**fieldObj
    * @method nonDimensionalFactor
    * @description Calculate non Dimensional Factor
    */
    nonDimensionalFactor = () => {
        const maxStiffener = this.returnMaxStiffeners();

        if (maxStiffener <= 1) {
            return 30.9;
        } else if (maxStiffener <= 1.25) {
            return 40.3;
        } else if (maxStiffener <= 1.5) {
            return 45.5;
        } else if (maxStiffener <= 1.75) {
            return 48.4;
        } else if (maxStiffener <= 2) {
            return 49.9;
        } else if (maxStiffener <= 2.5) {
            return 50;
        } else {
            return 50;
        }

    };

    /**
    * @method calculateSkinPlateBendingStress
    * @description Calculate Skin Plate Bending Stress
    */
    calculateSkinPlateBendingStress = () => {
        const { fieldObj } = this.props;
        const nonDimensionalFactor = this.nonDimensionalFactor();
        const maxPressureSkinPlate = this.maxPressureCenterSkinPlate();

        const verticalStiff = (fieldObj && fieldObj.verticalStiffeners) ? checkForNull((this.returnFieldInteger('width') / (this.returnFieldInteger('verticalStiffeners') - 1))) : 0;
        const horizontalStiff = (fieldObj && fieldObj.horizontalStiffeners) ? checkForNull((this.returnFieldInteger('height') / (this.returnFieldInteger('horizontalStiffeners') - 1))) : 0;
        let returnValue = '';
        if (verticalStiff < horizontalStiff) {
            returnValue = verticalStiff;
        } else {
            returnValue = horizontalStiff;
        }

        const bendingStress = (nonDimensionalFactor / 100 * maxPressureSkinPlate * (returnValue * returnValue)) / (this.returnFieldInteger('skinPlateThickness') * this.returnFieldInteger('skinPlateThickness'))
        return checkForNull(bendingStress)
    };


    handlehorizontalStiffenersChange = (e) => {
        this.setState({ horizontalSniffersSelect: e.target.value })
    }

    handlehorizontalRib = (e) => {
        this.setState({
            selectHorizontalRib: e.target.value
        });
    };

    handlefactorOfSafetyDD = (e) => {
        this.setState({
            factorOfSafetyDD: e.target.value
            // horizontalStiffenersSectionObj: tempObj
        });//, () => this.calculationHandler())
    };

    /**
    * @method returnEndVerticalStiff
    * @description Return end vertical stiffiners
    */
    returnEndVerticalStiff = () => {
        const { fieldObj } = this.props;

        return fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
    }

    /**
    * @method returnCoActingWidthB1
    * @description Co acting width B1
    */
    returnCoActingWidthB1 = () => {
        const { fieldObj } = this.props;

        return fieldObj ? checkForNull(((40 * this.returnFieldInteger('skinPlateThickness')) + this.returnFieldInteger('HRt3'))) : 0;
    }

    /**
    * @method returnCoActingWidthB2
    * @description Co acting width B2
    */
    returnCoActingWidthB2 = () => {
        return this.returnEndVerticalStiff() * 0.11;
    }

    /**
    * @method returnMinimumCoActingWidth
    * @description Return Co acting minimum width
    */
    returnMinimumCoActingWidth = () => {
        const coActingB1 = this.returnCoActingWidthB1();
        const coActingB2 = this.returnCoActingWidthB2();
        const bayWidthHorizontal = this.bayWidthHorizontalStif();

        return checkForNull((Math.min(coActingB1, coActingB2, bayWidthHorizontal)));
    }

    /**
    * @method HRStiffY1Calculation
    * @description Return Y1 according to Horizontal stiffeners
    */
    HRStiffY1Calculation = () => {
        const { selectedHorizontalStiff } = this.state;

        let B = this.returnMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('HRd');
        let b1 = this.returnFieldInteger('HRb1');
        let b = this.returnFieldInteger('HRb1') - this.returnFieldInteger('HRt1');
        let d1 = this.returnFieldInteger('HRd1');
        let t1 = this.returnFieldInteger('HRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('HRt3');
        let d = this.returnFieldInteger('HRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY1 = '';

        if (selectedHorizontalStiff === 'A') {

            returnY1 = (a2 * (2 * D - t2) + (a1 * t1) + a * (d1 + 2 * t1)) / (2 * (a1 + a + a2))

        } else if (selectedHorizontalStiff === 'B') {

            b = B - t3;
            d1 = d;
            returnY1 = (B * Math.pow(D, 2) - b * Math.pow(d1, 2)) / (2 * (B * D - b * d1))

        } else if (selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY1 = (a2 * (D - t2 / 2) + a1 * (d1 + t1 + t1 / 2) + a * (d1 / 2 + t1) + a1 * t1 / 2) / (2 * a1 + a + a2)

        } else if (selectedHorizontalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY1 = (a3 * (t2 / 2 + d1 + t1) + a2 * (d1 / 2 + t1) + a1 * (t1 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY1);
    }

    /**
    * @method HRStiffY2Calculation
    * @description Return Y2 according to Horizontal stiffeners
    */
    HRStiffY2Calculation = () => {
        const { selectedHorizontalStiff } = this.state;

        let B = this.returnMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('HRd');
        let b1 = this.returnFieldInteger('HRb1');
        let b = this.returnFieldInteger('HRb1') - this.returnFieldInteger('HRt1');
        let d1 = this.returnFieldInteger('HRd1');
        let t1 = this.returnFieldInteger('HRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('HRt3');
        let d = this.returnFieldInteger('HRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY2 = '';

        if (selectedHorizontalStiff === 'A') {

            returnY2 = (a1 * (2 * D - t1) + (a2 * t2) + a * (d1 + 2 * t2)) / (2 * (a1 + a + a2))

        } else if (selectedHorizontalStiff === 'B') {

            b = B - t3;
            d1 = d;

            // 
            // 
            // 
            // 
            // 
            // 
            // 
            // 
            // 

            returnY2 = (B * Math.pow(D, 2) + (b * Math.pow(d1, 2)) - (2 * b * d1 * D)) / (2 * ((B * D) - (b * d1)))

        } else if (selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY2 = (a1 * (D - t1 / 2) + a * (d1 / 2 + t1 + t2) + a1 * (t2 + t1 / 2) + a2 * t2 / 2) / (2 * a1 + a + a2)

        } else if (selectedHorizontalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY2 = (a1 * (t1 / 2 + d1 + t2) + a2 * (d1 / 2 + t2) + a3 * (t2 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY2);
    }

    /**
    * @method HRStiffInertiaCalculation
    * @description Return I according to Horizontal stiffeners
    */
    HRStiffInertiaCalculation = () => {
        const { selectedHorizontalStiff } = this.state;

        let B = this.returnMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('HRd');
        let b1 = this.returnFieldInteger('HRb1');
        let b = this.returnFieldInteger('HRb1') - this.returnFieldInteger('HRt1');
        let d1 = this.returnFieldInteger('HRd1');
        let t1 = this.returnFieldInteger('HRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('HRt3');
        let d = this.returnFieldInteger('HRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';
        let Intertia = '';
        let I1 = '';
        let I2 = '';
        let returnInertia = '';

        if (selectedHorizontalStiff === 'A') {

            I1 = (1 / 12) * ((a1 * Math.pow(t1, 2)) + (a2 * Math.pow(t2, 2)) + (a * Math.pow(d1, 2)));
            I2 = (a1 * a2 * Math.pow((D + d1), 2) + a1 * a * Math.pow((t1 + d1), 2) + a2 * a * Math.pow((t2 + d1), 2));
            Intertia = I1 + (I2 / (4 * (a1 + a + a2)));
            returnInertia = Intertia / 1000000000000

        } else if (selectedHorizontalStiff === 'B') { //TODO: This should be swtich case

            b = B - t3;   //TODO: The below values should be a function
            d1 = d;

            returnInertia = ((1 / (12 * ((B * D) - (b * d1)))) * ((Math.pow((B * Math.pow(D, 2) - b * Math.pow(d1, 2)), 2)) - (4 * B * D * b * d1 * Math.pow((D - d1), 2)))) / 1000000000000

        } else if (selectedHorizontalStiff === 'C' || selectedHorizontalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a * Math.pow(d1, 2) + a1 * Math.pow(t1, 2) + a2 * Math.pow(t2, 2)) + a1 * Math.pow((this.HRStiffY1Calculation() - t1 / 2), 2) + a * Math.pow((this.HRStiffY1Calculation() - d1 / 2), 2) + a1 * Math.pow((this.HRStiffY2Calculation() - t2 - t1 / 2), 2) + a2 * Math.pow((this.HRStiffY2Calculation() - t2 / 2), 2)) / 1000000000000

        } else if (selectedHorizontalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a3 * Math.pow(t2, 2) + a2 * Math.pow(d1, 2)) + ((a1 * a3 * Math.pow((D + d1), 2) + a1 * a2 * Math.pow((t1 + d1), 2) + a3 * a2 * Math.pow((t2 + d1), 2))) / (4 * (a1 + a2 + a3))) / 1000000000000

        }

        return checkForNull(returnInertia);
    }

    /**
    * @method VRStiffY1Calculation
    * @description Return Y1 according to Vertical stiffeners
    */
    VRStiffY1Calculation = () => {
        const { selectedVerticalStiff } = this.state;

        let B = this.returnVerticalMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('VRd');
        let b1 = this.returnFieldInteger('VRb1');
        let b = this.returnFieldInteger('VRb1') - this.returnFieldInteger('VRt1');
        let d1 = this.returnFieldInteger('VRd1');
        let t1 = this.returnFieldInteger('VRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('VRt3');
        let d = this.returnFieldInteger('VRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY1 = '';

        if (selectedVerticalStiff === 'A') {

            returnY1 = (a2 * (2 * D - t2) + (a1 * t1) + a * (d1 + 2 * t1)) / (2 * (a1 + a + a2))

        } else if (selectedVerticalStiff === 'B') {

            b = B - t3;
            d1 = d;
            returnY1 = (B * Math.pow(D, 2) - b * Math.pow(d1, 2)) / (2 * (B * D - b * d1))

        } else if (selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY1 = (a2 * (D - t2 / 2) + a1 * (d1 + t1 + t1 / 2) + a * (d1 / 2 + t1) + a1 * t1 / 2) / (2 * a1 + a + a2)

        } else if (selectedVerticalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY1 = (a3 * (t2 / 2 + d1 + t1) + a2 * (d1 / 2 + t1) + a1 * (t1 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY1);
    }

    /**
        * @method VRStiffY2Calculation
        * @description Return Y2 according to Vertical stiffeners
        */
    VRStiffY2Calculation = () => {
        const { selectedVerticalStiff } = this.state;

        let B = this.returnVerticalMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('VRd');
        let b1 = this.returnFieldInteger('VRb1');
        let b = this.returnFieldInteger('VRb1') - this.returnFieldInteger('VRt1');
        let d1 = this.returnFieldInteger('VRd1');
        let t1 = this.returnFieldInteger('VRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('VRt3');
        let d = this.returnFieldInteger('VRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let returnY2 = '';

        if (selectedVerticalStiff === 'A') {

            returnY2 = (a1 * (2 * D - t1) + (a2 * t2) + a * (d1 + 2 * t2)) / (2 * (a1 + a + a2))

        } else if (selectedVerticalStiff === 'B') {

            b = B - t3;
            d1 = d;

            returnY2 = (B * Math.pow(D, 2) + b * Math.pow(d1, 2) - 2 * b * d1 * D) / (2 * (B * D - b * d1))

        } else if (selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnY2 = (a1 * (D - t1 / 2) + a * (d1 / 2 + t1 + t2) + a1 * (t2 + t1 / 2) + a2 * t2 / 2) / (2 * a1 + a + a2)

        } else if (selectedVerticalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnY2 = (a1 * (t1 / 2 + d1 + t2) + a2 * (d1 / 2 + t2) + a3 * (t2 / 2)) / (a1 + a2 + a3)

        }

        return checkForNull(returnY2);
    }


    /**
    * @method VRStiffInertiaCalculation
    * @description Return I according to Vertical stiffeners
    */
    VRStiffInertiaCalculation = () => {
        const { selectedVerticalStiff } = this.state;

        let B = this.returnVerticalMinimumCoActingWidth();
        let D = this.returnFieldInteger('skinPlateThickness') + this.returnFieldInteger('VRd');
        let b1 = this.returnFieldInteger('VRb1');
        let b = this.returnFieldInteger('VRb1') - this.returnFieldInteger('VRt1');
        let d1 = this.returnFieldInteger('VRd1');
        let t1 = this.returnFieldInteger('VRt1');
        let t2 = this.returnFieldInteger('skinPlateThickness');
        let t3 = this.returnFieldInteger('VRt3');
        let d = this.returnFieldInteger('VRd');
        let a1 = b1 * t1;
        let a = d1 * t3;
        let a2 = B * t2;
        let a3 = '';

        let Intertia = '';
        let I1 = '';
        let I2 = '';
        let returnInertia = '';

        if (selectedVerticalStiff === 'A') {

            I1 = (1 / 12) * ((a1 * Math.pow(t1, 2)) + (a2 * Math.pow(t2, 2)) + (a * Math.pow(d1, 2)));
            I2 = (a1 * a2 * Math.pow((D + d1), 2) + a1 * a * Math.pow((t1 + d1), 2) + a2 * a * Math.pow((t2 + d1), 2));
            Intertia = I1 + (I2 / (4 * (a1 + a + a2)));
            returnInertia = Intertia / 1000000000000

        } else if (selectedVerticalStiff === 'B') { //TODO: This should be swtich case

            b = B - t3;   //TODO: The below values should be a function
            d1 = d;

            returnInertia = ((1 / (12 * ((B * D) - (b * d1)))) * ((Math.pow((B * Math.pow(D, 2) - b * Math.pow(d1, 2)), 2)) - (4 * B * D * b * d1 * Math.pow((D - d1), 2)))) / 1000000000000

        } else if (selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D') {

            b = b1;
            d1 = d - 2 * t1;
            a1 = b * t1;
            a = d1 * t3;
            a2 = checkForNull(B * t2);

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a * Math.pow(d1, 2) + a1 * Math.pow(t1, 2) + a2 * Math.pow(t2, 2)) + a1 * Math.pow((this.VRStiffY1Calculation() - t1 / 2), 2) + a * Math.pow((this.VRStiffY1Calculation() - d1 / 2), 2) + a1 * Math.pow((this.VRStiffY2Calculation() - t2 - t1 / 2), 2) + a2 * Math.pow((this.VRStiffY2Calculation() - t2 / 2), 2)) / 1000000000000

        } else if (selectedVerticalStiff === 'E') {

            d1 = d - t1;
            D = t2 + d1 + t1;
            a1 = b1 * t1;
            a2 = t3 * d1;
            a3 = B * t2;

            returnInertia = ((1 / 12) * (a1 * Math.pow(t1, 2) + a3 * Math.pow(t2, 2) + a2 * Math.pow(d1, 2)) + ((a1 * a3 * Math.pow((D + d1), 2) + a1 * a2 * Math.pow((t1 + d1), 2) + a3 * a2 * Math.pow((t2 + d1), 2))) / (4 * (a1 + a2 + a3))) / 1000000000000

        }

        return checkForNull(returnInertia);
    }


    /**
    * @method bayWidthHtalStiffSpan
    * @description Bay width of horizontal stiffiners span
    */
    bayWidthHtalStiffSpan = () => {
        const { fieldObj } = this.props;
        const bayWidthHorizontal = this.bayWidthHorizontalStif();
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((bayWidthHorizontal / 1000) * (width / 1000)))
    }

    /**
    * @method returnHydroForceMaxHead
    * @description Hydrostatic force due to max head
    */
    returnHydroForceMaxHead = () => {
        const { fieldObj } = this.props;

        const bayWidthHorizontalSpan = Number(this.bayWidthHtalStiffSpan());
        const maxNumber = Number((this.returnMaxNumber() / 1000));
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
        //
        //
        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthHorizontalSpan) / (width / 1000)))
    }

    /**
    * @method returnHydroForceSeatingHead
    * @description Hydrostatic force due to seating head
    */
    returnHydroForceSeatingHead = () => {
        const { fieldObj } = this.props;

        const bayWidthHorizontalSpan = Number(this.bayWidthHtalStiffSpan());
        const maxNumber = Number((this.seatingWaterCalculation() / 1000));
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthHorizontalSpan) / (width / 1000)))
    }

    /**
    * @method returnHydroForceUnseatingHead
    * @description Hydrostatic force due to unseating head
    */
    returnHydroForceUnseatingHead = () => {
        const { fieldObj } = this.props;

        const bayWidthHorizontalSpan = Number(this.bayWidthHtalStiffSpan());
        const maxNumber = Number((this.unseatingWaterCalculation() / 1000));
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthHorizontalSpan) / (width / 1000)))
    }

    /**
    * @method returnBendingMomentMaxHead
    * @description Bending moment due to Maximum head
    */
    returnBendingMomentMaxHead = () => {
        const { fieldObj } = this.props;

        const hydroForceMaxHead = Number(this.returnHydroForceMaxHead());
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((hydroForceMaxHead * (Math.pow((width / 1000), 2))) / 8))
    }

    /**
    * @method returnBendingMomentSeatingHead
    * @description Bending moment due to Seating head
    */
    returnBendingMomentSeatingHead = () => {
        const { fieldObj } = this.props;

        const hydroForceSeatingHead = Number(this.returnHydroForceSeatingHead());
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull((hydroForceSeatingHead * (Math.pow((width / 1000), 2))) / 8)
    }

    /**
    * @method returnBendingMomentUnSeatingHead
    * @description Bending moment due to Unseating head
    */
    returnBendingMomentUnSeatingHead = () => {
        const { fieldObj } = this.props;

        const hydroForceUnSeatingHead = Number(this.returnHydroForceUnseatingHead());
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((hydroForceUnSeatingHead * (Math.pow((width / 1000), 2))) / 8))
    }

    /**
    * @method returnMaxTensileStress
    * @description Maximum Tensile Stress
    */
    returnMaxTensileStress = () => {

        const bendingMomentSeatingHead = Number(this.returnBendingMomentSeatingHead());
        const Z2 = checkForNull((this.HRStiffInertiaCalculation() / (this.HRStiffY2Calculation() / 1000)))
        //
        return checkForNull((bendingMomentSeatingHead / Z2))
    }

    /**
    * @method returnMaxCompressiveStress
    * @description Maximum Compressive Stress
    */
    returnMaxCompressiveStress = () => {

        const bendingMomentSeatingHead = Number(this.returnBendingMomentSeatingHead());
        const Z1 = (this.HRStiffInertiaCalculation() / (this.HRStiffY1Calculation() / 1000))

        return checkForNull((bendingMomentSeatingHead / Z1))
    }

    /**
    * @method returnMaxTensileStressUnSeatHead
    * @description Maximum Tensile Stress Unseat head
    */
    returnMaxTensileStressUnSeatHead = () => {

        const bendingMomentUnSeatingHead = Number(this.returnBendingMomentUnSeatingHead());
        const Z1 = (this.HRStiffInertiaCalculation() / (this.HRStiffY1Calculation() / 1000))

        return checkForNull(bendingMomentUnSeatingHead / Z1)
    }

    /**
    * @method returnMaxCompressiveStressUnseatedHead
    * @description Maximum Compressive Stress Unseat head
    */
    returnMaxCompressiveStressUnseatedHead = () => {

        const bendingMomentUnSeatingHead = Number(this.returnBendingMomentUnSeatingHead());
        const Z2 = (this.HRStiffInertiaCalculation() / (this.HRStiffY2Calculation() / 1000))

        return checkForNull((bendingMomentUnSeatingHead / Z2))
    }

    /**
    * @method returnMaxShearForce
    * @description Maximum shear force
    */
    returnMaxShearForce = () => {
        const { fieldObj } = this.props;
        const hydroForceMaxHead = this.returnHydroForceMaxHead();
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull((hydroForceMaxHead * (width / 1000)) / 2)
    }

    // /**
    // * @method returnMaxShearStress
    // * @description Maximum shear stress
    // */
    // returnMaxShearStress = () => {
    //     const { fieldObj } = this.props;
    //     const MaxShearForce = this.returnMaxShearForce();
    //     const MinimumCoActingWidth = this.returnMinimumCoActingWidth();
    //     const HRt3 = fieldObj && fieldObj.HRt3 ? this.returnFieldInteger('HRt3') : 0;

    //     return checkForNull((1.5 * (MaxShearForce / (MinimumCoActingWidth * HRt3 / 1000000))));
    // }

    /**
    * @method returnMaxShearStress
    * @description Maximum shear stress
    */
    returnMaxShearStress = () => {
        const { fieldObj } = this.props;
        const MaxShearForce = this.returnMaxShearForce();
        const HRt3 = fieldObj && fieldObj.HRt3 ? this.returnFieldInteger('HRt3') : 0;
        const HRd1 = fieldObj && fieldObj.HRd1 ? this.returnFieldInteger('HRd1') : 0;

        return checkForNull((1.5 * (MaxShearForce / (HRd1 * HRt3 / 1000000))));
    }

    /**
    * @method returnMaxDeflectionAtCentre
    * @description Maximum deflection at centre
    */
    returnMaxDeflectionAtCentre = () => {
        const { fieldObj } = this.props;

        //S167
        const hydroForceMaxHead = this.returnHydroForceMaxHead();
        //S13
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
        //S151
        const momentOfInertia = this.HRStiffInertiaCalculation();
        return checkForNull((5 * hydroForceMaxHead * (Math.pow((width / 1000), 4))) / (384 * 2 * Math.pow(10, 11) * momentOfInertia))

    }

    /**
    * @method returnPermissibleDefTenderSpec
    * @description Permissible deflection as per tender sepcification
    */
    returnPermissibleDefTenderSpec = () => {
        const { fieldObj } = this.props;

        //S13
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;
        //S230
        const horizontalDeflection = fieldObj && fieldObj.horizontalDeflection ? this.returnFieldInteger('horizontalDeflection') : 0;

        return checkForNull((width / horizontalDeflection));


    }

    /**
    * @method handleVerticalStiffeners
    * @description Vertical Stiffeners Section
    */
    handleVerticalStiffeners = (e) => {

        let t1 = this.returnFieldInteger('VRt1');
        let d = this.returnFieldInteger('VRd');

        const value = e.target.value;
        let tempObj = {};

        if (value === 'A') {
            this.props.change('VRd1', d - t1)
            tempObj = VerticalStiffiners.A;
        } else if (value === 'B') {
            this.props.change('VRd1', d)
            tempObj = VerticalStiffiners.B;
        } else if (value === 'C') {
            this.props.change('VRd1', d - 2 * t1)
            tempObj = VerticalStiffiners.C;
        } else if (value === 'D') {
            this.props.change('VRd1', d - 2 * t1)
            tempObj = VerticalStiffiners.D;
        } else if (value === 'E') {
            this.props.change('VRd1', d - t1)
            tempObj = VerticalStiffiners.E;
        }

        this.setState({
            selectedVerticalStiff: value,
            verticalStiffenersSectionObj: tempObj
        })
    };

    /**
    * @method vrb1AlertMsg
    * @description Vertical stiff b1 alert msg according to selected section
    */
    vrb1AlertMsg = () => {
        const { selectedVerticalStiff } = this.state;

        if ((selectedVerticalStiff === 'A' || selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D' || selectedVerticalStiff === 'E') && Number(this.returnFieldInteger('VRb1')) === 0) {
            return 'Warning either put the value of b1 or change the section';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRb1')) === 0) {
            return '';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRb1')) !== 0) {
            return 'Warning either put the value of b1 or change the section';
        } else {
            return '';
        }
    }

    /**
    * @method vrt1AlertMsg
    * @description Vertical stiff t1 alert msg according to selected section
    */
    vrt1AlertMsg = () => {
        const { selectedVerticalStiff } = this.state;

        if ((selectedVerticalStiff === 'A' || selectedVerticalStiff === 'C' || selectedVerticalStiff === 'D' || selectedVerticalStiff === 'E') && Number(this.returnFieldInteger('VRt1')) === 0) {
            return 'Warning either put the value of t1 or change the section';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRt1')) === 0) {
            return '';
        } else if (selectedVerticalStiff === 'B' && Number(this.returnFieldInteger('VRt1')) !== 0) {
            return 'Warning either put the value of t1 or change the section';
        } else {
            return '';
        }
    }

    /**
    * @method returnVerticalCoActingWidthB1
    * @description Vertical Co acting width B1
    */
    returnVerticalCoActingWidthB1 = () => {
        const { fieldObj } = this.props;

        return fieldObj ? checkForNull((((40 * this.returnFieldInteger('skinPlateThickness')) + this.returnFieldInteger('VRt3')))) : 0;
    }

    /**
    * @method returnVerticalCoActingWidthB2
    * @description Vertical Co acting width B2
    */
    returnVerticalCoActingWidthB2 = () => {

        return this.bayWidthHorizontalStif() * 0.11;
    }

    /**
    * @method returnVerticalMinimumCoActingWidth
    * @description Return Vertical Co acting minimum width
    */
    returnVerticalMinimumCoActingWidth = () => {
        const coActingB1 = this.returnVerticalCoActingWidthB1();
        const coActingB2 = this.returnVerticalCoActingWidthB2();
        const bayWidthVertical = this.bayWidthVerticalStif();

        return checkForNull((Math.min(coActingB1, coActingB2, bayWidthVertical)));
    }

    /**
    * @method bayWidthVtalStiffSpan
    * @description Bay width of Vertical stiffiners span
    */
    bayWidthVtalStiffSpan = () => {
        const { fieldObj } = this.props;
        const bayWidthVertical = this.bayWidthVerticalStif();
        const width = fieldObj && fieldObj.width ? this.returnFieldInteger('width') + 80 : 0;

        return checkForNull(((bayWidthVertical / 1000) * (this.bayWidthHorizontalStif() / 1000)))
    }

    /**
    * @method returnVerticalHydroForceMaxHead
    * @description Vertical Hydrostatic force due to max head
    */
    returnVerticalHydroForceMaxHead = () => {

        const bayWidthVerticalSpan = Number(this.bayWidthVtalStiffSpan());
        const maxNumber = Number((this.returnMaxNumber() / 1000));
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthVerticalSpan) / (CenterToCenterWidthHorizontalStif / 1000)))
    }

    /**
    * @method returnVerticalHydroForceSeatingHead
    * @description Vertical Hydrostatic force due to seating head
    */
    returnVerticalHydroForceSeatingHead = () => {

        const bayWidthVerticalSpan = Number(this.bayWidthVtalStiffSpan());
        const maxNumber = Number((this.seatingWaterCalculation() / 1000));
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthVerticalSpan) / (CenterToCenterWidthHorizontalStif / 1000)))
    }

    /**
    * @method returnHydroForceUnseatingHead
    * @description Vertical Hydrostatic force due to unseating head
    */
    returnVerticalHydroForceUnseatingHead = () => {

        const bayWidthVtalStiffSpan = Number(this.bayWidthVtalStiffSpan());
        const maxNumber = Number((this.unseatingWaterCalculation() / 1000));
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((1010 * 9.81 * maxNumber * bayWidthVtalStiffSpan) / (CenterToCenterWidthHorizontalStif / 1000)))
    }

    /**
    * @method returnVerticalBendingMomentMaxHead
    * @description Vertical Bending moment due to Maximum head
    */
    returnVerticalBendingMomentMaxHead = () => {

        const verticalHydroForceMaxHead = Number(this.returnVerticalHydroForceMaxHead());
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((verticalHydroForceMaxHead * (Math.pow((CenterToCenterWidthHorizontalStif / 1000), 2))) / 12))
    }

    /**
    * @method returnVerticalBendingMomentSeatingHead
    * @description Vertical Bending moment due to Seating head
    */
    returnVerticalBendingMomentSeatingHead = () => {

        const verticalHydroForceSeatingHead = Number(this.returnVerticalHydroForceSeatingHead());
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((verticalHydroForceSeatingHead * (Math.pow((CenterToCenterWidthHorizontalStif / 1000), 2))) / 12))
    }

    /**
    * @method returnVerticalBendingMomentUnSeatingHead
    * @description Bending moment due to Unseating head
    */
    returnVerticalBendingMomentUnSeatingHead = () => {

        const verticalHydroForceUnSeatingHead = Number(this.returnVerticalHydroForceUnseatingHead());
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        return checkForNull(((verticalHydroForceUnSeatingHead * (Math.pow((CenterToCenterWidthHorizontalStif / 1000), 2))) / 12))
    }

    /**
    * @method returnVerticalMaxTensileStress
    * @description Vertical Maximum Tensile Stress
    */
    returnVerticalMaxTensileStress = () => {

        const verticalBendingMomentSeatingHead = Number(this.returnVerticalBendingMomentSeatingHead());
        const Z2 = (this.VRStiffInertiaCalculation() / (this.VRStiffY2Calculation() / 1000))

        return checkForNull((verticalBendingMomentSeatingHead / Z2))
    }

    /**
    * @method returnVerticalMaxCompressiveStress
    * @description Vertical Maximum Compressive Stress
    */
    returnVerticalMaxCompressiveStress = () => {

        const verticalBendingMomentSeatingHead = Number(this.returnVerticalBendingMomentSeatingHead());
        const Z1 = (this.VRStiffInertiaCalculation() / (this.VRStiffY1Calculation() / 1000))

        return checkForNull((verticalBendingMomentSeatingHead / Z1))
    }

    /**
    * @method returnVerticalMaxTensileStressUnSeatHead
    * @description Vertical Maximum Tensile Stress Unseat head
    */
    returnVerticalMaxTensileStressUnSeatHead = () => {

        const verticalBendingMomentUnSeatingHead = Number(this.returnVerticalBendingMomentUnSeatingHead());
        const Z1 = (this.VRStiffInertiaCalculation() / (this.VRStiffY1Calculation() / 1000))

        return checkForNull((verticalBendingMomentUnSeatingHead / Z1))
    }

    /**
    * @method returnVerticalMaxCompressiveStressUnseatedHead
    * @description Vertical Maximum Compressive Stress Unseat head
    */
    returnVerticalMaxCompressiveStressUnseatedHead = () => {

        const verticalBendingMomentUnSeatingHead = Number(this.returnVerticalBendingMomentUnSeatingHead());
        const Z2 = (this.VRStiffInertiaCalculation() / (this.VRStiffY2Calculation() / 1000))

        return checkForNull((verticalBendingMomentUnSeatingHead / Z2))
    }

    /**
    * @method returnVerticalMaxShearForce
    * @description Vertical Maximum shear force
    */
    returnVerticalMaxShearForce = () => {
        const hydroForceMaxHead = this.returnVerticalHydroForceMaxHead();
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())
        return checkForNull(((hydroForceMaxHead * (CenterToCenterWidthHorizontalStif / 1000)) / 2))
    }

    /**
    * @method returnVerticalMaxShearStress
    * @description Vertical Maximum shear stress
    */
    returnVerticalMaxShearStress = () => {
        const { fieldObj } = this.props;

        const MaxShearForce = this.returnVerticalMaxShearForce();
        const MinimumCoActingWidth = this.returnVerticalMinimumCoActingWidth();
        const VRt3 = fieldObj && fieldObj.VRt3 ? this.returnFieldInteger('VRt3') : 0;

        return checkForNull((1.5 * (MaxShearForce / (this.returnFieldInteger('VRd1') * VRt3 / 1000000))));
    }

    /**
    * @method returnVerticalMaxDeflectionAtCentre
    * @description Vertical Maximum deflection at centre
    */
    returnVerticalMaxDeflectionAtCentre = () => {

        //S167
        const hydroForceMaxHead = this.returnVerticalHydroForceMaxHead();

        //S13
        const CenterToCenterWidthHorizontalStif = Number(this.bayWidthHorizontalStif())

        //S151
        const momentOfInertia = this.VRStiffInertiaCalculation();

        return checkForNull((hydroForceMaxHead * (Math.pow((CenterToCenterWidthHorizontalStif) / 1000, 4) / (384 * 2 * Math.pow(10, 11) * momentOfInertia))))
    }

    /**
    * @method returnVerticalPermissibleDefTenderSpec
    * @description Vertical Permissible deflection as per tender sepcification
    */
    returnVerticalPermissibleDefTenderSpec = () => {
        const { fieldObj } = this.props;

        //S14
        const height = fieldObj && fieldObj.height ? this.returnFieldInteger('height') + 80 : 0;

        //S357
        const verticalDeflection = fieldObj && fieldObj.verticalDeflection ? this.returnFieldInteger('verticalDeflection') : 0;

        return checkForNull((height / verticalDeflection));

    }

    /**
    * @method Value
    * @description Horizontal Ribs height
    */
    Value = () => {
        const { selectedHorizontalStiff } = this.state;
        let hrRibsHeight = '';

        if (selectedHorizontalStiff === 'A') {
            hrRibsHeight = this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'B') {
            hrRibsHeight = this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'C') {
            hrRibsHeight = 2 * this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'D') {
            hrRibsHeight = 2 * this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1');
        } else if (selectedHorizontalStiff === 'E') {
            // hrRibsHeight = this.returnFieldInteger('HRd') + this.returnFieldInteger('HRd1');
            hrRibsHeight = this.returnFieldInteger('HRb1') + this.returnFieldInteger('HRd1')



        } else {
            hrRibsHeight = 0;
        }

        return hrRibsHeight;
    }

    /**
    * @method handleSeriesOffered
    * @description Handle offered series
    */
    handleSeriesOffered = (e) => {
        const value = e.target.value;
        this.setState({ selectedSeriesOffered: value, frameExtension: '' })
        this.setFramelength(value);
        this.setFrameExtensionArray(value);
    }

    /**
    * @method handleActuation
    * @description Handle Actuation
    */
    handleActuation = (e) => {
        const value = e.target.value;
        this.setState({ activeActuation: value })
        this.props.ActuationToggler(value)
    }

    /**
    * @method verticalRibsHeight
    * @description Vertical Ribs height
    */
    verticalRibsHeight = () => {
        const { selectedVerticalStiff } = this.state;
        let vrRibsHeight = '';

        if (selectedVerticalStiff === 'A') {
            vrRibsHeight = this.returnFieldInteger('VRb1') + this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'B') {
            vrRibsHeight = this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'C') {
            vrRibsHeight = 2 * this.returnFieldInteger('VRb1') + this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'D') {
            vrRibsHeight = 2 * this.returnFieldInteger('VRb1') + this.returnFieldInteger('VRd1');
        } else if (selectedVerticalStiff === 'E') {
            vrRibsHeight = this.returnFieldInteger('VRd') + this.returnFieldInteger('VRd1');
        } else {
            vrRibsHeight = 0;
        }

        return vrRibsHeight;
    }

    handleApplicableStandardSelect = (e) => {
        const value = e.target.value;
        this.setState({ selectedApplicableStandard: value })
    }

    isUniqueNumberChanged = () => {
        const { fieldObj } = this.props;
        const { item_number, pid_number, quote_number } = this.state.identifier





        if (item_number === fieldObj.ItemNumber && pid_number === fieldObj.pid_number && quote_number === fieldObj.quote_number) {
            return true
        } else {
            return false
        }
    }

    /**
    * @method shutterDesignConfirmation
    * @description Shutter confirmation after save for Edit and Create Copy
    */
    shutterDesignConfirmation = (values) => {
        const toasterBody = (
            <Form >
                <FormGroup tag="fieldset">
                    {/* <legend>Radio Buttons</legend> */}
                    {!this.state.isPostOrderCreated && <FormGroup check>
                        <Label check>
                            <Input type="radio" name="radio1" onChange={(e) => this.setState({ copyCosting: false, isPostOrder: false })} />{' '}
                            Save to existing costing.
                        </Label>
                    </FormGroup>
                    }

                    <FormGroup check>
                        <Label check>
                            <Input type="radio" name="radio1" onChange={(e) => this.setState({ copyCosting: true, isPostOrder: false })} />{' '}
                            Save as new costing.
                        </Label>
                    </FormGroup>
                    {
                        this.isUniqueNumberChanged() && !this.state.isPostOrderCreated &&
                        <FormGroup check disabled>
                            <Label check>
                                <Input type="radio" name="radio1" onChange={(e) => this.setState({ isPostOrder: true, copyCosting: false })} />{' '}
                                Post Order
                            </Label>
                        </FormGroup>
                    }
                </FormGroup>

            </Form>
        )
        const toastrConfirmOptions = {
            onOk: (values) => {
                this.confirmCreate(values)
            },
            // onCancel: (values) => {
            //     this.confirmEdit(values)
            // },
            okText: 'Save',
            // cancelText: 'No'
        };
        // return toastr.confirm(`${MESSAGES.CREATE_COPY_ALERT}`, toastrConfirmOptions);
        return toastr.confirm(toasterBody, toastrConfirmOptions);
    }

    // continueEditingConfirmation = () => {
    //     const toastrBody = ``
    //     const toastrConfirmOptions = {
    //         onOk: (values) => {

    //         },
    //         // onCancel: (values) => {
    //         //     this.props.toggle('1')
    //         // },
    //         okText: 'Okay',
    //         // cancelText: 'Cancel'
    //     };
    //     // return toastr.confirm(`${MESSAGES.CREATE_COPY_ALERT}`, toastrConfirmOptions);
    //     return toastr.confirm(toastrBody, toastrConfirmOptions);
    // }

    /**
    * @method confirmCreate
    * @description Create the copy of existing shutter design's
    */
    confirmCreate = (values) => {
        this.shutterDesignHandler(values, this.state.copyCosting)
    }

    // /**
    // * @method confirmEdit
    // * @description Edit existing shutter design 
    // */
    // confirmEdit = (values) => {
    //     this.shutterDesignHandler(values, false)
    // }

    handleHeightOnchange = (e) => {
        const h = parseInt(e.target.value);
        const cl_pl = 3.084576 - h / 2000
        return this.setState({ clPlValue: cl_pl })
    }

    /**
    * Submit the login form
    * @param values
    */
    onSubmit(values) {


        const { fieldObj, isEditFlag, shutterDesignCreated } = this.props;
        this.calculate()
        const { referenceDocumentsObj, manufacturingMaterialObj } = this.state;
        const PermissibleCompressiveStress = (referenceDocumentsObj.AxialStress * manufacturingMaterialObj.YS)
        const maxDeflectionAtCentre = this.returnVerticalMaxDeflectionAtCentre() * 1000
        const permissibleBendingStress = (referenceDocumentsObj.BendingStress * manufacturingMaterialObj.YS).toFixed(2)
        const bendingStressInPlate = this.calculateSkinPlateBendingStress()
        const PermissibleShearStress = (referenceDocumentsObj.ShearStress * manufacturingMaterialObj.FSS)
        const MaxTensileStress = checkForNull(this.returnMaxTensileStress() / Math.pow(10, 6))
        const MaxCompressiveStress = checkForNull(this.returnMaxCompressiveStressUnseatedHead() / Math.pow(10, 6))
        const MaxShearStress = checkForNull(this.returnVerticalMaxShearStress() / Math.pow(10, 6))
        const verticalMaxTensileStress = checkForNull(this.returnVerticalMaxTensileStress() / Math.pow(10, 6))
        const verticalMaxCompressiveStress = checkForNull(this.returnVerticalMaxCompressiveStress() / Math.pow(10, 6))
        const VerticalMaxCompressiveStress = checkForNull(this.returnVerticalMaxCompressiveStressUnseatedHead() / Math.pow(10, 6))

        if (
            (this.state.selectedSeriesOffered === 'A-111' || this.state.selectedSeriesOffered === 'A-112') ||
            (permissibleBendingStress > bendingStressInPlate &&
                PermissibleCompressiveStress > MaxTensileStress &&
                PermissibleCompressiveStress > MaxCompressiveStress &&
                PermissibleCompressiveStress > MaxCompressiveStress &&
                PermissibleCompressiveStress > MaxCompressiveStress &&
                PermissibleShearStress > MaxShearStress &&
                PermissibleCompressiveStress > verticalMaxTensileStress &&
                PermissibleCompressiveStress > verticalMaxCompressiveStress &&
                PermissibleCompressiveStress > VerticalMaxCompressiveStress &&
                PermissibleShearStress > MaxShearStress &&
                ((maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                    maxDeflectionAtCentre < 1.6 &&
                    Number(fieldObj.referenceDocuments) === 0) ||
                    (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        maxDeflectionAtCentre < 1.6 &&
                        Number(fieldObj.referenceDocuments) === 3) ||
                    (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        Number(fieldObj.referenceDocuments) === 1) ||
                    (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        Number(fieldObj.referenceDocuments) === 2)
                )
                &&
                ((maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                    maxDeflectionAtCentre < 1.6 &&
                    Number(fieldObj.referenceDocuments) === 0) ||
                    (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        Number(fieldObj.referenceDocuments) === 1) ||
                    (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        Number(fieldObj.referenceDocuments) === 2) ||
                    (maxDeflectionAtCentre < this.returnVerticalPermissibleDefTenderSpec() &&
                        maxDeflectionAtCentre < 1.6 &&
                        Number(fieldObj.referenceDocuments) === 3)
                ))
        ) {
            if (isEditFlag || shutterDesignCreated) {
                this.shutterDesignConfirmation(values);
                return false;
            }
            // Create new Shutter Design 
            // Create Copy of existing
            // Conditionally Edit existing Shutter design 
            // this.shutterDesignHandler(values, true)
        } else {
            toastr.warning('Your design is unsafe, Please check all the values once again.')
        }
    }

    shearStressCalc = () => {
        let temp, val, X26, X25, calcfos31

        if (this.state.factorOfSafetyDD === "STANDARD") {
            X26 = 1
            calcfos31 = 5
        } else { X26 = 0 }

        if (this.state.factorOfSafetyDD === "CUSTOM") {
            X25 = 1
            calcfos31 = this.props.fieldObj.FOSValue
        }
        else {
            X25 = 0
        }

        if (String(this.props.fieldObj.referenceDocuments) === '0') {
            temp = 0.25
        } else if (String(this.props.fieldObj.referenceDocuments) === '3') {
            temp = 0.2
        } else {
            temp = 0.33
        }
        val = Number(temp) * Number(X26) + (1 / Number(calcfos31)) * Number(X25)
        return val
    }

    table1_mainSec3G320 = () => {
        // =IF(F317 < E318, F318, 0)
        const { fieldObjShutter } = this.props
        let val
        if (fieldObjShutter.height < 762) {
            val = 90
        }
        else if (fieldObjShutter.height < 1525 && fieldObjShutter.height > 762) {
            val = 100
        }
        else {
            val = 0
        }
        return val
    }

    table2_mainSec3G328 = (height) => {
        let indexTemp
        indexTemp = height <= 305 ? 0 : 5
        for (let i = 0; i <= 4; i++) {
            const range1 = table2Section3G328[i - 1]
            const range2 = table2Section3G328[i]

            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        return table2Section3G328Value[indexTemp]
    }

    table4_mainSec3G351 = (height) => {
        let indexTemp
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]

            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        return table4Section3G351Value[indexTemp]
    }

    sizeOfSideWedges = () => {
        const { SelectedSeriesOffered } = this.props.fieldObjShutter
        let val

        if (SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = this.table1_mainSec3G320()
        } else if (SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = 0
        } else if (SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            val = 0
        } else {
            val = this.table3_mainSec3G336(this.props.fieldObjShutter.height)
        }
        return val
    }

    table3_mainSec3G336 = (height) => {
        let indexTemp
        indexTemp = height <= 915.00 ? 0 : 4
        for (let i = 1; i <= 3; i++) {
            const range1 = table3Section3G336[i - 1]
            const range2 = table3Section3G336[i]

            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        return table3Section3G336Value[indexTemp]
    }

    noOfSideWedges = () => {
        const { fieldObjShutter } = this.props
        const temp = this.table4_mainSec3G351(fieldObjShutter.height)
        let val
        if (fieldObjShutter.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = this.table2_mainSec3G328(fieldObjShutter.height)
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = temp
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = temp
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = 0
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            val = 0
        } else {
            val = temp
        }
        return val
        // =IF(R369 = 101, this.table2_mainSec3G328(), IF(R369 = 102, this.table4_mainSec3G351(),
        //  IF(R369 = 103, this.table4_mainSec3G351(),
        //  IF(R369 = 301, 0, IF(R369 = 201, 0, this.table4_mainSec3G351())))))
    }

    KSeries1 = (height) => {
        let indexTemp
        let tempVal = {}
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]
            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        tempVal.table4MC = table4MC[indexTemp]
        tempVal.table4WT = table4WT[indexTemp]
        tempVal.table4BW = table4BW[indexTemp]
        return tempVal
    }

    KSeries2 = (height) => {
        let indexTemp
        let tempVal = {}
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]
            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        tempVal.table5MC = table5MC[indexTemp]
        tempVal.table5WT = table5WT[indexTemp]
        tempVal.table5BW = table5BW[indexTemp]
        return tempVal
    }

    KSeries3 = (height) => {
        let indexTemp
        let tempVal = {}
        indexTemp = height <= 305 ? 0 : 12
        for (let i = 1; i <= 12; i++) {
            const range1 = table4Section3G351[i - 1]
            const range2 = table4Section3G351[i]
            if (height > range1 && height < range2) {
                indexTemp = i
            }
        }
        tempVal.table6MC = table6MC[indexTemp]
        tempVal.table6WT = table6WT[indexTemp]
        tempVal.table6BW = table6BW[indexTemp]
        return tempVal
    }

    KSeries4 = () => {
        let val = {}
        const { fieldObjShutter } = this.props
        if (fieldObjShutter.height <= 1219.00) {
            val.BW = 75.00
            val.WT = 20.00
            val.MC = 5.00
        } else if (fieldObjShutter.height > 1219.00 && fieldObjShutter.height <= 2006.60) {
            val.BW = 80.00
            val.WT = 20.00
            val.MC = 8.00
        } else if (fieldObjShutter.height > 2006.6) {
            val.BW = 85.00
            val.WT = 25.00
            val.MC = 10.00
        }
        return val
    }

    KSeries5 = () => {
        let val = {}
        const { fieldObjShutter } = this.props
        if (fieldObjShutter.height <= 1219.00) {
            val.BW = 74.00
            val.WT = 20.00
            val.MC = 5.00
        } else if (fieldObjShutter.height > 1219.00 && fieldObjShutter.height <= 2006.60) {
            val.BW = 74.00
            val.WT = 20.00
            val.MC = 8.00
        } else if (fieldObjShutter.height > 2006.6) {
            val.BW = 86.00
            val.WT = 25.00
            val.MC = 10.00
        }
        return val
    }

    widthOfBorder = () => {
        const H322 = 45
        const { fieldObjShutter } = this.props
        const KSeries1 = this.KSeries1(fieldObjShutter.height)
        const KSeries2 = this.KSeries2(fieldObjShutter.height)
        const KSeries3 = this.KSeries3(fieldObjShutter.height)
        const KSeries4 = this.KSeries4()
        const KSeries5 = this.KSeries5()

        let val
        if (fieldObjShutter.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = 45
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = KSeries1.table4BW
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = KSeries2.table5BW
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN') {
            val = KSeries3.table6BW
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = KSeries4.BW
        } else {
            val = KSeries5.BW
        }
        return val
    }

    thicknessOfBorder = () => {

        // =IF(R369=101,I322,IF(R369=102,L351,IF(R369=103,L366,IF(R369=104,L381,IF(R369=301,L387,L393)))))

        const { fieldObjShutter } = this.props
        const KSeries1 = this.KSeries1(fieldObjShutter.height)
        const KSeries2 = this.KSeries2(fieldObjShutter.height)
        const KSeries3 = this.KSeries3(fieldObjShutter.height)
        const KSeries4 = this.KSeries4()
        const KSeries5 = this.KSeries5()

        let val
        if (fieldObjShutter.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = 28
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = KSeries1.table4WT
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = KSeries2.table5WT
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN') {
            val = KSeries3.table6WT
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = KSeries4.WT
        } else {
            val = KSeries5.WT
        }
        return val
    }

    mcAllowance = () => {

        // =IF(R369=101,J322,IF(R369=102,M351,IF(R369=103,M366,IF(R369=104,M381,IF(R369=301,M387,M393)))))

        const { fieldObjShutter } = this.props
        const KSeries1 = this.KSeries1(fieldObjShutter.height)
        const KSeries2 = this.KSeries2(fieldObjShutter.height)
        const KSeries3 = this.KSeries3(fieldObjShutter.height)
        const KSeries4 = this.KSeries4()
        const KSeries5 = this.KSeries5()

        let val
        if (fieldObjShutter.SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            val = 10
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-102- SECTIONAL FRAME DESIGN') {
            val = KSeries1.table4MC
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-103- INTEGRAL FRAME DESIGN') {
            val = KSeries2.table5MC
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-104- UNIVERSAL FRAME DESIGN') {
            val = KSeries3.table6MC
        } else if (fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            val = KSeries4.MC
        } else {
            val = KSeries5.MC
        }
        return val
    }

    weightOfSkinPlate = () => {
        let val = this.props.fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE' ? this.mcAllowance() : 0
        return 1 * 1 * (Number(this.props.fieldObj.hs4) + Number(val)) * 7250 / 1000
    }

    weightOfSkinPlate_2 = () => {
        return (Number(this.props.fieldObjShutter.width) * Number(this.props.fieldObjShutter.height)) * Number(this.weightOfSkinPlate()) / 1000000
    }

    weightOfSideWedges = () => {
        const { SelectedSeriesOffered } = this.props
        const a = 2
        const b = a == 0 ? 1 : a
        let finalVal, sum = 0, index = 10
        for (let i = 0; i < 10; i++) {
            if (a > weightOfSideWedgesCalc[i]) {
                sum = Number(sum) + Number(weightOfSideWedgesCalcValue[i])
            }
        }

        if (SelectedSeriesOffered === 'A-101- FLAT BACK FRAME DESIGN') {
            finalVal = 0
        } else if (SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE') {
            finalVal = 0
        } else if (SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL') {
            finalVal = 0
        } else {
            finalVal = Number(sum) / Number(b)
        }

        return (Number(this.sizeOfSideWedges()) + 25) * 100 * Number(finalVal) * 2 * 7.25 / 1000000

    }

    weightOfDoor3 = () => {
        return (Number(this.widthOfBorder()) + Number(this.mcAllowance())) * (Number(this.thicknessOfBorder()) + Number(this.mcAllowance()) * 2) * 7250 / 1000000
    }

    weightOfDoor3_2 = () => {
        const { fieldObjShutter } = this.props
        return Number(this.weightOfDoor3()) * (Number(fieldObjShutter.width) + Number(fieldObjShutter.height) + 2 * Number(this.widthOfBorder())) * 2 / 1000
    }


    risingNonRisingStemDia = () => {
        const { fieldObjShutter } = this.props
        let temp, finalVal
        if (fieldObjShutter.width < 915) {
            temp = 30
        }
        else if (fieldObjShutter.width > 915 && fieldObjShutter.width < 1551) {
            temp = 50
        }
        else if (fieldObjShutter.width > 1551 && fieldObjShutter.width < 2510) {
            temp = 60
        }
        else {
            temp = 70
        }

        if (fieldObjShutter.SpindleDirection === 'RISING') {
            finalVal = temp
        }
        else {
            finalVal = this.calcOfQ431Back()
        }
        return finalVal
    }

    calcOfQ431Back = () => {
        let indexTemp

        // indexTemp = height <= 305 ? 0 : 18
        for (let i = 1; i <= 27; i++) {
            const range = Q431Back[i]
            if (Number(this.props.fieldObj.stemDiaField) === Number(range)) {
                indexTemp = i
            }
        }
        return Q431BackValue[indexTemp]
    }

    diagonalWidthHeightCalc = () => {
        const { fieldObjShutter } = this.props
        const valueDiagonal = Math.sqrt((fieldObjShutter.height * fieldObjShutter.height) + (fieldObjShutter.width * fieldObjShutter.width))

        if (valueDiagonal <= 500) {

            thicknessObjectSHV = {
                Skin: fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE' ? 20 : 10,
                Horizontal: 10,
                Vertical: 10,
            }
        } else if (valueDiagonal <= 1000) {

            thicknessObjectSHV = {
                Skin: fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE' ? 20 : 12,
                Horizontal: 12,
                Vertical: 12,
            }
        } else if (valueDiagonal <= 1500) {

            thicknessObjectSHV = {
                Skin: fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE' ? 20 : 14,
                Horizontal: 12,
                Vertical: 10,
            }
        } else if (valueDiagonal <= 2000) {

            thicknessObjectSHV = {
                Skin: fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE' ? 20 : 18,
                Horizontal: 14,
                Vertical: 12,
            }
        } else if (valueDiagonal <= 2500) {

            thicknessObjectSHV = {
                Skin: 22,
                Horizontal: 18,
                Vertical: 14,
            }
        } else if (valueDiagonal <= 3000) {

            thicknessObjectSHV = {
                Skin: 25,
                Horizontal: 22,
                Vertical: 18,
            }
        } else if (valueDiagonal <= 4000) {

            thicknessObjectSHV = {
                Skin: 30,
                Horizontal: 25,
                Vertical: 22,
            }
        } else if (valueDiagonal <= 5000) {

            thicknessObjectSHV = {
                Skin: 32,
                Horizontal: 30,
                Vertical: 25,
            }
        } else {

            thicknessObjectSHV = {
                Skin: 35,
                Horizontal: 32,
                Vertical: 30,
            }
        }

        // this.setState({ thicknessSHVObject: thicknessObjectSHV, diagonalWH: valueDiagonal })
        return thicknessObjectSHV;
    }

    shutterThicknessA = () => {
        // =Sheet1!D29*G302+Sheet1!R27*G301
        const { fieldObjShutter } = this.props
        const val = this.diagonalWidthHeightCalc()
        const val1 = this.diagonalWidthHeightCalcTable4()
        let G302 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 0 : 1
        let G301 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 1 : 0
        return (val.Skin * G302) + (val1.Skin * G301)
    }

    ribThickness2A = () => {
        // =Sheet1!D30*G302+Sheet1!R29*G301
        const { fieldObjShutter } = this.props
        const val = this.diagonalWidthHeightCalc()
        const val1 = this.diagonalWidthHeightCalcTable4()
        let G302 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 0 : 1
        let G301 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 1 : 0
        return (val.Horizontal * G302) + (val1.Vertical * G301)
    }

    ribThickness2A_5 = () => {
        // =Sheet1!D30*G302+Sheet1!R29*G301
        // Sheet1!D31*G302+Sheet1!R29*G301   new
        const { fieldObjShutter } = this.props
        const val = this.diagonalWidthHeightCalc()
        const val1 = this.diagonalWidthHeightCalcTable4()
        let G302 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 0 : 1
        let G301 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 1 : 0
        return (val.Vertical * G302) + (val1.Vertical * G301)
    }

    ribHeightA = () => {
        // =IF(F301=201,Sheet1!R28,"")
        const { fieldObjShutter } = this.props
        const val = this.diagonalWidthHeightCalcTable4()
        return fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? val.Horizontal : ''
    }

    ribHeightA_5 = () => {
        // =IF(F301=201,Sheet1!R27,"")
        const { fieldObjShutter } = this.props
        const val = this.diagonalWidthHeightCalcTable4()
        return fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? val.Skin : ''
    }

    noOfHorizontalRibsSpacingCalcA = () => {
        const { fieldObjShutter } = this.props
        let G302 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 0 : 1
        let G301 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 1 : 0
        return (this.horizontalRSCalcTable1(fieldObjShutter.height) * G302) + (this.horizontalRSCalcTableHoriz(fieldObjShutter.height) * G301)
    }

    noOfHorizontalRibsSpacingCalcA_5 = () => {
        const { fieldObjShutter } = this.props
        let G302 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 0 : 1
        let G301 = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' ? 1 : 0
        // ********** CR : 03:01:2022 | changed height with width **********
        return (this.horizontalRSCalcTable1(fieldObjShutter.width) * G302) + (this.horizontalRSCalcTableVert(fieldObjShutter.width) * G301)
    }

    diagonalWidthHeightCalcTable4 = () => {
        const { fieldObjShutter } = this.props
        const valueDiagonal = Math.max(fieldObjShutter.height, fieldObjShutter.width)
        let tempObj = {};
        // =IF($K$24<=700,L27,IF($K$24<=1200,L28,IF($K$24<=1600,L29,IF($K$24<=2000,L30,IF($K$24<=2500,L31,IF($K$24<=3000,L32,L33))))))     

        if (valueDiagonal <= 700) {

            tempObj = {
                Skin: 10,
                Horizontal: 40,
                Vertical: 10,
            }
        } else if (valueDiagonal <= 1200) {

            tempObj = {
                Skin: 12,
                Horizontal: 60,
                Vertical: 10,
            }
        } else if (valueDiagonal <= 1600) {

            tempObj = {
                Skin: 15,
                Horizontal: 80,
                Vertical: 16,
            }
        } else if (valueDiagonal <= 2000) {

            tempObj = {
                Skin: 20,
                Horizontal: 80,
                Vertical: 18,
            }
        } else if (valueDiagonal <= 2500) {

            tempObj = {
                Skin: 22,
                Horizontal: 100,
                Vertical: 18,
            }
        } else if (valueDiagonal <= 3000) {

            tempObj = {
                Skin: 22,
                Horizontal: 110,
                Vertical: 22,
            }
        } else {

            tempObj = {
                Skin: 25,
                Horizontal: 110,
                Vertical: 24,
            }
        }

        // this.setState({ thicknessSHVObject: tempObj, diagonalWH: valueDiagonal })
        return tempObj;
    }

    horizontalRSCalcTableHoriz = (height) => {
        let indexTemp
        indexTemp = height <= 450 ? 0 : 10
        for (let i = 1; i <= 17; i++) {
            const range1 = horizontalWidthDataCompareB[i]
            const range2 = horizontalHeightDataCompareC[i]

            if (height > range1 && height <= range2) {
                indexTemp = i
            }
        }
        return horizontalHeightDataValueHoriz[indexTemp]
    }

    horizontalRSCalcTableVert = (width) => {
        let indexTemp
        indexTemp = width <= 450 ? 0 : 10
        for (let i = 1; i <= 17; i++) {
            const range1 = horizontalWidthDataCompareB[i]
            const range2 = horizontalHeightDataCompareC[i]

            if (width > range1 && width <= range2) {
                indexTemp = i
            }
        }

        return horizontalHeightDataValueVert[indexTemp]
    }

    horizontalRSCalcTable1 = (height) => {
        let indexTemp
        indexTemp = height <= 305 ? 0 : 18
        for (let i = 1; i <= 17; i++) {
            const range1 = horizontalRSDataCompare[i - 1]
            const range2 = horizontalRSDataCompare[i]

            if (height > range1 && height <= range2) {
                indexTemp = i
            }
        }

        return horizontalRSDataValue[indexTemp]
    }

    tensileStressCalc = () => {
        return this.state.factorOfSafetyDD === 'CUSTOM' ? Number(this.state.manufacturingMaterialObj.UTS) /
            Number(this.props.fieldObj.FOSValue) : Number(this.state.manufacturingMaterialObj.UTS) / 5
    }
    compressiveStressCalc = () => {
        return this.state.factorOfSafetyDD === 'CUSTOM' ? Number(this.state.manufacturingMaterialObj.CS) /
            Number(this.props.fieldObj.FOSValue) : Number(this.state.manufacturingMaterialObj.CS) / 5
    }

    calculationForCI = () => {
        // Table 1 Section A Start

        const { fieldObj, fieldObjShutter } = this.props
        const { horizontalSniffersSelect, manufacturingMaterialObj, selectHorizontalRib } = this.state

        // stemDiaField, selectHorizontalRib, manufacturingMaterial, hs1, hs2, hs3, hs4, hs5, hs6, hs7,
        // hs8, hs9, hs10, hs11, hs12, hs13, hs14, hs15, factorOfSafetyDD, horizontalStiffenersSection
        const ribDistanceL = horizontalSniffersSelect === 'A' ? Number(fieldObjShutter.height) / Number(fieldObj.hs5)
            : Number(fieldObjShutter.height) / Number(fieldObj.hs11)

        const diagonalVal = this.diagonalWidthHeightCalc()

        const tableVal10_3 = Number(fieldObj.hs3) + Number(fieldObj.hs4) - Number(fieldObj.hs3) * (2 * Number(fieldObj.hs2) + Number(fieldObj.hs1)) / (3 * (Number(fieldObj.hs1) + Number(fieldObj.hs2)))

        const tableVal11_3 = Math.pow(Number(fieldObj.hs3), 3) * (Math.pow(Number(fieldObj.hs1), 2) + 4 * Number(fieldObj.hs1) *
            Number(fieldObj.hs2) + Math.pow(Number(fieldObj.hs2), 2)) / (36 * (Number(fieldObj.hs1) + Number(fieldObj.hs2)))

        const tableVal7_5 = selectHorizontalRib === 'WITHOUT STEM HOLE' ? 0 : Number(fieldObj.hs4) + (Number(fieldObj.hs3) - this.calcOfQ431Back()) / 2

        const tableVal8_5 = selectHorizontalRib === 'WITHOUT STEM HOLE' ? 0 : Number(tableVal7_5) + Number(this.calcOfQ431Back())
        const tableVal3_5 = Number(fieldObj.hs2) - (Number(tableVal7_5) - Number(fieldObj.hs4)) / Number(fieldObj.hs3) * (Number(fieldObj.hs2) - Number(fieldObj.hs1))

        const tableVal2_5 = Number(fieldObj.hs2) - (tableVal8_5 - Number(fieldObj.hs4)) / Number(fieldObj.hs3) * (Number(fieldObj.hs2) - Number(fieldObj.hs1))

        const tableVal9_5 = selectHorizontalRib === 'WITHOUT STEM HOLE' ? 0 : (Number(tableVal8_5) - Number(tableVal7_5)) * (Number(tableVal2_5) + Number(tableVal3_5)) / 2 * (-1)

        const tableVal10_5 = selectHorizontalRib === 'WITHOUT STEM HOLE' ? 0 : (Number(tableVal7_5) + (Number(tableVal8_5) -
            Number(tableVal7_5)) * (2 * Number(tableVal3_5) + Number(tableVal2_5)) / (3 * (Number(tableVal2_5) + Number(tableVal3_5))))

        const tableVal11_5 = selectHorizontalRib === 'WITHOUT STEM HOLE' ? 0 : -Math.pow((Number(tableVal8_5) - Number(tableVal7_5)), 3)
            * (Math.pow(Number(tableVal2_5), 2) + 4 * Number(tableVal2_5) * Number(tableVal3_5) + Math.pow(Number(tableVal3_5), 2)) / (36 * (Number(tableVal2_5) + Number(tableVal3_5)))

        const tableVal9_6 = (Number(ribDistanceL) * Number(fieldObj.hs4)) + (Number(fieldObj.hs1) + Number(fieldObj.hs2)) / 2 * Number(fieldObj.hs3) + tableVal9_5

        const tableval10_6 = ((((Number(ribDistanceL) * Number(fieldObj.hs4)))) *
            (Number(fieldObj.hs4) / 2) + ((Number(fieldObj.hs1) + Number(fieldObj.hs2)) / 2 * Number(fieldObj.hs3))
            * tableVal10_3 + tableVal9_5 * tableVal10_5) / tableVal9_6

        let g, h, j
        g = Number(ribDistanceL) * Number(fieldObj.hs4)
        h = (Number(fieldObj.hs1) + Number(fieldObj.hs2)) / 2 * Number(fieldObj.hs3)
        j = Number(ribDistanceL) * Math.pow(Number(fieldObj.hs4), 3) / 12
        const tableVal11_6 = ((Number(fieldObj.hs4) / 2 - tableval10_6) * (Number(fieldObj.hs4) / 2 - tableval10_6) * g) +
            ((tableVal10_3 - tableval10_6) * (tableVal10_3 - tableval10_6) * h) +
            ((tableVal10_5 - tableval10_6) * (tableVal10_5 - tableval10_6) * tableVal9_5) + j + tableVal11_3 + tableVal11_5

        // Table 1 Section B Start

        const tableVal1B_5_2 = Number(fieldObjShutter.height) / Number(fieldObj.hs11)

        const tableVal1B_9_2 = Number(tableVal1B_5_2) * Number(fieldObj.hs9)

        const tableVal1B_10_2 = Number(fieldObj.hs9) / 2

        const tableVal1B_11_2 = Number(tableVal1B_5_2) * Math.pow(Number(fieldObj.hs9), 3) / 12

        const tableVal1B_9_3 = Number(fieldObj.hs8) * Number(fieldObj.hs10)

        const tableVal1B_10_3 = Number(fieldObj.hs9) + (Number(fieldObj.hs10) / 2)
        // =G16+E17/2
        // 9,10

        const tableVal1B_11_3 = Number(fieldObj.hs9) * Math.pow(Number(fieldObj.hs10), 3) / 12

        const tableVal1B_9_4 = Number(fieldObj.hs7) * Number(fieldObj.hs6)

        // =G16 + E17 + (C18 / 2)

        const tableVal1B_10_4 = Number(fieldObj.hs9) + Number(fieldObj.hs10) + (Number(fieldObj.hs7) / 2)
        // =F18*C18^3/12

        const tableVal1B_11_4 = Number(fieldObj.hs6) * Math.pow(Number(fieldObj.hs7), 3) / 12

        // =IF('1500x1500'!$O$70 = ":WITHOUT STEM HOLE !", 0, G16 + (E17 - '1500x1500'!Q431) / 2)

        const tableVal1B_7_5 = selectHorizontalRib === 'WITHOUT STEM HOLE' ? 0 : Number(fieldObj.hs9) + (Number(fieldObj.hs10) - Number(this.calcOfQ431Back())) / 2

        // =IF('1500x1500'!$O$70 = ":WITHOUT STEM HOLE !", 0, H19 + '1500x1500'!Q431)

        const tableVal1B_8_5 = selectHorizontalRib === 'WITHOUT STEM HOLE' ? 0 : Number(tableVal1B_7_5) + Number(this.calcOfQ431Back())

        const tableVal1B_9_5 = (Number(tableVal1B_8_5) - Number(tableVal1B_7_5)) * Number(fieldObj.hs8) * (-1)

        // =(I19 - H19) / 2 + H19

        const tableVal1B_10_5 = (tableVal1B_8_5 - tableVal1B_7_5) / 2 + tableVal1B_7_5

        const tableVal1B_11_5 = Number(fieldObj.hs8) * Math.pow((Number(tableVal1B_7_5) - Number(tableVal1B_8_5)), 3) / 12

        // =D19 * (H19 - I19) ^ 3 / 12

        const tableVal1B_9_6 = tableVal1B_9_5 + tableVal1B_9_4 + tableVal1B_9_3 + tableVal1B_9_2

        // =(J16*K16+J17*K17+J18*K18+J19*K19)/J20

        // =(J16*K16+J17*K17+J18*K18+J19*K19)/J20

        const tableVal1B_10_6 = (tableVal1B_9_2 * tableVal1B_10_2 + tableVal1B_9_3 * tableVal1B_10_3 + tableVal1B_9_4 * tableVal1B_10_4 + tableVal1B_9_5 * tableVal1B_10_5) / tableVal1B_9_6

        // a=(K16-K20)^2*J16+(K17-K20)^2*J17+(K18-K20)^2*J18+(K19-K20)^2*J19+L16+L17+L18+L19

        const tableVal1B_11_6 = Math.pow(Number(tableVal1B_10_2) - tableVal1B_10_6, 2) * tableVal1B_9_2 +
            Math.pow(tableVal1B_10_3 - tableVal1B_10_6, 2) * tableVal1B_9_3 +
            Math.pow(tableVal1B_10_4 - tableVal1B_10_6, 2) * tableVal1B_9_4 + Math.pow(tableVal1B_10_5 - tableVal1B_10_6, 2) * tableVal1B_9_5
            + tableVal1B_11_2 + tableVal1B_11_3 + tableVal1B_11_4 + tableVal1B_11_5

        const sectionMemberMOI = horizontalSniffersSelect === 'A' ? tableVal11_6 : tableVal1B_11_6

        const J6 = Number(ribDistanceL) * Number(fieldObj.hs4)
        const K6 = Number(fieldObj.hs4) / 2
        const J7 = (Number(fieldObj.hs1) + Number(fieldObj.hs2)) / 2 * Number(fieldObj.hs3)
        const K7 = tableVal10_3
        const L7 = tableVal11_3
        const L6 = Number(ribDistanceL) * Math.pow(Number(fieldObj.hs4), 3) / 12
        const val1 = (Math.pow(((J6 * K6 + J7 * K7) / (J6 + J7) - K6), 2) * J6 + Math.pow(K7 - (J6 * K6 + J7 * K7) / (J6 + J7), 2) * J7 + L7 + L6)

        const J16 = Number(tableVal1B_9_2)
        const K16 = Number(tableVal1B_10_2)
        const J17 = Number(tableVal1B_9_3)
        const K17 = Number(tableVal1B_10_3)
        const J18 = Number(tableVal1B_9_4)
        const K18 = Number(tableVal1B_10_4)
        const L17 = Number(tableVal1B_11_3)
        const L16 = Number(tableVal1B_11_2)
        const L18 = Number(tableVal1B_11_4)
        const val2 = (Math.pow((J16 * K16 + J17 * K17 + J18 * K18) / (J16 + J17 + J18) - K16, 2) * J16 + Math.pow(K17 - (J16 * K16 + J17 * K17 + J18 * K18) / (J16 + J17 + J18), 2) * J17 + Math.pow(K18 - (J16 * K16 + J17 * K17 + J18 * K18) / (J16 + J17 + J18), 2) * J18 + L17 + L16 + L18)

        const solidMemberMOI = horizontalSniffersSelect === 'A' ? val1 : val2
        const tempTensileSeating = horizontalSniffersSelect === 'A' ? tableval10_6 : tableVal1B_10_6
        const tensileSeating = sectionMemberMOI / tempTensileSeating

        const P85 = horizontalSniffersSelect === 'A' ? Number(fieldObj.hs3) : Number(fieldObj.hs10)
        const R84 = horizontalSniffersSelect === 'A' ? Number(fieldObj.hs4) : Number(fieldObj.hs9)
        const V88 = horizontalSniffersSelect === 'A' ? Number(tableval10_6) : Number(tableVal1B_10_6)
        const tempValue = horizontalSniffersSelect === 'A' ? (Number(P85) + Number(R84) - Number(V88)) : (Number(P85) + Number(fieldObj.hs7) + Number(R84) - Number(V88))
        const compressiveSeating = Number(sectionMemberMOI) / Number(tempValue)
        const U13 = (fieldObjShutter && fieldObjShutter.width) ? this.returnFieldInteger('width') / 1000 : 0
        const U16 = this.unseatingHeadCalculation() / 1000
        const Q84 = horizontalSniffersSelect === 'A' ? ribDistanceL : tableVal1B_5_2
        const seatingHeadTensileStress = Math.pow(U13, 2) * U16 * 9810.000 * Q84 / 8 / tensileSeating

        // =U13^2*U16*W189*Q84/8/R95
        const tem1 = Math.pow(U13, 2) * U16 * 9810.000 * Q84 / 8
        const seatingHeadCompressiveStress = tem1 / compressiveSeating
        // dddddddddd
        const U18 = ((fieldObjShutter.unseatingHead * 1000 + this.returnFieldInteger('height') / 2) / 1000)
        const unseatingHeadTensileStress = Math.pow(U13, 2) * U18 * 9810.000 * Q84 / 8 / tensileSeating

        const unseatingHeadCompressiveStress = Math.pow(U13, 2) * U18 * 9810.000 * Q84 / 8 / compressiveSeating
        const R28 = manufacturingMaterialObj.E

        const beamDeflectionMaxHead = U16 * 9810.000 * Q84 * 5 * Math.pow(U13, 4) * 1000000 / (384 * R28 * sectionMemberMOI)

        const actualDefLesser = Math.min(U13 * 1000 / 720, 1.6)
        const tempforRibThickness4A = fieldObjShutter.SelectedSeriesOffered === 'A-201-202-203 CAST IRON OPEN CHANNEL' || fieldObjShutter.SelectedSeriesOffered === 'A-301 CAST IRON WEIR GATE'
            ? 1 : 1.5

        const ribThickness4A = nextEvenNo(fieldObj.hs2 * tempforRibThickness4A)
        const E27 = fieldObj.hs3
        const G26 = fieldObj.hs4
        const D27 = ribThickness4A
        const C27 = ribThickness4A - 2
        const tableVal2A_10_3 = Number(E27) + Number(G26) - Number(E27) * (2 * Number(D27) + Number(C27)) / (3 * (Number(C27) + Number(D27)))
        const tableVal2A_11_3 = Math.pow(Number(E27), 3) * (Math.pow(Number(C27), 2) + 4 * Number(C27) * Number(D27) + Math.pow(Number(D27), 2)) / (36 * (Number(C27) + Number(D27)))

        const tableVal2A_7_5 = Number(G26) + (Number(E27) - Number(this.risingNonRisingStemDia())) / 2
        const tableVal2A_8_5 = Number(tableVal2A_7_5) + Number(this.risingNonRisingStemDia())
        const tableVal2A_2_5 = Number(D27) - (Number(tableVal2A_8_5) - Number(G26)) / Number(E27) * (Number(D27) - Number(C27))
        const tableVal2A_3_5 = D27 - (tableVal2A_7_5 - G26) / E27 * (D27 - C27)
        const tableVal2A_9_5 = (Number(tableVal2A_8_5) - Number(tableVal2A_7_5)) * (Number(tableVal2A_2_5) + Number(tableVal2A_3_5)) / 2 * (-1)

        const tableVal2A_10_5 = tableVal2A_7_5 + (tableVal2A_8_5 - tableVal2A_7_5) * (2 * tableVal2A_3_5 + tableVal2A_2_5) / (3 * (tableVal2A_2_5 + tableVal2A_3_5))
        //kkkkkkkkkkkkkkkkkk
        const tableVal2A_11_5 = -Math.pow(tableVal2A_8_5 - tableVal2A_7_5, 3) * (Math.pow(tableVal2A_2_5, 2) + 4 * tableVal2A_2_5 * tableVal2A_3_5 + Math.pow(tableVal2A_3_5, 2)) / (36 * (tableVal2A_2_5 + tableVal2A_3_5))

        const tableVal2A_9_6 = (Number(ribDistanceL) / 2) * Number(fieldObj.hs4) + ((Number(ribThickness4A) - 2) + Number(ribThickness4A)) / 2 * Number(fieldObj.hs3) + tableVal2A_9_5
        const J26 = (Number(ribDistanceL) / 2) * Number(fieldObj.hs4)
        const K26 = Number(fieldObj.hs4) / 2
        const J27 = ((Number(ribThickness4A) - 2) + Number(ribThickness4A)) / 2 * Number(fieldObj.hs3)
        const K27 = tableVal2A_10_3
        const J29 = tableVal2A_9_5
        const K29 = tableVal2A_10_5
        const J30 = tableVal2A_9_6
        const tableVal2A_10_6 = (J26 * K26 + J27 * K27 + J29 * K29) / J30

        const K30 = tableVal2A_10_6
        const L26 = (Number(ribDistanceL) / 2) * Math.pow(Number(fieldObj.hs4), 3) / 12
        const L27 = tableVal2A_11_3
        const L29 = tableVal2A_11_5
        const tableVal2A_11_6 = Math.pow(K26 - K30, 2) * J26 + Math.pow(K27 - K30, 2) * J27 + Math.pow(K29 - K30, 2) * J29 + L26 + L27 + L29

        // Table 2 B 
        const tableVal2B_5_2 = (fieldObjShutter.height / fieldObj.hs11) / 2

        const tableVal2B_6_2 = fieldObj.hs9

        const tableVal2B_9_2 = tableVal2B_5_2 * tableVal2B_6_2

        const tableVal2B_10_2 = tableVal2B_6_2 / 2

        const tableVal2B_11_2 = tableVal2B_5_2 * Math.pow(tableVal2B_6_2, 3) / 12

        const tableVal2B_3_3 = nextEvenNo(fieldObj.hs8 * 1.5)

        const tableVal2B_4_3 = fieldObj.hs10

        const tableVal2B_9_3 = tableVal2B_3_3 * tableVal2B_4_3

        const tableVal2B_10_3 = Number(tableVal2B_6_2) + (Number(tableVal2B_4_3) / 2)

        const tableVal2B_11_3 = tableVal2B_3_3 * Math.pow(tableVal2B_4_3, 3) / 12

        const tableVal2B_2_4 = nextEvenNo(fieldObj.hs8 * 1.5)

        const tableVal2B_5_4 = fieldObj.hs6

        const tableVal2B_9_4 = tableVal2B_2_4 * tableVal2B_5_4

        const tableVal2B_10_4 = Number(tableVal2B_6_2) + Number(tableVal2B_4_3) + (Number(tableVal2B_2_4) / 2)

        const tableVal2B_11_4 = Number(tableVal2B_5_4) * Math.pow(Number(tableVal2B_2_4), 3) / 12

        const tableVal2B_3_5 = tableVal2B_3_3
        // = G36 + (E37 - '1500x1500'!R432)/2
        const tableVal2B_7_5 = Number(tableVal2B_6_2) + (Number(tableVal2B_4_3) - Number(this.risingNonRisingStemDia())) / 2

        const tableVal2B_8_5 = Number(tableVal2B_7_5) + Number(this.risingNonRisingStemDia())

        const tableVal2B_9_5 = (Number(tableVal2B_8_5) - Number(tableVal2B_7_5)) * Number(tableVal2B_3_5) * (-1)

        const tableVal2B_10_5 = (Number(tableVal2B_8_5) - Number(tableVal2B_7_5)) / 2 + Number(tableVal2B_7_5)

        const tableVal2B_11_5 = Number(tableVal2B_3_5) * Math.pow(Number(tableVal2B_7_5) - Number(tableVal2B_8_5), 3) / 12

        const tableVal2B_9_6 = Number(tableVal2B_9_2) + Number(tableVal2B_9_3) + Number(tableVal2B_9_4) + Number(tableVal2B_9_5)

        const tableVal2B_10_6 = (Number(tableVal2B_9_2) * Number(tableVal2B_10_2) +
            Number(tableVal2B_9_3) * Number(tableVal2B_10_3) + Number(tableVal2B_9_4) * Number(tableVal2B_10_4) +
            Number(tableVal2B_9_5) * Number(tableVal2B_10_5)) / Number(tableVal2B_9_6)

        const tableVal2B_11_6 = Math.pow(Number(tableVal2B_10_2) - Number(tableVal2B_10_6), 2) * Number(tableVal2B_9_2) +
            Math.pow(Number(tableVal2B_10_3) - Number(tableVal2B_10_6), 2) * Number(tableVal2B_9_3)
            + Math.pow(Number(tableVal2B_10_4) - Number(tableVal2B_10_6), 2) * Number(tableVal2B_9_4) + Math.pow(Number(tableVal2B_10_5) -
                Number(tableVal2B_10_6), 2) * Number(tableVal2B_9_5)
            + Number(tableVal2B_11_2) + Number(tableVal2B_11_3) + Number(tableVal2B_11_4) + Number(tableVal2B_11_5)


        const section2Val1 = horizontalSniffersSelect === 'A' ? tableVal2A_11_6 : tableVal2B_11_6

        const tempValB1 = Math.pow((Number(J26) * Number(K26) + Number(J27) * Number(K27)) /
            (Number(J26) + Number(J27)) - Number(K26), 2) * Number(J26) + Math.pow(Number(K27) -
                (Number(J26) * Number(K26) + Number(J27) * Number(K27)) / (Number(J26) + Number(J27)), 2) * Number(J27) +
            Number(L27) + Number(L26)
        const J36 = Number(tableVal2B_9_2)
        const K36 = Number(tableVal2B_10_2)
        const J37 = Number(tableVal2B_9_3)
        const K37 = Number(tableVal2B_10_3)
        const J38 = Number(tableVal2B_9_4)
        const K38 = Number(tableVal2B_10_4)
        const L36 = Number(tableVal2B_11_2)
        const L37 = Number(tableVal2B_11_3)
        const L38 = Number(tableVal2B_11_4)

        const tempValB2 = (Math.pow((J36 * K36 + J37 * K37 + J38 * K38) / (J36 + J37 + J38) - K36, 2) * J36 +
            Math.pow(K37 - (J36 * K36 + J37 * K37 + J38 * K38) / (J36 + J37 + J38), 2) * J37 +
            Math.pow(K38 - (J36 * K36 + J37 * K37 + J38 * K38) / (J36 + J37 + J38), 2) * J38 + L37 + L36 + L38)
        const section2Val2 = horizontalSniffersSelect === 'A' ? tempValB1 : tempValB2
        const V181 = horizontalSniffersSelect === 'A' ? tableVal2A_10_6 : tableVal2B_10_6
        const tensileSeatingTable2 = section2Val1 / V181

        const P178 = horizontalSniffersSelect === 'A' ? fieldObj.hs3 : tableVal2B_4_3
        const R177 = horizontalSniffersSelect === 'A' ? fieldObj.hs4 : tableVal2B_6_2
        const N179 = tableVal2B_2_4
        const tempcompressiveSeatingTable2 = horizontalSniffersSelect === 'A' ? (Number(P178) + Number(R177) - Number(V181)) : (Number(P178) + Number(N179) + Number(R177) - Number(V181))
        const compressiveSeatingTable2 = Number(section2Val1) / Number(tempcompressiveSeatingTable2)

        // const U13 = this.returnFieldInteger('width') / 1000
        // const U16 = this.unseatingHeadCalculation() / 1000
        const Q177 = horizontalSniffersSelect === 'A' ? (ribDistanceL / 2) : tableVal2B_5_2
        const R187 = tensileSeatingTable2
        const W189 = 9810.000
        const R188 = compressiveSeatingTable2

        const seatingHeadTensileStressTable2 = Math.pow(U13, 2) * U16 * Q177 / 8 / R187 * W189

        const seatingHeadCompressiveStressTable2 = Math.pow(U13, 2) * U16 * W189 * Q177 / 8 / R188

        const unseatingHeadCompressiveStressTable2 = Math.pow(U13, 2) * U18 * W189 * Q177 / 8 / R188

        const unseatingHeadTensileStressTable2 = Math.pow(U13, 2) * U18 * W189 * Q177 / 8 / R187
        const R184 = section2Val1
        const beamDeflectionMaxHeadTable2 = (U16) * W189 * Q177 * 5 * Math.pow(U13, 4) * 1000000 / (384 * R28 * R184)

        const actualDefLesserTabl2 = Math.min(U13 * 1000 / 720, 1.6)

        const tableVal5_5_2 = this.returnFieldInteger('width') / fieldObj.hs15
        const tableVal5_6_2 = horizontalSniffersSelect === 'A' ? fieldObj.hs4 : fieldObj.hs9
        const tableVal5_9_2 = tableVal5_5_2 * tableVal5_6_2
        const tableVal5_10_2 = tableVal5_6_2 / 2
        const tableVal5_11_2 = tableVal5_5_2 * Math.pow(tableVal5_6_2, 3) / 12
        const tableVal5_2_3 = fieldObj.hs12
        const tableVal5_3_3 = fieldObj.hs13
        const tableVal5_4_3 = fieldObj.hs14
        const tableVal5_9_3 = (Number(tableVal5_2_3) + Number(tableVal5_3_3)) / 2 * Number(tableVal5_4_3)
        const tableVal5_10_3 = Number(tableVal5_4_3) + Number(tableVal5_6_2) - Number(tableVal5_4_3) * (2 * Number(tableVal5_3_3) + Number(tableVal5_2_3)) / (3 * (Number(tableVal5_2_3) + Number(tableVal5_3_3)))
        const tableVal5_11_3 = Math.pow(Number(tableVal5_4_3), 3) * (Math.pow(Number(tableVal5_2_3), 2) + 4 * Number(tableVal5_2_3) * Number(tableVal5_3_3) + Math.pow(Number(tableVal5_3_3), 2)) / (36 * (Number(tableVal5_2_3) + Number(tableVal5_3_3)))
        const tableVal5_9_6 = Number(tableVal5_9_2) + Number(tableVal5_9_3)
        const tableVal5_10_6 = (Number(tableVal5_9_2) * Number(tableVal5_10_2) + Number(tableVal5_9_3) * Number(tableVal5_10_3)) / Number(tableVal5_9_6)
        const tableVal5_11_6 = Math.pow(Number(tableVal5_10_2) - Number(tableVal5_10_6), 2) * Number(tableVal5_9_2) + Math.pow(Number(tableVal5_10_3) - Number(tableVal5_10_6), 2) * Number(tableVal5_9_3) + Number(tableVal5_11_2) + Number(tableVal5_11_3)

        const U15 = fieldObjShutter.seatingHead
        const U17 = fieldObjShutter.unseatingHead
        const seatingHeadTensileStress_5 = (Number(Q177) / 1000) * Number(U13) * Number(U15) * 9810.00 * Number(tableVal5_5_2) / 12 / (Number(tableVal5_11_6) / Number(tableVal5_10_6))
        const R269 = Number(tableVal5_11_6) / (Number(tableVal5_4_3) + Number(tableVal5_6_2) - Number(tableVal5_10_6))
        const seatingHeadCompressiveStress_5 = (Number(Q84) / 1000) * Number(U13) * Number(U15) * 9810.00 * Number(tableVal5_5_2) / 12 / Number(R269)

        const unseatingHeadCompressiveStress_5 = (Number(Q84) / 1000) * Number(U13) * Number(U17) * 9810.00 * Number(tableVal5_5_2) / 12 / Number(R269)
        const R268 = Number(tableVal5_11_6) / Number(tableVal5_10_6)
        const unseatingHeadTensileStress_5 = (Number(Q84) / 1000) * Number(U13) * Number(U17) * 9810.00 * Number(tableVal5_5_2) / 12 / Number(R268)

        const beamDeflectionMaxHead_5 = Number(U16) * 9810 * Number(tableVal5_5_2) * Math.pow(Number(Q84) / 1000, 4) * 1000000 / (384 * Number(R28) * Number(tableVal5_11_6))
        const actualDefLesser_5 = Math.min(U13 * 1000 / 720, 1.6)

        //3 weight formula

        const horizRibThickWeb_M3 = horizontalSniffersSelect === 'A' ? (fieldObj.hs2) : fieldObj.hs8
        const horizontalRibsHeightValue = horizontalSniffersSelect === 'A' ? (fieldObj.hs3) : (fieldObj.hs5)
        const horizRibsHeightVal_M3 = horizontalSniffersSelect === 'A' ? (fieldObj.hs3) : (fieldObj.hs10)

        const horizoncalRibsQuantityVal_M = (fieldObjShutter.height / ribDistanceL) + 1
        const verticalRibsQuantityVal_M = (fieldObjShutter.width / (this.returnFieldInteger('width') / fieldObj.hs15)) + 1


        // =IF(Q72="A",(horizRibThickWeb_M3*horizRibsHeightVal_M3)*7250/10^6,((horizRibThickWeb_M3*horizRibsHeightVal_M3)+(fieldObj.hs7*fieldObj.hs6))*7250/10^6)

        // =IF(Q72="A",(T303*T306)*7250/10^6,((T303*T306)+(T304*U74))*7250/10^6)

        const weightOfHRibsEBR = horizontalSniffersSelect === 'A' ? (Number(horizRibThickWeb_M3) * Number(horizRibsHeightVal_M3)) * 7250 / 1000000 :
            ((Number(horizRibThickWeb_M3) * Number(horizRibsHeightVal_M3)) + (Number(fieldObj.hs7) * Number(fieldObj.hs6))) * 7250 / 1000000
        const weightOfHRibsEBR_2 = weightOfHRibsEBR * (horizoncalRibsQuantityVal_M - 2) * fieldObjShutter.width / 1000


        const weightOfHTopBottomRib = horizontalSniffersSelect === 'A' ? (ribThickness4A * horizRibsHeightVal_M3) * 7250 / 1000000 :
            ((nextEvenNo(fieldObj.hs8 * 1.5) * horizRibsHeightVal_M3) + (fieldObj.hs6 * nextEvenNo(fieldObj.hs8 * 1.5))) * 7250 / 1000000

        const weightOfHTopBottomRib_2 = weightOfHTopBottomRib * 2 * fieldObjShutter.width / 1000

        const weightOfVRibs = ((fieldObj.hs13) * (fieldObj.hs14)) * 7250 / 1000000
        const weightOfVRibs_2 = weightOfVRibs * (verticalRibsQuantityVal_M * fieldObjShutter.height) / 1000


        // const weightOfSideWedges = ((this.sizeOfSideWedges()) + 25) * 100 * S370 * 2 * 7.25 / 1000000
        // weightOfSideWedges_2

        const weightOfShutter = Number(this.weightOfSkinPlate_2()) + Number(weightOfHRibsEBR_2) + Number(weightOfHTopBottomRib_2) + Number(weightOfVRibs_2) + Number(this.weightOfSideWedges()) * Number(this.noOfSideWedges()) + Number(this.weightOfDoor3_2())
        const shutterThicknessSection5 = tableVal5_6_2
        const values = []

        values.ribDistanceL = ribDistanceL
        values.diagonalVal = diagonalVal
        values.tableVal10_3 = tableVal10_3
        values.tableVal11_3 = tableVal11_3
        values.tableVal7_5 = tableVal7_5
        values.tableVal8_5 = tableVal8_5
        values.tableVal3_5 = tableVal3_5
        values.tableVal2_5 = tableVal2_5
        values.tableVal9_5 = tableVal9_5
        values.tableVal10_5 = tableVal10_5
        values.tableVal11_5 = tableVal11_5
        values.tableVal9_6 = tableVal9_6
        values.tableval10_6 = tableval10_6
        values.tableVal11_6 = tableVal11_6
        values.tableVal1B_5_2 = tableVal1B_5_2
        values.tableVal1B_9_2 = tableVal1B_9_2
        values.tableVal1B_10_2 = tableVal1B_10_2
        values.tableVal1B_11_2 = tableVal1B_11_2
        values.tableVal1B_9_3 = tableVal1B_9_3
        values.tableVal1B_10_3 = tableVal1B_10_3
        values.tableVal1B_11_3 = tableVal1B_11_3
        values.tableVal1B_9_4 = tableVal1B_9_4
        values.tableVal1B_10_4 = tableVal1B_10_4
        values.tableVal1B_11_4 = tableVal1B_11_4
        values.tableVal1B_7_5 = tableVal1B_7_5
        values.tableVal1B_8_5 = tableVal1B_8_5
        values.tableVal1B_9_5 = tableVal1B_9_5
        values.tableVal1B_10_5 = tableVal1B_10_5
        values.tableVal1B_11_5 = tableVal1B_11_5
        values.tableVal1B_9_6 = tableVal1B_9_6
        values.tableVal1B_10_6 = tableVal1B_10_6
        values.tableVal1B_11_6 = tableVal1B_11_6
        values.sectionMemberMOI = sectionMemberMOI
        values.val1 = val1
        values.val2 = val2
        values.solidMemberMOI = solidMemberMOI
        values.tempTensileSeating = tempTensileSeating
        values.tensileSeating = tensileSeating
        values.compressiveSeating = compressiveSeating
        values.seatingHeadTensileStress = seatingHeadTensileStress
        values.seatingHeadCompressiveStress = seatingHeadCompressiveStress
        values.unseatingHeadTensileStress = unseatingHeadTensileStress
        values.unseatingHeadCompressiveStress = unseatingHeadCompressiveStress
        values.R28 = R28
        values.beamDeflectionMaxHead = beamDeflectionMaxHead
        values.actualDefLesser = actualDefLesser
        values.tempforRibThickness4A = tempforRibThickness4A
        values.ribThickness4A = ribThickness4A
        values.tableVal2A_10_3 = tableVal2A_10_3
        values.tableVal2A_11_3 = tableVal2A_11_3
        values.tableVal2A_7_5 = tableVal2A_7_5
        values.tableVal2A_8_5 = tableVal2A_8_5
        values.tableVal2A_2_5 = tableVal2A_2_5
        values.tableVal2A_3_5 = tableVal2A_3_5
        values.tableVal2A_9_5 = tableVal2A_9_5
        values.tableVal2A_10_5 = tableVal2A_10_5
        values.tableVal2A_11_5 = tableVal2A_11_5
        values.tableVal2A_9_6 = tableVal2A_9_6
        values.tableVal2A_10_6 = tableVal2A_10_6
        values.tableVal2A_11_6 = tableVal2A_11_6
        values.tableVal2B_5_2 = tableVal2B_5_2
        values.tableVal2B_6_2 = tableVal2B_6_2
        values.tableVal2B_9_2 = tableVal2B_9_2
        values.tableVal2B_10_2 = tableVal2B_10_2
        values.tableVal2B_11_2 = tableVal2B_11_2
        values.tableVal2B_3_3 = tableVal2B_3_3
        values.tableVal2B_4_3 = tableVal2B_4_3
        values.tableVal2B_9_3 = tableVal2B_9_3
        values.tableVal2B_10_3 = tableVal2B_10_3
        values.tableVal2B_11_3 = tableVal2B_11_3
        values.tableVal2B_2_4 = tableVal2B_2_4
        values.tableVal2B_5_4 = tableVal2B_5_4
        values.tableVal2B_9_4 = tableVal2B_9_4
        values.tableVal2B_10_4 = tableVal2B_10_4
        values.tableVal2B_11_4 = tableVal2B_11_4
        values.tableVal2B_3_5 = tableVal2B_3_5
        values.tableVal2B_7_5 = tableVal2B_7_5
        values.tableVal2B_8_5 = tableVal2B_8_5
        values.tableVal2B_9_5 = tableVal2B_9_5
        values.tableVal2B_10_5 = tableVal2B_10_5
        values.tableVal2B_11_5 = tableVal2B_11_5
        values.tableVal2B_9_6 = tableVal2B_9_6
        values.tableVal2B_10_6 = tableVal2B_10_6
        values.tableVal2B_11_6 = tableVal2B_11_6
        values.section2Val1 = section2Val1
        values.tempValB1 = tempValB1
        values.tempValB2 = tempValB2
        values.section2Val2 = section2Val2
        values.tensileSeatingTable2 = tensileSeatingTable2
        values.tempcompressiveSeatingTable2 = tempcompressiveSeatingTable2
        values.compressiveSeatingTable2 = compressiveSeatingTable2
        values.seatingHeadTensileStressTable2 = seatingHeadTensileStressTable2
        values.seatingHeadCompressiveStressTable2 = seatingHeadCompressiveStressTable2
        values.unseatingHeadCompressiveStressTable2 = unseatingHeadCompressiveStressTable2
        values.unseatingHeadTensileStressTable2 = unseatingHeadTensileStressTable2
        values.beamDeflectionMaxHeadTable2 = beamDeflectionMaxHeadTable2
        values.actualDefLesserTabl2 = actualDefLesserTabl2
        values.tableVal5_5_2 = tableVal5_5_2
        values.tableVal5_6_2 = tableVal5_6_2
        values.tableVal5_9_2 = tableVal5_9_2
        values.tableVal5_10_2 = tableVal5_10_2
        values.tableVal5_11_2 = tableVal5_11_2
        values.tableVal5_2_3 = tableVal5_2_3
        values.tableVal5_3_3 = tableVal5_3_3
        values.tableVal5_4_3 = tableVal5_4_3
        values.tableVal5_9_3 = tableVal5_9_3
        values.tableVal5_10_3 = tableVal5_10_3
        values.tableVal5_11_3 = tableVal5_11_3
        values.tableVal5_9_6 = tableVal5_9_6
        values.tableVal5_10_6 = tableVal5_10_6
        values.tableVal5_11_6 = tableVal5_11_6
        values.seatingHeadTensileStress_5 = seatingHeadTensileStress_5
        values.seatingHeadCompressiveStress_5 = seatingHeadCompressiveStress_5
        values.unseatingHeadCompressiveStress_5 = unseatingHeadCompressiveStress_5
        values.unseatingHeadTensileStress_5 = unseatingHeadTensileStress_5
        values.beamDeflectionMaxHead_5 = beamDeflectionMaxHead_5
        values.actualDefLesser_5 = actualDefLesser_5
        values.horizRibThickWeb_M3 = horizRibThickWeb_M3
        values.horizontalRibsHeightValue = horizontalRibsHeightValue
        values.horizRibsHeightVal_M3 = horizRibsHeightVal_M3
        values.horizoncalRibsQuantityVal_M = horizoncalRibsQuantityVal_M
        values.verticalRibsQuantityVal_M = verticalRibsQuantityVal_M
        values.weightOfHRibsEBR = weightOfHRibsEBR
        values.weightOfHRibsEBR_2 = weightOfHRibsEBR_2
        values.weightOfHTopBottomRib = weightOfHTopBottomRib
        values.weightOfHTopBottomRib_2 = weightOfHTopBottomRib_2
        values.weightOfVRibs = weightOfVRibs
        values.weightOfVRibs_2 = weightOfVRibs_2
        values.weightOfShutter = weightOfShutter
        values.shutterThicknessSection5 = shutterThicknessSection5
        return values
    }

    render() {
        const { handleSubmit, fieldObj, isEditFlag, isViewFlag, fieldObjShutter } = this.props;
        const {
            isLoader,
            manufacturingMaterialObj,
            currentSelectedMaterial,
            selectedSeriesOffered,
            modal,
            activeActuation,
            selectHorizontalRib,
            horizontalSniffersSelect } = this.state;
        fieldObj.Value = this.Value();
        fieldObj.vertiRibsHeight = this.verticalRibsHeight();
        const values = this.calculationForCI()
        const { ribDistanceL, diagonalVal, tableVal10_3, tableVal11_3, tableVal7_5, tableVal8_5, tableVal3_5, tableVal2_5,
            tableVal9_5, tableVal10_5, tableVal11_5, tableVal9_6, tableval10_6, tableVal11_6, tableVal1B_5_2, tableVal1B_9_2,
            tableVal1B_10_2, tableVal1B_11_2, tableVal1B_9_3, tableVal1B_10_3, tableVal1B_11_3, tableVal1B_9_4, tableVal1B_10_4,
            tableVal1B_11_4, tableVal1B_7_5, tableVal1B_8_5, tableVal1B_9_5, tableVal1B_10_5, tableVal1B_11_5, tableVal1B_9_6,
            tableVal1B_10_6, tableVal1B_11_6, sectionMemberMOI, solidMemberMOI, tensileSeating,
            compressiveSeating, seatingHeadTensileStress, seatingHeadCompressiveStress, unseatingHeadTensileStress,
            unseatingHeadCompressiveStress, beamDeflectionMaxHead, actualDefLesser, ribThickness4A,
            tableVal2A_10_3, tableVal2A_11_3, tableVal2A_7_5, tableVal2A_8_5, tableVal2A_2_5, tableVal2A_3_5, tableVal2A_9_5,
            tableVal2A_10_5, tableVal2A_11_5, tableVal2A_9_6, tableVal2A_10_6, tableVal2A_11_6, tableVal2B_5_2, tableVal2B_6_2,
            tableVal2B_9_2, tableVal2B_10_2, tableVal2B_11_2, tableVal2B_3_3, tableVal2B_4_3, tableVal2B_9_3, tableVal2B_10_3,
            tableVal2B_11_3, tableVal2B_2_4, tableVal2B_5_4, tableVal2B_9_4, tableVal2B_10_4, tableVal2B_11_4, tableVal2B_3_5,
            tableVal2B_7_5, tableVal2B_8_5, tableVal2B_9_5, tableVal2B_10_5, tableVal2B_11_5, tableVal2B_9_6, tableVal2B_10_6,
            tableVal2B_11_6, section2Val1, section2Val2, tensileSeatingTable2,
            compressiveSeatingTable2, seatingHeadTensileStressTable2, seatingHeadCompressiveStressTable2,
            unseatingHeadCompressiveStressTable2, unseatingHeadTensileStressTable2, beamDeflectionMaxHeadTable2, actualDefLesserTabl2,
            tableVal5_5_2, tableVal5_6_2, tableVal5_9_2, tableVal5_10_2, tableVal5_11_2, tableVal5_2_3, tableVal5_3_3, tableVal5_4_3,
            tableVal5_9_3, tableVal5_10_3, tableVal5_11_3, tableVal5_9_6, tableVal5_10_6, tableVal5_11_6, seatingHeadTensileStress_5,
            seatingHeadCompressiveStress_5, unseatingHeadCompressiveStress_5, unseatingHeadTensileStress_5, beamDeflectionMaxHead_5,
            actualDefLesser_5, shutterThicknessSection5 } = values

        const materialManufacturedAdjacentText = fieldObj.manufacturingMaterial === '4' ?
            ' / IS 1865 SG400' : fieldObj.manufacturingMaterial === '5' ?
                ' / IS 1865 SG500/7' : ''

        //first value
        let X25, X26, firstVal, tempP, tempA, secondValue, con1, con2, minOfCon1_2, finalValueShearStress, val23Shear//,
        if (this.state.factorOfSafetyDD === "STANDARD") {
            X26 = 1
        } else { X26 = 0 }
        if (this.state.factorOfSafetyDD === "CUSTOM") {
            X25 = 1
        }
        else {
            X25 = 0
        }
        //here
        // 0  3  1
        // =IF(M21=M421,0.25,IF(M21=M422,0.2,IF(M21=M423,0.75,0.4)))*X26+(1/W28)*X25
        if (fieldObj.referenceDocuments === '0') {
            tempP = 0.25
        } else if (fieldObj.referenceDocuments === '3') {
            tempP = 0.20
        } else if (fieldObj.referenceDocuments === '1') {
            tempP = 0.75
        } else {
            tempP = 0.4
        }
        let calcfos1, calcfos2, calcfos3

        if (this.state.factorOfSafetyDD === "STANDARD") {
            calcfos1 = 2
            calcfos2 = 2
            calcfos3 = 5
        } else {
            calcfos1 = fieldObj.FOS1
            calcfos2 = fieldObj.FOS2
        }

        firstVal = Number(tempP) * Number(X26) + (1 / Number(calcfos1)) * Number(X25)


        // second value
        // =IF(M21 = M421, 0.5, IF(M21 = M422, 0.33, IF(M21 = M423, 0.75, 0.4))) * X26 + (1 / W29) * X25

        if (String(fieldObj.referenceDocuments) === '0') {
            tempA = 0.5
        } else if (String(fieldObj.referenceDocuments) === '3') {
            tempA = 0.33
        } else if (String(fieldObj.referenceDocuments) === '1') {
            tempA = 0.75
        } else {
            tempA = 0.4
        }
        secondValue = Number(tempA) * Number(X26) + (1 / Number(calcfos2)) * Number(X25)

        con1 = Number(manufacturingMaterialObj.UTS) * Number(firstVal)
        con2 = Number(manufacturingMaterialObj.YS) * Number(secondValue)
        minOfCon1_2 = Number(con1) < Number(con2) ? Number(con1) : Number(con2)
        finalValueShearStress = Number(minOfCon1_2) === Number(con1) ? Number(firstVal) : Number(secondValue)
        val23Shear = Number(minOfCon1_2) === Number(con1) ? Number(manufacturingMaterialObj.UTS) : Number(manufacturingMaterialObj.YS)
        shearstressObj = Number(finalValueShearStress) * Number(val23Shear)

        return (
            <div class="card-body">
                <Modal isOpen={modal}>
                    <ModalHeader>Success</ModalHeader>
                    <ModalBody>
                        {`Shutter Design data successfully ${isEditFlag ? 'updated' : 'saved'}. Continue editing with ${activeActuation === 'MANUAL' ? 'Manual' : 'Elecetical'} design and Yoke design.`}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => this.props.toggle(fieldObj.Actuation === 'MANUAL' ? '3' : '4')}>Continue</Button>{' '}
                    </ModalFooter>
                </Modal>
                {isLoader && <Loader />}
                <Container fluid className="cr-shutter-container cr-table-wrap">
                    <div className="shutter-design cr-collaps-wrap">
                        {/* <div className="form-heading">
                            <h2>Shutter Design</h2>
                        </div> */}
                        <form
                            noValidate
                            className="form"
                            autoComplete="off"
                            onSubmit={handleSubmit(this.onSubmit.bind(this))}
                            onKeyPress={(e) => onKeyPress(e)}
                        >
                            {
                                selectedSeriesOffered !== 'A-111' && selectedSeriesOffered !== 'A-112' &&
                                <div>
                                    <Row className={'mb-3'}>
                                        <Col>
                                            <div className={''}>
                                                {/* <div className={'collaps-head card-header'} onClick={this.stageTwoController}>
                                                    <h3>Stage Two</h3>
                                                </div> */}
                                                {/* {this.state.stageTwoOpen && */}
                                                <div className={''}>
                                                    <h4>DESIGN CALCULATION FOR SHUTTER  / GATE LEAF / STOPLOG </h4>
                                                    {/* *************DESIGN DATA************* */}
                                                    <hr className={'mb-4 pb-1'} />
                                                    <Row className={'mb-3 mt-4'}>
                                                        <Col md="12">
                                                            <div className={'page-heads'}>
                                                                1). DESIGN DATA: -
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'a).    Width of opening'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="3">
                                                            <p>{fieldObjShutter && fieldObjShutter.width ? checkForNull(this.returnFieldInteger('width')).toFixed(0) : 0} {'mm'}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{fieldObjShutter && fieldObjShutter.width ? `${checkForNull(this.returnFieldInteger('width') / 1000).toFixed(2)} m` : 0}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'b). Height of opening'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="3">
                                                            <p>{fieldObjShutter && fieldObjShutter.height ? checkForNull(this.returnFieldInteger('height')).toFixed(0) : 0} {'mm'}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{fieldObjShutter && fieldObjShutter.height ? `${checkForNull(this.returnFieldInteger('height') / 1000).toFixed(2)} m` : 0}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'c)  Design seating head'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="3">
                                                            <p>{checkForNull(fieldObjShutter.seatingHead * 1000)} {'mm'}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${(checkForNull(fieldObjShutter.seatingHead)).toFixed(3)} m`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'d)   Seating Head on bottom rib'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="3">
                                                            <p>{checkForNull(this.unseatingHeadCalculation())} {'mm'} </p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(this.unseatingHeadCalculation() / 1000).toFixed(3)} m`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'e)   Design unseating head'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="3">
                                                            <p>{(fieldObjShutter && fieldObjShutter.unseatingHead && fieldObjShutter.seatingHead) ? checkForNull(fieldObjShutter.unseatingHead * 1000).toFixed(0) : 0} {'mm'}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{(fieldObjShutter && fieldObjShutter.unseatingHead && fieldObjShutter.seatingHead) ? `${checkForNull(fieldObjShutter.unseatingHead).toFixed(3)} m` : 0}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'f)   Unseating Head on bottom rib'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="3">
                                                            <p>{(fieldObjShutter && fieldObjShutter.unseatingHead && fieldObjShutter.seatingHead) ? checkForNull((fieldObjShutter.unseatingHead * 1000 + this.returnFieldInteger('height') / 2)).toFixed(0) : 0} {'mm'}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{(fieldObjShutter && fieldObjShutter.unseatingHead && fieldObjShutter.seatingHead) ? `${checkForNull((fieldObjShutter.unseatingHead * 1000 + this.returnFieldInteger('height') / 2) / 1000).toFixed(3)} m` : 0}</p>
                                                        </Col>
                                                    </Row>
                                                    {/* *************MATERIAL SPECIFICATION AND PERMISSIBLE STRESSES************* */}
                                                    <hr />
                                                    <Row className={'mb-3 mt-4'}>
                                                        <Col md="7">
                                                            <div className={'page-heads'}>
                                                                2). MATERIAL SPECIFICATION AND PERMISSIBLE STRESSES: -
                                                            </div>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>
                                                                {fieldObjShutter.applicableStandard === 'AWWA-C560' ?
                                                                    'Reference Documents : AWWA C-560 code of practice for Shutter.' :
                                                                    fieldObjShutter.applicableStandard === 'BS-7775' ?
                                                                        'Reference Documents : BS 7775 code of practice for Shutter.' :
                                                                        'Reference Documents : IS 13349 code of practice for Shutter.'
                                                                }
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb15 none-label'}>
                                                        <Col md="5" className="cr-mm-dimension">{'Material used for manufacturing:'}<span class="asterisk-required">*</span></Col>
                                                        <Col md="2" className="cr-mm-dimension text-right">{'='}</Col>
                                                        <Col md="5" className="max-width-container">
                                                            <Field
                                                                label={``}
                                                                name={"manufacturingMaterial"}
                                                                type="text"
                                                                placeholder={'----- Select -----'}
                                                                validate={[required]}
                                                                required={true}
                                                                options={manufacturingMaterialOption}
                                                                onChange={this.handleManufacturingMaterial}
                                                                optionValue={'Value'}
                                                                optionLabel={'Text'}
                                                                component={renderSelectField}
                                                                className=" custom-select"
                                                                customClassName=" withoutBorderBottom"
                                                                readOnly={isViewFlag}
                                                                disabled={isViewFlag}
                                                                valueDescription={currentSelectedMaterial}
                                                            /> <span className="unit-display">{materialManufacturedAdjacentText}</span>
                                                        </Col>


                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>{'The above selected material is used for skin plate, vertical stiffeners and horizontal stiffener of Shutter and have following strength :'}</p>
                                                        </Col>
                                                    </Row>


                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Ultimate tensile strength '}</p> */}
                                                        </Col>
                                                        {/* <Col md="2" className='text-right'>
                                                            <p>{'Factor Of Safety = '}</p>
                                                        </Col> */}
                                                        {/* <Col md="2">
                                                            <div>
                                                                <Field
                                                                    label={``}
                                                                    name={"factorOfSafetyDD"}
                                                                    type="text"
                                                                    placeholder={'----- Select -----'}
                                                                    validate={[required]}
                                                                    required={true}
                                                                    options={factorOfSafety}
                                                                    onChange={this.handlefactorOfSafetyDD}
                                                                    optionValue={'Value'}
                                                                    optionLabel={'Text'}
                                                                    component={renderSelectField}
                                                                    className=" custom-select"
                                                                    customClassName=" withoutBorderBottom"
                                                                    readOnly={isViewFlag}
                                                                    disabled={isViewFlag}
                                                                /></div>
                                                        </Col> */}
                                                        {/* <Col md="3">
                                                            {this.state.factorOfSafetyDD == "CUSTOM" &&
                                                                <div>
                                                                    FOS
                                                                </div>
                                                            }
                                                        </Col> */}
                                                    </Row>


                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Ultimate tensile strength '}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`TS = `}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${manufacturingMaterialObj.UTS * 1} Mpa`}</p>
                                                        </Col>
                                                        <Col md="3">
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Ultimate Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'CS = '}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${manufacturingMaterialObj.CS * 1} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Modulus of Elasticity '}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'E = '}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${manufacturingMaterialObj.E} Mpa`}</p>
                                                        </Col>
                                                        <Col md="3">
                                                            {/* {this.state.factorOfSafetyDD == "CUSTOM" &&
                                                                <div>
                                                                    <Field
                                                                        label={``}
                                                                        name={"FOS3"}
                                                                        type="text"
                                                                        placeholder={''}
                                                                        // validate={[required]}
                                                                        component={renderText}
                                                                        required={true}
                                                                        className={''}
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                    />
                                                                </div>
                                                            } */}
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Factor of Safety'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'FS = '}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            {this.state.factorOfSafetyDD === "CUSTOM" ?
                                                                <div>
                                                                    <Field
                                                                        label={``}
                                                                        name={"FOSValue"}
                                                                        type="text"
                                                                        placeholder={''}
                                                                        // validate={[required]}
                                                                        component={renderText}
                                                                        required={true}
                                                                        className={''}
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                    />
                                                                </div> :
                                                                <div>
                                                                    <Field
                                                                        label={``}
                                                                        // name={this.state.factorOfSafetyDD == "STANDARD" ? "FOSValueStan" : ""}
                                                                        name={"FOSValueStan"}
                                                                        type="text"
                                                                        placeholder={''}
                                                                        // validate={[required]}
                                                                        component={renderText}
                                                                        required={true}
                                                                        className={''}
                                                                        customClassName=" withoutBorderBottom"
                                                                        // valueDescription={this.state.FOSValueStandard}
                                                                        readOnly={isViewFlag}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            }
                                                        </Col>
                                                        <Col md="2">
                                                            <p>
                                                                <Field
                                                                    label={``}
                                                                    name={"factorOfSafetyDD"}
                                                                    type="text"
                                                                    placeholder={'----- Select -----'}
                                                                    validate={[required]}
                                                                    required={true}
                                                                    options={factorOfSafety}
                                                                    onChange={this.handlefactorOfSafetyDD}
                                                                    optionValue={'Value'}
                                                                    optionLabel={'Text'}
                                                                    component={renderSelectField}
                                                                    className=" custom-select"
                                                                    customClassName=" withoutBorderBottom"
                                                                    readOnly={isViewFlag}
                                                                    disabled={isViewFlag}
                                                                />
                                                            </p>
                                                        </Col>
                                                    </Row>

                                                    {/* <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>{'Permissible mono-axial stresses for structural components of hydraulic gates'}</p>
                                                        </Col>
                                                    </Row> */}
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{' = '}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Strength / Factor of Safety'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(this.tensileStressCalc()).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{'='}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(this.compressiveStressCalc()).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Compressive Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            {/* <p>{'='}</p> */}
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Based on the ratio of compressive to tensile strength of cast iron.'}</p>
                                                        </Col>
                                                    </Row>
                                                    {/* ************* DESIGN OF GATE LEAF / STOP LOG ************* */}
                                                    <hr />
                                                    <Row className={'mb-3 mt-4'}>
                                                        <Col md="12">
                                                            <div className={'page-heads'}>
                                                                3). TYPICAL HORIZONTAL RIB STRENGTH AND DEFLECTION: -
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <div>
                                                                <p className={'mb-3'}>The maximum stresses and the deflection are calculated based on the specified design head. The beam is simply supported with a uniform water load for the highest loaded rib (next to the bottom one).</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {horizontalSniffersSelect === 'A' &&
                                                        <>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>FLAT PLATE</sub> = T / 2
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>TRAPEZOID</sub> = T + H - H(2B + A)/(3 (B + A)
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>COMP</sub> = (C <sub>TRAPEZOID</sub> x A <sub>TRAPEZOID</sub> + C <sub>FLAT PLATE</sub> x A <sub>FLAT PLATE</sub>)/ TOTAL AREA
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>FLAT PLATE</sub> = T x W<sup>3</sup>/12
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>TRAPEZOID</sub> = H<sup>3</sup>(B<sup>2</sup> + 4 x B x A + A<sup>2</sup>)/(36 (B + A)
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S1 = I <sub>COMP</sub> / C <sub>COMP</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S2 = I <sub>COMP</sub> / (H + T - C <sub>COMP</sub> )
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP DEFLECTION</sub> =  (C <sub>COMP</sub>  -C <sub>FLAT PLATE</sub>)<sup>2</sup> x  A <sub>FLAT PLATE</sub>) + I <sub>TRAPEZOID</sub> + I <sub>FLAT PLATE</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP</sub> = (C <sub>TRAPEZOID</sub> - C <sub>COMP</sub> )<sup>2</sup> x A <sub>TRAPEZOID</sub>+((C <sub>COMP</sub>-C <sub>FLAT PLATE</sub>)<sup>2</sup> x A <sub>FLAT PLATE</sub>) + I <sub>TRAPEZOID</sub> + I <sub>FLAT PLATE</sub>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    }

                                                    {horizontalSniffersSelect === 'B' &&
                                                        <>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>FLAT PLATE</sub> = T / 2
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>TRAPEZOID</sub> = T + H - H(2B + A)/(3 (B + A)
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>COMP</sub> = (C <sub>FLAT PLATE (1)</sub> x A <sub>FLAT PLATE (1)</sub> + C <sub>FLAT PLATE (2)</sub>  x A <sub>FLAT PLATE (2)</sub> + C <sub>FLAT PLATE (3)</sub>  x A <sub>FLAT PLATE (3)</sub>)/ TOTAL AREA
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>FLAT PLATE</sub> = T x W<sup>3</sup>/12
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S1 = I <sub>COMP</sub> / C <sub>COMP</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S2 = I <sub>COMP</sub> / (H + T - C <sub>COMP</sub> )
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP DEFLECTION</sub> =  (C <sub>COMP</sub> - C <sub>FLAT PLATE</sub>)<sup>2</sup> x  A <sub>FLAT PLATE</sub>) + I <sub>FLAT PLATE</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP</sub> = (C <sub>FLAT PLATE (1)</sub> - C <sub>COMP</sub> )<sup>2</sup>  x A <sub>FLAT PLATE (1)</sub> + (C <sub>FLAT PLATE (2)</sub> - C <sub>COMP</sub> )<sup>2</sup> x A <sub>FLAT PLATE (2)</sub> + (C <sub>COMP</sub> - C <sub>FLAT PLATE (3)</sub>)<sup>2</sup> x A <sub>FLAT PLATE (3)</sub> + I <sub>FLAT PLATE (1)</sub> + I <sub>FLAT PLATE (2)</sub> + I <sub>FLAT PLATE (3)</sub>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    }

                                                    <Row className={'mb-3 cr-stagecard-content'}>
                                                        <Col md="12" className="d-flex justify-content-between">
                                                            <div className="design-horizontal">
                                                                <div className="cr-img-wrap">
                                                                    {selectHorizontalRib == 'WITHOUT STEM HOLE' ?
                                                                        <><img src={require('../../assests/images/CISectionA.png')} />
                                                                            <img src={require('../../assests/images/CISectionASide.png')} /> </> :
                                                                        <> <img src={require('../../assests/images/CISectionAHole.png')} />
                                                                            <img src={require('../../assests/images/CISectionASide.png')} /></>
                                                                    }
                                                                </div>
                                                                <p>{'SECTION No: A'}</p>
                                                            </div>

                                                            <div className="design-horizontal">
                                                                <div className="cr-img-wrap">
                                                                    {selectHorizontalRib == 'WITHOUT STEM HOLE' ?
                                                                        <>    <img src={require('../../assests/images/CISectionB.png')} />
                                                                            <img src={require('../../assests/images/CISectionBSide.png')} /></> :
                                                                        <><img src={require('../../assests/images/CISectionBHole.png')} />
                                                                            <img src={require('../../assests/images/CISectionBSide.png')} /></>
                                                                    }
                                                                </div>
                                                                <p>{'SECTION No: B'}</p>
                                                            </div>
                                                        </Col>
                                                        {/* <Col md="3" className="cr-mm-dimension">
                                                            {'TYPICAL HORIZONTAL RIB'}<span class="asterisk-required">*</span>
                                                        </Col>
                                                        <Col md="2" className="cr-mm-dimension text-right">
                                                            {' = '}
                                                        </Col>
                                                        <Col md="2" className={'none-label'}>
                                                            <Field
                                                                label={``}
                                                                name={"selectHorizontalRib"}
                                                                type="text"
                                                                placeholder={'----- Select -----'}
                                                                validate={[required]}
                                                                required={true}
                                                                options={horizontalRibOptions}
                                                                onChange={this.handlehorizontalRib}
                                                                optionValue={'Value'}
                                                                optionLabel={'Text'}
                                                                component={renderSelectField}
                                                                className=" custom-select"
                                                                customClassName=" withoutBorderBottom"
                                                                readOnly={isViewFlag}
                                                                disabled={isViewFlag}
                                                            />
                                                        </Col>

                                                        <Col md="3" className="cr-mm-dimension">
                                                            {'We consider section for Horizontal Stiffeners  ='}<span class="asterisk-required">*</span>
                                                        </Col>
                                                        <Col md="2" className="cr-mm-dimension text-right">
                                                            {' = '}
                                                        </Col>
                                                        <Col md="2" className={'none-label'}>
                                                            <Field
                                                                label={``}
                                                                name={"horizontalStiffenersSection"}
                                                                type="text"
                                                                placeholder={'----- Select -----'}
                                                                validate={[required]}
                                                                required={true}
                                                                options={horizontalStiffenerOption}
                                                                onChange={this.handlehorizontalStiffenersChange}
                                                                optionValue={'Value'}
                                                                optionLabel={'Text'}
                                                                component={renderSelectField}
                                                                className=" custom-select"
                                                                customClassName=" withoutBorderBottom"
                                                                readOnly={isViewFlag}
                                                                disabled={isViewFlag}
                                                            />
                                                        </Col>
                                                        <Col md="2">
                                                            {''}
                                                        </Col> */}
                                                    </Row>


                                                    <Row>
                                                        <Col md="6">
                                                            <Row>
                                                                <Col md="6" className="cr-mm-dimension">
                                                                    {'TYPICAL HORIZONTAL RIB'}<span class="asterisk-required">*</span> <span className="ml-2"> = </span>
                                                                </Col>
                                                                {/* <Col md="2" className="cr-mm-dimension text-right">
                                                            {' = '}
                                                        </Col> */}
                                                                <Col md="4" className={'none-label min-width-container'}>
                                                                    <Field
                                                                        label={``}
                                                                        name={"selectHorizontalRib"}
                                                                        type="text"
                                                                        placeholder={'----- Select -----'}
                                                                        validate={[required]}
                                                                        required={true}
                                                                        options={horizontalRibOptions}
                                                                        onChange={this.handlehorizontalRib}
                                                                        optionValue={'Value'}
                                                                        optionLabel={'Text'}
                                                                        component={renderSelectField}
                                                                        className=" custom-select"
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                        disabled={isViewFlag}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>

                                                        {selectHorizontalRib === 'WITH STEM HOLE' ?
                                                            <Col md="6">
                                                                <Row>
                                                                    <Col md="3" className="cr-mm-dimension">
                                                                        {'STEM DIA'} <span className="ml-2"> = </span>
                                                                    </Col>
                                                                    {/* <Col md="2" className="cr-mm-dimension text-right">
                                                                {' = '}
                                                            </Col> */}
                                                                    <Col md="4" className={'none-label d-flex min-width'}>
                                                                        <Field
                                                                            label={``}
                                                                            name={"stemDiaField"}
                                                                            type="text"
                                                                            placeholder={'----- Select -----'}
                                                                            validate={[required]}
                                                                            required={true}
                                                                            options={stemDiaOption}
                                                                            onChange={this.handleStemDia}
                                                                            optionValue={'Value'}
                                                                            optionLabel={'Text'}
                                                                            component={renderSelectField}
                                                                            className=" custom-select"
                                                                            customClassName=" withoutBorderBottom"
                                                                            readOnly={isViewFlag}
                                                                            disabled={isViewFlag}
                                                                        /> <p className="ml-1"> mm </p>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            : ''
                                                        }
                                                    </Row>
                                                    <Row>
                                                        <Col md="6" className="mt-3">
                                                            <Row>
                                                                <Col md="6" className="cr-mm-dimension">
                                                                    {'We consider section for Horizontal Stiffeners'}<span class="asterisk-required">*</span><span className="ml-2"> = </span>
                                                                </Col>
                                                                {/* <Col md="2" className="cr-mm-dimension text-right">
                                                            {' = '}
                                                        </Col> */}
                                                                <Col md="4" className={'none-label min-width-field'}>
                                                                    <Field
                                                                        label={``}
                                                                        name={"horizontalStiffenersSection"}
                                                                        type="text"
                                                                        placeholder={'----- Select -----'}
                                                                        validate={[required]}
                                                                        required={true}
                                                                        options={horizontalStiffenerOption}
                                                                        onChange={this.handlehorizontalStiffenersChange}
                                                                        optionValue={'Value'}
                                                                        optionLabel={'Text'}
                                                                        // defaultValue={'A'}
                                                                        component={renderSelectField}
                                                                        className=" custom-select"
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                        disabled={isViewFlag}
                                                                        valueDescription={horizontalSniffersSelect}
                                                                    />
                                                                </Col>
                                                                <Col md="2">
                                                                    {''}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    {/* -------------------------new left column design start-------------- */}
                                                    <Row className="mt-2">
                                                        {horizontalSniffersSelect === 'A' && <Col md="6">
                                                            <Row>
                                                                <Col md="7">
                                                                    <p>Where,</p>
                                                                </Col>
                                                                <Col md="5">
                                                                    <Row>
                                                                        <Col md="6" className="text-center">
                                                                            <p>Considered</p>
                                                                        </Col>
                                                                        <Col md="6" className="pr-0 text-center">
                                                                            <p>Recommended</p>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                    <p>RIB THICKNESS-1</p>
                                                                    <p>A <span className="ml-3">=</span></p>
                                                                </Col>
                                                                <Col md="5">
                                                                    <Row>
                                                                        <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                            <Field
                                                                                label={``}
                                                                                name={"hs1"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}

                                                                            />
                                                                        </Col>
                                                                        <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                            {`${Number(this.ribThickness2A()) - 2} mm`}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                    <p>RIB THICKNESS-2</p>
                                                                    <p>B <span className="ml-3">=</span></p>
                                                                </Col>
                                                                <Col md="5">
                                                                    <Row>
                                                                        <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                            <Field
                                                                                label={``}
                                                                                name={"hs2"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                            {`${this.ribThickness2A()} mm`}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                    <p>RIB HEIGHT</p>
                                                                    <p>H <span className="ml-3">=</span></p>
                                                                </Col>
                                                                <Col md="5">
                                                                    <Row>
                                                                        <Col md="6" className="text-center min-box-width cishutter-input-field cis-text-nowrap d-flex align-items-center ml-2 rib-height-feild">
                                                                            <Field
                                                                                label={``}
                                                                                name={"hs3"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="5" className="text-center d-flex justify-content-center align-items-center">
                                                                            {`${this.ribHeightA()} ${this.ribHeightA() === '' ? '' : 'mm'}`}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                    <p>SHUTTER THICKNESS</p>
                                                                    <p>T <span className="ml-3">=</span></p>
                                                                </Col>
                                                                <Col md="5">
                                                                    <Row>
                                                                        <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                            <Field
                                                                                label={``}
                                                                                name={"hs4"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                            {`${this.shutterThicknessA()} mm`}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                    <p>NO OF HORZ RIBS SPACING</p>
                                                                    <p> <span className="ml-3">=</span></p>
                                                                </Col>
                                                                <Col md="5">
                                                                    <Row>
                                                                        <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                            <Field
                                                                                label={``}
                                                                                name={"hs5"}
                                                                                type="text"
                                                                                placeholder={''}
                                                                                validate={[required]}
                                                                                component={renderText}
                                                                                required={true}
                                                                                className={''}
                                                                                customClassName=" withoutBorderBottom"
                                                                                readOnly={isViewFlag}
                                                                            />
                                                                        </Col>
                                                                        <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                            {`${this.noOfHorizontalRibsSpacingCalcA()} Nos`}
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            <Row className="mb-4">
                                                                <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                    <p>RIB DISTANCE</p>
                                                                    <p>W <span className="ml-3">=</span></p>
                                                                </Col>
                                                                <Col md="5">
                                                                    <Row>
                                                                        <Col md="6" className="text-center cis-text-nowrap d-flex justify-content-center align-items-center">
                                                                            {checkForNull(ribDistanceL).toFixed(2)}{" mm"}
                                                                        </Col>
                                                                        <Col md="6" className="text-center cishutter-input-field">

                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>}
                                                        {horizontalSniffersSelect === 'B' &&
                                                            <>
                                                                <Col md="6"></Col>
                                                                <Col md="6">
                                                                    <Row>
                                                                        <Col md="7">
                                                                            <p>Where,</p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center">
                                                                                    <p>Considered</p>
                                                                                </Col>
                                                                                <Col md="6" className="pr-0 text-center">
                                                                                    <p>Recommended</p>
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                            <p>WIDTH OF FLANGE</p>
                                                                            <p>b <span className="ml-3">=</span></p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"hs6"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                                    {" mm"}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                            <p>RIB THICKNESS FOR FLANGE</p>
                                                                            <p>t1 <span className="ml-3">=</span></p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"hs7"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                                    {`${(diagonalVal.Horizontal).toFixed(2)} mm`}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                            <p>RIB THICKNESS FOR WEB</p>
                                                                            <p>t2 <span className="ml-3">=</span></p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"hs8"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                                    {`${(diagonalVal.Horizontal).toFixed(2)} mm`}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md="7" className="d-flex justify-content-between align-items-center cis-text-nowrap">
                                                                            <p>SHUTTER THICKNESS</p>
                                                                            <p>t3 <span className="ml-3">=</span></p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"hs9"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                                    {`${(diagonalVal.Skin).toFixed(2)} mm`}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                            <p>RIB HEIGHT (WEB)</p>
                                                                            <p>d <span className="ml-3">=</span></p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"hs10"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                                    {" mm"}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                            <p>NO OF HORZ RIBS SPACING</p>
                                                                            <p> <span className="ml-3">=</span></p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center cishutter-input-field cis-text-nowrap">
                                                                                    <Field
                                                                                        label={``}
                                                                                        name={"hs11"}
                                                                                        type="text"
                                                                                        placeholder={''}
                                                                                        validate={[required]}
                                                                                        component={renderText}
                                                                                        required={true}
                                                                                        className={''}
                                                                                        customClassName=" withoutBorderBottom"
                                                                                        readOnly={isViewFlag}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="6" className="text-center d-flex justify-content-center align-items-center">
                                                                                    {(this.horizontalRSCalcTable1(fieldObjShutter.height)).toFixed(2)}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className="mb-4">
                                                                        <Col md="7" className="d-flex justify-content-between align-items-center">
                                                                            <p>RIB DISTANCE</p>
                                                                            <p>B <span className="ml-3">=</span></p>
                                                                        </Col>
                                                                        <Col md="5">
                                                                            <Row>
                                                                                <Col md="6" className="text-center d-flex justify-content-center cis-text-nowrap align-items-center">
                                                                                    {`${checkForNull(fieldObjShutter.height / fieldObj.hs11).toFixed(2)} mm`}
                                                                                </Col>
                                                                                <Col md="6" className="text-center cishutter-input-field">

                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </>
                                                        }
                                                    </Row>
                                                    {/* -------------------------new left column design end-------------- */}
                                                    {/* -------------------------new right column design Start-------------- */}
                                                    {/* -------------------------new right column design end-------------- */}
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>{'The "beam" is a composite shape made up of a plate and a trapezoidal rib. The anisotropic properties of cast iron are considered. See the sketch for dimensions.'}</p>
                                                        </Col>
                                                    </Row>

                                                    {horizontalSniffersSelect === 'A' &&
                                                        <table className="ci-shutter-table" width="100%">
                                                            <tr>
                                                                <th></th>
                                                                <th>A</th>
                                                                <th>B</th>
                                                                <th>H</th>
                                                                <th>W</th>
                                                                <th>T</th>
                                                                <th>H2</th>
                                                                <th>H3</th>
                                                                <th>area</th>
                                                                <th>"C"</th>
                                                                <th>"I"</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Plate</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>{checkForNull(ribDistanceL).toFixed(2)}</th>
                                                                <th>{checkForNull(fieldObj.hs4).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(Number(ribDistanceL) * Number(fieldObj.hs4)).toFixed(2)}</th>
                                                                <th>{checkForNull(Number(fieldObj.hs4) / 2).toFixed(2)}</th>
                                                                <th>{checkForNull(Number(ribDistanceL) * Math.pow(Number(fieldObj.hs4), 3) / 12).toFixed(1)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Rib</td>
                                                                <td>{checkForNull(fieldObj.hs1).toFixed(2)}</td>
                                                                <td>{checkForNull(fieldObj.hs2).toFixed(2)}</td>
                                                                <th>{checkForNull(fieldObj.hs3).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull((Number(fieldObj.hs1) + Number(fieldObj.hs2)) / 2 * Number(fieldObj.hs3)).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal10_3).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal11_3).toFixed(3)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                            </tr>
                                                            {selectHorizontalRib === 'WITHOUT STEM HOLE' ?
                                                                <tr>
                                                                    <td>-</td>
                                                                    <td>-</td>
                                                                    <td>-</td>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                </tr> :
                                                                <tr>
                                                                    <td>Handling/Stem hole*</td>
                                                                    <td>{checkForNull(tableVal2_5).toFixed(1)}</td>
                                                                    <td>{checkForNull(tableVal3_5).toFixed(1)}</td>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>{checkForNull(tableVal7_5).toFixed(1)}</th>
                                                                    <th>{checkForNull(tableVal8_5).toFixed(1)}</th>
                                                                    <th>{checkForNull(tableVal9_5).toFixed(2)}</th>
                                                                    <th>{checkForNull(tableVal10_5).toFixed(2)}</th>
                                                                    <th>{checkForNull(tableVal11_5).toFixed(3)}</th>
                                                                </tr>
                                                            }
                                                            <tr>
                                                                <td>Composite</td>
                                                                <td></td>
                                                                <td></td>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th>{checkForNull(tableVal9_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableval10_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal11_6).toFixed(1)}</th>
                                                            </tr>
                                                        </table>
                                                    }

                                                    {horizontalSniffersSelect === 'B' &&
                                                        <table className="ci-shutter-table" width="100%">
                                                            <tr>
                                                                <th></th>
                                                                <th>t1</th>
                                                                <th>t2</th>
                                                                <th>d</th>
                                                                <th>B</th>
                                                                <th>t3</th>
                                                                <th>d1</th>
                                                                <th>d2</th>
                                                                <th>Area</th>
                                                                <th>"C"</th>
                                                                <th>"I"</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Plate</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal1B_5_2).toFixed(2)}</th>
                                                                <th>{checkForNull(fieldObj.hs9).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal1B_9_2).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_10_2).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_11_2).toFixed(1)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Rib-Web</td>
                                                                <td>-</td>
                                                                <td>{checkForNull(fieldObj.hs8).toFixed(2)}</td>
                                                                <th>{checkForNull(fieldObj.hs10).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal1B_9_3).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_10_3).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_11_3).toFixed(1)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Rib-flange</td>
                                                                <td>{checkForNull(fieldObj.hs7).toFixed(2)}</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>{checkForNull(fieldObj.hs6).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal1B_9_4).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_10_4).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_11_4).toFixed(2)}</th>
                                                            </tr>
                                                            {selectHorizontalRib === 'WITHOUT STEM HOLE' ?
                                                                <tr>
                                                                    <td>-</td>
                                                                    <td>-</td>
                                                                    <td>-</td>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                </tr> :
                                                                <tr>
                                                                    <td>Handling/Stem hole</td>
                                                                    <td>-</td>
                                                                    <td>{checkForNull(fieldObj.hs8).toFixed(1)}</td>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>-</th>
                                                                    <th>{checkForNull(tableVal1B_7_5).toFixed(1)}</th>
                                                                    <th>{checkForNull(tableVal1B_8_5).toFixed(1)}</th>
                                                                    <th>{checkForNull(tableVal1B_9_5).toFixed(2)}</th>
                                                                    <th>{checkForNull(tableVal1B_10_5).toFixed(2)}</th>
                                                                    <th>{checkForNull(tableVal1B_11_5).toFixed(1)}</th>
                                                                </tr>
                                                            }
                                                            <tr>
                                                                <td>Composite</td>
                                                                <td></td>
                                                                <td></td>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th>{checkForNull(tableVal1B_9_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_10_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal1B_11_6).toFixed(1)}</th>
                                                            </tr>
                                                        </table>
                                                    }

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>{'* The stem hole or handling hole is a very small part of the overall beam. Although stresses are calculated based on the properties through that section, the value for Moment of Inertia for deflection is based on a solid member.'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Therefore, Moment of Inertia based on a section member'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>I =</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(sectionMemberMOI).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Moment of Inertia based on a solid member'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>Is =</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(solidMemberMOI).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'For Tensile Seating and Compressive Unseating'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>S1 =</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(tensileSeating).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'For Compressive Seating and Tensile Unseating'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>S2 =</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(compressiveSeating).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>{'The compressive strength and modulus of elasticity are typical values taken from ASM Metals Handbook'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'SEATING HEAD TENSILE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Gate Width2 x Maximum Head x 9810 x W )/8/S1'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(seatingHeadTensileStress).toFixed(2)} Mpa`} </p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.tensileStressCalc().toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${seatingHeadTensileStress > this.tensileStressCalc() ? 'error' : ''} `}>{seatingHeadTensileStress > this.tensileStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>
                                                    {/* // Sytart here */}
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'SEATING HEAD COMPRESSIVE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Gate Width2 x Maximum Head x 9810 x W )/8/S2'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(seatingHeadCompressiveStress).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable compressive stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.compressiveStressCalc().toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${seatingHeadCompressiveStress > this.compressiveStressCalc() ? 'error' : ''} `}>{seatingHeadCompressiveStress > this.compressiveStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'UNSEATING HEAD TENSILE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Gate Width2 x Maximum Head x 9810 x W )/8/S2'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(unseatingHeadCompressiveStress).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.tensileStressCalc().toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${unseatingHeadCompressiveStress > this.tensileStressCalc() ? 'error' : ''} `}>{unseatingHeadCompressiveStress > this.tensileStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'UNSEATING HEAD COMPRESSIVE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Gate Width2 x Maximum Head x 9810 x W )/8/S1'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(unseatingHeadTensileStress).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable compressive stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.compressiveStressCalc().toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${unseatingHeadTensileStress > this.compressiveStressCalc() ? 'error' : ''} `}>{unseatingHeadTensileStress > this.compressiveStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'BEAM DEFLECTION AT MAXIMUM HEAD'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Deflection'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Head on lowest rib x 9810 x beam width x5x width4 x 10^6/(384xExI)'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable compressive stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(beamDeflectionMaxHead).toFixed(2)} mm`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Deflection'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Lesser value of span / 720 and 1.6 mm'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable compressive stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>=</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(actualDefLesser).toFixed(2)} mm`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p className={`${beamDeflectionMaxHead > actualDefLesser ? 'error' : ''} `}>{beamDeflectionMaxHead > actualDefLesser ? 'DEFLECTION TOO HIGH' : 'The actual deflection is less than the permissible deflection, Hence the design is safe.'}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3 mt-4'}>
                                                        <Col md="12">
                                                            <div className={'page-heads'}>
                                                                4). BOTTOM RIB STRENGTH AND DEFLECTION: -
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <div>
                                                                <p className={'mb-3'}>The maximum stresses and the deflection are calculated based on the specified design head. The beam is simply supported with a uniform water load at the bottom rib.</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <div>
                                                                <p className={'mb-3'}>The "beam" is a composite shape made up of a plate and a trapezoidal rib. The anisotropic properties of cast iron are considered. See the sketch for dimensions.</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {horizontalSniffersSelect === 'A' &&
                                                        <>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>FLAT PLATE</sub> = T / 2
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>TRAPEZOID</sub> = T + H - H(2B + A)/(3 (B + A)
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>COMP</sub> = (C <sub>TRAPEZOID</sub> x A <sub>TRAPEZOID</sub> + C <sub>FLAT PLATE</sub> x A <sub>FLAT PLATE</sub>)/ TOTAL AREA
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>FLAT PLATE</sub> = T x W<sup>3</sup>/12
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>TRAPEZOID</sub> = H<sup>3</sup>(B<sup>2</sup> + 4 x B x A + A<sup>2</sup>)/(36 (B + A)
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S1 = I <sub>COMP</sub> / C <sub>COMP</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S2 = I <sub>COMP</sub> / (H + T - C <sub>COMP</sub> )
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP DEFLECTION</sub> =  (C <sub>COMP</sub>  -C <sub>FLAT PLATE</sub>)<sup>2</sup> x  A <sub>FLAT PLATE</sub>) + I <sub>TRAPEZOID</sub> + I <sub>FLAT PLATE</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP</sub> = (C <sub>TRAPEZOID</sub> - C <sub>COMP</sub> )<sup>2</sup> x A <sub>TRAPEZOID</sub>+((C <sub>COMP</sub>-C <sub>FLAT PLATE</sub>)<sup>2</sup> x A <sub>FLAT PLATE</sub>) + I <sub>TRAPEZOID</sub> + I <sub>FLAT PLATE</sub>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    }

                                                    {horizontalSniffersSelect === 'B' &&
                                                        <>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>FLAT PLATE</sub> = T / 2
                                                                </Col>
                                                            </Row>
                                                            {/* <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>TRAPEZOID</sub> = T + H - H(2B + A)/(3 (B + A)
                                                                </Col>
                                                            </Row> */}
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>COMP</sub> = (C <sub>FLAT PLATE (1)</sub> x A <sub>FLAT PLATE (1)</sub> + C <sub>FLAT PLATE (2)</sub>  x A <sub>FLAT PLATE (2)</sub> + C <sub>FLAT PLATE (3)</sub>  x A <sub>FLAT PLATE (3)</sub>)/ TOTAL AREA
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>FLAT PLATE</sub> = T x W<sup>3</sup>/12
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S1 = I <sub>COMP</sub> / C <sub>COMP</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    S2 = I <sub>COMP</sub> / (H + T - C <sub>COMP</sub> )
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP DEFLECTION</sub> =  (C <sub>COMP</sub> - C <sub>FLAT PLATE</sub>)<sup>2</sup> x  A <sub>FLAT PLATE</sub>) + I <sub>FLAT PLATE</sub>
                                                                </Col>
                                                            </Row>
                                                            <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    I <sub>COMP</sub> = (C <sub>FLAT PLATE (1)</sub> - C <sub>COMP</sub> )<sup>2</sup>  x A <sub>FLAT PLATE (1)</sub> + (C <sub>FLAT PLATE (2)</sub> - C <sub>COMP</sub> )<sup>2</sup> x A <sub>FLAT PLATE (2)</sub> + (C <sub>COMP</sub> - C <sub>FLAT PLATE (3)</sub>)<sup>2</sup> x A <sub>FLAT PLATE (3)</sub> + I <sub>FLAT PLATE (1)</sub> + I <sub>FLAT PLATE (2)</sub> + I <sub>FLAT PLATE (3)</sub>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    }

                                                    <Row className={'mb-3 cr-stagecard-content'}>
                                                        <Col md="12" className="d-flex justify-content-between">
                                                            <div className="design-horizontal">
                                                                <div className="cr-img-wrap">
                                                                    {selectHorizontalRib === 'WITHOUT STEM HOLE' ?
                                                                        <><img src={require('../../assests/images/CISectionA.png')} />
                                                                            <img src={require('../../assests/images/CISectionASide.png')} /> </> :
                                                                        <> <img src={require('../../assests/images/CISectionAHole.png')} />
                                                                            <img src={require('../../assests/images/CISectionASide.png')} /></>
                                                                    }
                                                                </div>
                                                                <p>{'SECTION No: A'}</p>
                                                            </div>

                                                            <div className="design-horizontal">
                                                                <div className="cr-img-wrap">
                                                                    {selectHorizontalRib === 'WITHOUT STEM HOLE' ?
                                                                        <>    <img src={require('../../assests/images/CISectionB.png')} />
                                                                            <img src={require('../../assests/images/CISectionBSide.png')} /></> :
                                                                        <><img src={require('../../assests/images/CISectionBHole.png')} />
                                                                            <img src={require('../../assests/images/CISectionBSide.png')} /></>
                                                                    }
                                                                </div>
                                                                <p>{'SECTION No: B'}</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md="4" className="cr-mm-dimension">
                                                            {'We consider section for Horizontal Stiffeners  ='}
                                                        </Col>
                                                        {/* <Col md="2" className="cr-mm-dimension text-right">
                                                            {' = '}
                                                        </Col> */}
                                                        <Col md="2" className={'none-label min-width-field'}>
                                                            <Field
                                                                label={``}
                                                                name={"horizontalStiffenersSection"}
                                                                type="text"
                                                                placeholder={'----- Select -----'}
                                                                validate={[required]}
                                                                required={true}
                                                                options={horizontalStiffenerOption}
                                                                onChange={this.handlehorizontalStiffenersChange}
                                                                optionValue={'Value'}
                                                                optionLabel={'Text'}
                                                                component={renderSelectField}
                                                                className=" custom-select"
                                                                customClassName=" withoutBorderBottom"
                                                                readOnly={isViewFlag}
                                                                disabled={true}
                                                                valueDescription={horizontalSniffersSelect}
                                                            />
                                                        </Col>
                                                        <Col md="2">
                                                            {''}
                                                        </Col>
                                                    </Row>

                                                    {horizontalSniffersSelect === 'A' &&
                                                        <>
                                                            {/* <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                        {'Where,'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'   ='}
                                                                    </Col>
                                                                    <Col md='1'>{'Considered'}</Col>
                                                                    <Col md='1'>
                                                                        {'Recommended'}
                                                                    </Col>
                                                                </>
                                                            </Row> */}

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                        {'RIB THICKNESS-1'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'A  ='}
                                                                    </Col>
                                                                    <Col md='2'>
                                                                        {`${checkForNull(ribThickness4A) - 2} mm`}
                                                                    </Col>

                                                                </>
                                                            </Row>

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                        {'RIB THICKNESS-2'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'B  ='}
                                                                    </Col>
                                                                    <Col md='2'>
                                                                        {`${checkForNull(ribThickness4A)} mm`}
                                                                    </Col>

                                                                </>
                                                            </Row>

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                        {'RIB HEIGHT'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'H  ='}
                                                                    </Col>
                                                                    <Col md='2'>{`${checkForNull(fieldObj.hs3)} mm`}</Col>

                                                                </>
                                                            </Row>



                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                        {'RIB DISTANCE'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'T  ='}
                                                                    </Col>
                                                                    <Col md='2' className="cis-text-nowrap">{`${checkForNull(ribDistanceL / 2).toFixed(2)} mm`}</Col>
                                                                </>
                                                            </Row>

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                        {'SHUTTER THICKNESS'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'   ='}
                                                                    </Col>
                                                                    <Col md='2'>{`${checkForNull(fieldObj.hs4).toFixed(2)} mm`}</Col>

                                                                </>
                                                            </Row>
                                                        </>
                                                    }

                                                    {horizontalSniffersSelect === 'B' &&
                                                        <>
                                                            {/* <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='3'>
                                                                        {'Where,'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'   ='}
                                                                    </Col>
                                                                    <Col md='1'>{'Considered'}</Col>
                                                                    <Col md='1'>
                                                                        {'Recommended'}
                                                                    </Col>
                                                                </>
                                                            </Row> */}

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='3'>
                                                                        {'WIDTH OF FLANGE'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'b  ='}
                                                                    </Col>
                                                                    <Col md='2'> {`${checkForNull(fieldObj.hs6)} mm`} </Col>

                                                                </>
                                                            </Row>

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='3'>
                                                                        {'RIB THICKNESS FOR FLANGE'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'t1  ='}
                                                                    </Col>
                                                                    <Col md='2'>{`${nextEvenNo(fieldObj.hs8 * 1.5)} mm`}</Col>

                                                                </>
                                                            </Row>

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='3'>
                                                                        {'RIB THICKNESS FOR WEB'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'t2  ='}
                                                                    </Col>
                                                                    <Col md='2'> {`${nextEvenNo(fieldObj.hs8 * 1.5)} mm`}</Col>

                                                                </>
                                                            </Row>



                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='3'>
                                                                        {'SHUTTER THICKNESS'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'t3  ='}
                                                                    </Col>
                                                                    <Col md='2'>{`${fieldObj.hs9} mm`}</Col>

                                                                </>
                                                            </Row>

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='3'>
                                                                        {'RIB HEIGHT (WEB)'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'d  ='}
                                                                    </Col>
                                                                    <Col md='2'>{`${fieldObj.hs10} mm`}</Col>

                                                                </>
                                                            </Row>

                                                            <Row className={'mb-3 cr-mm-dimension'}>
                                                                <>
                                                                    <Col md='3'>
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='1'>
                                                                    </Col>
                                                                    <Col md='3'>
                                                                        {'RIB DISTANCE'}
                                                                    </Col>
                                                                    <Col md='1' className='text-right'>
                                                                        {'  ='}
                                                                    </Col>
                                                                    <Col md='2' className="cis-text-nowrap">{`${((fieldObjShutter.height / fieldObj.hs11) / 2).toFixed(2)} mm`}</Col>

                                                                </>
                                                            </Row>

                                                        </>
                                                    }



                                                    {horizontalSniffersSelect === 'A' &&
                                                        <table className="ci-shutter-table" width="100%">
                                                            <tr>
                                                                <th></th>
                                                                <th>A</th>
                                                                <th>B</th>
                                                                <th>H</th>
                                                                <th>W</th>
                                                                <th>T</th>
                                                                <th>H2</th>
                                                                <th>H3</th>
                                                                <th>Area</th>
                                                                <th>"C"</th>
                                                                <th>"I"</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Plate</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>{checkForNull(ribDistanceL / 2).toFixed(2)}</th>
                                                                <th>{checkForNull(fieldObj.hs4).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull((Number(ribDistanceL) / 2) * Number(fieldObj.hs4)).toFixed(2)}</th>
                                                                <th>{checkForNull(Number(fieldObj.hs4) / 2).toFixed(2)}</th>
                                                                <th>{checkForNull((Number(ribDistanceL) / 2) * Math.pow(Number(fieldObj.hs4), 3) / 12).toFixed(2)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Rib</td>
                                                                <td>{checkForNull(ribThickness4A - 2).toFixed(2)}</td>
                                                                <td>{checkForNull(ribThickness4A).toFixed(2)}</td>
                                                                <th>{checkForNull(fieldObj.hs3).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(((Number(ribThickness4A) - 2) + Number(ribThickness4A)) / 2 * Number(fieldObj.hs3)).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_10_3).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_11_3).toFixed(1)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Handling/Stem hole*</td>
                                                                <td>{checkForNull(tableVal2A_2_5).toFixed(2)}</td>
                                                                <td>{checkForNull(tableVal2A_3_5).toFixed(2)}</td>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal2A_7_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_8_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_9_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_10_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_11_5).toFixed(2)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Composite</td>
                                                                <td></td>
                                                                <td></td>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th>{checkForNull(tableVal2A_9_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_10_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2A_11_6).toFixed(2)}</th>
                                                            </tr>
                                                        </table>
                                                    }

                                                    {horizontalSniffersSelect === 'B' &&
                                                        <table className="ci-shutter-table" width="100%">
                                                            <tr>
                                                                <th></th>
                                                                <th>t1</th>
                                                                <th>t2</th>
                                                                <th>d</th>
                                                                <th>B</th>
                                                                <th>t3</th>
                                                                <th>d1</th>
                                                                <th>d2</th>
                                                                <th>Area</th>
                                                                <th>"C"</th>
                                                                <th>"I"</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Plate</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal2B_5_2).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_6_2).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal2B_9_2).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_10_2).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_11_2).toFixed(2)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Rib-Web</td>
                                                                <td>-</td>
                                                                <td>{checkForNull(tableVal2B_3_3).toFixed(2)}</td>
                                                                <th>{checkForNull(tableVal2B_4_3).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal2B_9_3).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_10_3).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_11_3).toFixed(1)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Rib-flange</td>
                                                                <td>{checkForNull(tableVal2B_2_4).toFixed(2)}</td>
                                                                <td>-</td>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal2B_5_4).toFixed(2)}</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal2B_9_4).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_10_4).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_11_4).toFixed(2)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Handling/Stem hole</td>
                                                                <td>-</td>
                                                                <td>{checkForNull(tableVal2B_3_5).toFixed(2)}</td>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>-</th>
                                                                <th>{checkForNull(tableVal2B_7_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_8_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_9_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_10_5).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_11_5).toFixed(2)}</th>
                                                            </tr>
                                                            <tr>
                                                                <td>Composite</td>
                                                                <td></td>
                                                                <td></td>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th>{checkForNull(tableVal2B_9_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_10_6).toFixed(2)}</th>
                                                                <th>{checkForNull(tableVal2B_11_6).toFixed(1)}</th>
                                                            </tr>
                                                        </table>
                                                    }


                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            * The stem hole or handling hole is a very small part of the overall beam. Although stresses are calculated based on the properties through that section, the value for Moment of Inertia for deflection is based on a solid member.
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>Therefore, Moment of Inertia based on a section member</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            {' I ='}
                                                        </Col>
                                                        <Col md="5">
                                                            {checkForNull(section2Val1).toFixed(2)}
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>Moment of Inertia based on a solid member</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            {' Is ='}
                                                        </Col>
                                                        <Col md="5">
                                                            {checkForNull(section2Val2).toFixed(2)}
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>For Tensile Seating and Compressive Unseating</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            {' S1 ='}
                                                        </Col>
                                                        <Col md="5">
                                                            {checkForNull(tensileSeatingTable2).toFixed(2)}
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>For Compressive Seating and Tensile Unseating</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            {' S2 ='}
                                                        </Col>
                                                        <Col md="5">
                                                            {checkForNull(compressiveSeatingTable2).toFixed(2)}
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>The compressive strength and modulus of elasticity are typical values taken from ASM Metals Handbook</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'SEATING HEAD TENSILE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Gate Width2 x Maximum Head x 9810 x W )/8/S1'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(seatingHeadTensileStressTable2).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(this.tensileStressCalc()).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${seatingHeadTensileStressTable2 > this.tensileStressCalc() ? 'error' : ''} `}>{seatingHeadTensileStressTable2 > this.tensileStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>
                                                    {/* // Sytart here */}
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'SEATING HEAD COMPRESSIVE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Gate Width2 x Maximum Head x 9810 x W )/8/S2'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(seatingHeadCompressiveStressTable2).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable compressive stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.compressiveStressCalc().toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${seatingHeadCompressiveStressTable2 > this.compressiveStressCalc() ? 'error' : ''} `}>{seatingHeadCompressiveStressTable2 > this.compressiveStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'UNSEATING HEAD TENSILE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Gate Width2 x Maximum Head x 9810 x W )/8/S2'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(unseatingHeadCompressiveStressTable2).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(this.tensileStressCalc()).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${unseatingHeadCompressiveStressTable2 > this.tensileStressCalc() ? 'error' : ''} `}>{unseatingHeadCompressiveStressTable2 > this.tensileStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'UNSEATING HEAD COMPRESSIVE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Gate Width2 x Maximum Head x 9810 x W )/8/S1'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(unseatingHeadTensileStressTable2).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable compressive stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(this.compressiveStressCalc()).toFixed(2)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${unseatingHeadTensileStressTable2 > this.compressiveStressCalc() ? 'error' : ''} `}>{unseatingHeadTensileStressTable2 > this.compressiveStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'BEAM DEFLECTION AT MAXIMUM HEAD'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Deflection'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Head on lowest rib x 9810 x beam width x5x width4 x 10^6/(384xExI)'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable compressive stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(beamDeflectionMaxHeadTable2).toFixed(2)} mm`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Deflection'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Lesser value of span / 720 and 1.6 mm'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable compressive stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(actualDefLesserTabl2).toFixed(2)} mm`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p className={`${beamDeflectionMaxHeadTable2 > actualDefLesserTabl2 ? 'error' : ''} `}>{beamDeflectionMaxHeadTable2 > actualDefLesserTabl2 ? 'DEFLECTION TOO HIGH' : 'The actual deflection is less than the permissible deflection, Hence the design is safe.'}</p>
                                                        </Col>
                                                    </Row>




                                                    <Row className={'mb-3 mt-4'}>
                                                        <Col md="12">
                                                            <div className={'page-heads'}>
                                                                5). VERTICAL RIB STRENGTH AND DEFLECTION: -
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <div>
                                                                <p className={'mb-3'}>The maximum stresses and the deflection are calculated based on the specified design head. The beam is simply supported with a uniform water load at the bottom rib.</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <div>
                                                                <p className={'mb-3'}>The "beam" is a composite shape made up of a plate and a trapezoidal rib. The anisotropic properties of cast iron are considered. See the sketch for dimensions.</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {/* {horizontalSniffersSelect == 'A' && */}
                                                    <>
                                                        {/* <Row className={'mb-3'}>
                                                                <Col md="12">
                                                                    C <sub>FLAT PLATE</sub> = T / 2
                                                                </Col>
                                                            </Row> */}
                                                        <Row className={'mb-3'}>
                                                            <Col md="8">
                                                                <Row>
                                                                    <Col md="12" className={'mb-3'}>
                                                                        C <sub>TRAPEZOID</sub> = T + H - H(2B + A)/(3 (B + A)
                                                                    </Col>

                                                                    <Col md="12" className={'mb-3'}>
                                                                        C <sub>COMP</sub> = (C <sub>TRAPEZOID</sub> x A <sub>TRAPEZOID</sub> + C <sub>FLAT PLATE</sub> x A <sub>FLAT PLATE</sub>)/ TOTAL AREA
                                                                    </Col>

                                                                    <Col md="12" className={'mb-3'}>
                                                                        I <sub>FLAT PLATE</sub> = T x W<sup>3</sup>/12
                                                                    </Col>

                                                                    <Col md="12" className={'mb-3'}>
                                                                        I <sub>TRAPEZOID</sub> = H<sup>3</sup>(B<sup>2</sup> + 4 x B x A + A<sup>2</sup>)/(36 (B + A)
                                                                    </Col>

                                                                    <Col md="12" className={'mb-3'}>
                                                                        S1 = I <sub>COMP</sub> / C <sub>COMP</sub>
                                                                    </Col>

                                                                    <Col md="12" className={'mb-3'}>
                                                                        S2 = I <sub>COMP</sub> / (H + T - C <sub>COMP</sub> )
                                                                    </Col>
                                                                    <Col md="12" className={'mb-3'}>
                                                                        I <sub>COMP DEFLECTION</sub> =  (C <sub>COMP</sub>  -C <sub>FLAT PLATE</sub>)<sup>2</sup> x  A <sub>FLAT PLATE</sub>) + I <sub>TRAPEZOID</sub> + I <sub>FLAT PLATE</sub>
                                                                    </Col>
                                                                    <Col md="12">
                                                                        I <sub>COMP</sub> = (C <sub>TRAPEZOID</sub> - C <sub>COMP</sub> )<sup>2</sup> x A <sub>TRAPEZOID</sub>+((C <sub>COMP</sub>-C <sub>FLAT PLATE</sub>)<sup>2</sup> x A <sub>FLAT PLATE</sub>) + I <sub>TRAPEZOID</sub> + I <sub>FLAT PLATE</sub>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col md="4">
                                                                <Row className={'cr-stagecard-content'}>
                                                                    <Col md="12" className="d-flex justify-content-between">
                                                                        <div className="design-horizontal cisection-img">
                                                                            <div className="cr-img-wrap">
                                                                                <img src={require('../../assests/images/CISectionA_5.png')} />
                                                                                {/* <img src={require('../../assests/images/CISectionASide.png')} /> */}
                                                                            </div>
                                                                            <p>{'SECTION No: A'}</p>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                    {/* } */}
                                                    <Row>
                                                        <Col md="4" className="cr-mm-dimension">
                                                            {'We consider section for Vertical Stiffeners'}<span class="asterisk-required">*</span><span className="ml-2"> = </span>
                                                        </Col>
                                                        {/* <Col md="2" className="cr-mm-dimension text-right">
                                                            {' = '}
                                                        </Col> */}
                                                        <Col md="2" className={'none-label min-width-field'}>
                                                            <Field
                                                                label={``}
                                                                name={"horizontalStiffenersSection5"}
                                                                type="text"
                                                                placeholder={'----- Select -----'}
                                                                validate={[required]}
                                                                required={true}
                                                                options={horizontalStiffenerOption}
                                                                onChange={this.handlehorizontalStiffenersChange}
                                                                optionValue={'Value'}
                                                                optionLabel={'Text'}
                                                                component={renderSelectField}
                                                                className=" custom-select"
                                                                customClassName=" withoutBorderBottom"
                                                                readOnly={isViewFlag}
                                                                disabled={true}
                                                                valueDescription={horizontalSniffersSelect}
                                                            />
                                                        </Col>
                                                        <Col md="2">
                                                            {''}
                                                        </Col>

                                                    </Row>
                                                    <>
                                                        <Row className={'mb-3 cr-mm-dimension'}>
                                                            <>
                                                                <Col md='4' className="d-flex justify-content-between">
                                                                    {'RIB THICKNESS-1'} <p className="text-right">A =</p>
                                                                </Col>

                                                                <Col md='1' className="cis-text-nowrap">
                                                                    <Field
                                                                        label={``}
                                                                        name={"hs12"}
                                                                        type="text"
                                                                        placeholder={''}
                                                                        validate={[required]}
                                                                        component={renderText}
                                                                        required={true}
                                                                        className={''}
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                    />
                                                                </Col>
                                                                <Col md='1' className="text-center">
                                                                    {`${Number(this.ribThickness2A_5()) - 2} mm`}
                                                                </Col>
                                                            </>
                                                        </Row>

                                                        <Row className={'mb-3 cr-mm-dimension'}>
                                                            <>
                                                                <Col md='4' className="d-flex justify-content-between">
                                                                    {'RIB THICKNESS-2'}<p className="text-right">B =</p>
                                                                </Col>

                                                                <Col md='1' className="cis-text-nowrap">
                                                                    <Field
                                                                        label={``}
                                                                        name={"hs13"}
                                                                        type="text"
                                                                        placeholder={''}
                                                                        validate={[required]}
                                                                        component={renderText}
                                                                        required={true}
                                                                        className={''}
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                    />
                                                                </Col>
                                                                <Col md='1' className="text-center">
                                                                    {`${this.ribThickness2A_5()} mm`}
                                                                </Col>
                                                            </>
                                                        </Row>

                                                        <Row className={'mb-3 cr-mm-dimension'}>
                                                            <>
                                                                <Col md='4' className="d-flex justify-content-between">
                                                                    {'RIB HEIGHT'}<p className="text-right">H =</p>
                                                                </Col>

                                                                <Col md='1' className="cis-text-nowrap">
                                                                    <Field
                                                                        label={``}
                                                                        name={"hs14"}
                                                                        type="text"
                                                                        placeholder={''}
                                                                        validate={[required]}
                                                                        component={renderText}
                                                                        required={true}
                                                                        className={''}
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                    />

                                                                </Col>
                                                                <Col md='1' className="text-center">
                                                                    {`${this.ribHeightA()}`} {" mm"}
                                                                </Col>
                                                            </>
                                                        </Row>



                                                        <Row className={'mb-3 cr-mm-dimension'}>
                                                            <>
                                                                <Col md='4' className="d-flex justify-content-between">
                                                                    {'SHUTTER THICKNESS'}<p className="text-right">T =</p>
                                                                </Col>
                                                                <Col md='1'>
                                                                    {`${checkForNull(shutterThicknessSection5)} ${this.ribHeightA_5() === '' ? ' mm' : ''}`}
                                                                </Col>
                                                                <Col md='1' className="text-center">
                                                                    {`${(this.ribHeightA_5())} ${this.ribHeightA_5() === '' ? '' : 'mm'}`}
                                                                </Col>
                                                            </>
                                                        </Row>

                                                        <Row className={'mb-3 cr-mm-dimension'}>
                                                            <>
                                                                <Col md='4' className="d-flex justify-content-between">
                                                                    {'NO OF VERT RIBS SPACING'}<p className="text-right">=</p>
                                                                </Col>
                                                                <Col md='1' className="cis-text-nowrap">
                                                                    <Field
                                                                        label={``}
                                                                        name={"hs15"}
                                                                        type="text"
                                                                        placeholder={''}
                                                                        validate={[required]}
                                                                        component={renderText}
                                                                        required={true}
                                                                        className={''}
                                                                        customClassName=" withoutBorderBottom"
                                                                        readOnly={isViewFlag}
                                                                    />
                                                                </Col>
                                                                <Col md='1' className="text-center">
                                                                    {`${this.noOfHorizontalRibsSpacingCalcA_5()} Nos`}
                                                                </Col>
                                                            </>
                                                        </Row>

                                                        <Row className={'mb-3 cr-mm-dimension'}>
                                                            <>
                                                                <Col md='4' className="d-flex justify-content-between">
                                                                    {'RIB DISTANCE'}<p className="text-right">W =</p>
                                                                </Col>
                                                                <Col md='2' className="cis-text-nowrap">{`${checkForNull(this.returnFieldInteger('width') / fieldObj.hs15).toFixed(2)} mm`}</Col>

                                                            </>
                                                        </Row>
                                                    </>
                                                    {/* } */}
                                                    <Row className={'mb-3 mt-4'}>
                                                        <Col md="12">
                                                            <div className={'page-heads'}>
                                                                TYPICAL VERTICAL RIB STRENGTH AND DEFLECTION
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3 mt-4'}>
                                                        <Col md="12">
                                                            FOR SECTION A
                                                        </Col>
                                                    </Row>
                                                    {/* {horizontalSniffersSelect == 'A' && */}
                                                    <table className="ci-shutter-table" width="100%">
                                                        <tr>
                                                            <th></th>
                                                            <th>A</th>
                                                            <th>B</th>
                                                            <th>H</th>
                                                            <th>W</th>
                                                            <th>T</th>
                                                            <th>H2</th>
                                                            <th>H3</th>
                                                            <th>area</th>
                                                            <th>"C"</th>
                                                            <th>"I"</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Plate</td>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <th>-</th>
                                                            <th>{checkForNull(tableVal5_5_2).toFixed(2)}</th>
                                                            <th>{checkForNull(tableVal5_6_2).toFixed(2)}</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>{checkForNull(tableVal5_9_2).toFixed(2)}</th>
                                                            <th>{checkForNull(tableVal5_10_2).toFixed(2)}</th>
                                                            <th>{checkForNull(tableVal5_11_2).toFixed(2)}</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Rib</td>
                                                            <td>{checkForNull(tableVal5_2_3).toFixed(2)}</td>
                                                            <td>{checkForNull(tableVal5_3_3).toFixed(2)}</td>
                                                            <th>{checkForNull(tableVal5_4_3).toFixed(2)}</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>{checkForNull(tableVal5_9_3).toFixed(2)}</th>
                                                            <th>{checkForNull(tableVal5_10_3).toFixed(2)}</th>
                                                            <th>{checkForNull(tableVal5_11_3).toFixed(2)}</th>
                                                        </tr>
                                                        <tr>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                        </tr>
                                                        <tr>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                            <th>-</th>
                                                        </tr>
                                                        <tr>
                                                            <td>Composite</td>
                                                            <td></td>
                                                            <td></td>
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th></th>
                                                            <th>{checkForNull(tableVal5_9_6).toFixed(2)}</th>
                                                            <th>{checkForNull(tableVal5_10_6).toFixed(2)}</th>
                                                            <th>{checkForNull(tableVal5_11_6).toFixed(2)}</th>
                                                        </tr>
                                                    </table>
                                                    {/* } */}

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>{'The "beam" is a composite shape made up of a plate and a trapezoidal rib. The anisotropic properties of cast iron are considered. See the sketch for dimensions.'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Therefore, Moment of Inertia based on a section member'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`I =`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(tableVal5_11_6).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Moment of Inertia based on a solid member'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`Is =`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(tableVal5_11_6).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'For Tensile Seating and Compressive Unseating'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`S1 =`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(tableVal5_11_6 / tableVal5_10_6).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'For Compressive Seating and Tensile Unseating'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`S2 =`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{checkForNull(Number(tableVal5_11_6) / (Number(tableVal5_4_3) + Number(tableVal5_6_2) - Number(tableVal5_10_6))).toFixed(2)}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p>{'The compressive strength and modulus of elasticity are typical values taken from ASM Metals Handbook'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'SEATING HEAD TENSILE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Gate Width2 x Maximum Head x 9810 x W )/8/S1'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(seatingHeadTensileStress_5).toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(this.tensileStressCalc()).toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${checkForNull(seatingHeadTensileStress_5) > this.tensileStressCalc() ? 'error' : ''} `}>{checkForNull(seatingHeadTensileStress_5) > this.tensileStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>
                                                    {/* // Sytart here */}
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'SEATING HEAD COMPRESSIVE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Gate Width2 x Maximum Head x 9810 x W )/8/S2'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(seatingHeadCompressiveStress_5).toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable compressive stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.compressiveStressCalc().toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${checkForNull(seatingHeadCompressiveStress_5) > this.compressiveStressCalc() ? 'error' : ''} `}>{checkForNull(seatingHeadCompressiveStress_5) > this.compressiveStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'UNSEATING HEAD TENSILE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Gate Width2 x Maximum Head x 9810 x W )/8/S2'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(unseatingHeadCompressiveStress_5).toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Tensile Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.tensileStressCalc().toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${checkForNull(unseatingHeadCompressiveStress_5) > this.tensileStressCalc() ? 'error' : ''} `}>{checkForNull(unseatingHeadCompressiveStress_5) > this.tensileStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'UNSEATING HEAD COMPRESSIVE STRESS'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Compressive Stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Gate Width2 x Maximum Head x 9810 x W )/8/S1'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable Tensile Stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{`${checkForNull(unseatingHeadTensileStress_5).toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable compressive stress'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${this.compressiveStressCalc().toFixed(0)} Mpa`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p className={`${checkForNull(unseatingHeadTensileStress_5) > this.compressiveStressCalc() ? 'error' : ''} `}>{checkForNull(unseatingHeadTensileStress_5) > this.compressiveStressCalc() ? 'STRESS TOO HIGH' : ''}</p>
                                                        </Col>
                                                    </Row>

                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <b><p>{'BEAM DEFLECTION AT MAXIMUM HEAD'}</p></b>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Deflection'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'(Head on lowest rib x 9810 x beam width x5x width4 x 10^6/(384xExI)'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable compressive stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(beamDeflectionMaxHead_5).toFixed(4)} mm`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            <p>{'Allowable Deflection'}</p>
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="5">
                                                            <p>{'Lesser value of span / 720 and 1.6 mm'}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="5">
                                                            {/* <p>{'Allowable compressive stress'}</p> */}
                                                        </Col>
                                                        <Col md="2" className='text-right'>
                                                            <p>{`=`}</p>
                                                        </Col>
                                                        <Col md="2">
                                                            <p>{`${checkForNull(actualDefLesser_5).toFixed(2)} mm`}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row className={'mb-3'}>
                                                        <Col md="12">
                                                            <p className={`${checkForNull(beamDeflectionMaxHead_5) > checkForNull(actualDefLesser_5) ? 'error' : ''} `}>{checkForNull(beamDeflectionMaxHead_5) > checkForNull(actualDefLesser_5) ? 'DEFLECTION TOO HIGH' : 'The actual deflection is less than the permissible deflection, Hence the design is safe.'}</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>


                                </div>
                            }

                        </form>
                    </div>
                </Container>
            </div >
        );
    }
}

/**
* @method mapStateToProps
* @description return state to component as props
* @param {*} state
    */
function mapStateToProps(state) {
    const { auth } = state;
    const fieldObj = selector(state, 'hs1', 'hs2', 'hs3', 'hs4', 'hs5', 'hs6', 'hs7', 'hs8', 'hs9', 'hs10', 'hs11',
        'hs12', 'hs13', 'hs14', 'hs15', 'stemDiaField', 'manufacturingMaterial', 'factorOfSafetyDD', 'FOS3'
        , 'selectHorizontalRib', 'horizontalStiffenersSection', 'hs12', 'hs13', 'FOSValue'
        , 'hs14', 'hs15', 'horizontalStiffenersSection5', 'FOSValueStan'
    );

    const { technologyList, loading } = auth;
    return { technologyList, loading, fieldObj }
}

/**
* @method connect
* @description connect with redux
* @param {function} mapStateToProps
* @param {function} mapDispatchToProps
*/
export default connect(mapStateToProps, {
    createShutterDesign,
    getShutterDesignData,
    updateShutterDesign,
})(reduxForm({
    form: 'CIShutterDesign',
    onSubmitFail: errors => {
        focusOnError(errors);
    },
    enableReinitialize: true,
})(CIShutterDesign));
